import { defineMessages } from 'react-intl';

const messages = defineMessages({
	qrTitleLowCam: {
		id: 'fe.qr_title_bad_camera',
		defaultMessage: 'Your camera resolution is too low for the picture to be accepted'
	},
	qrTitleNoCam: {
		id: 'fe.qr_title_no_camera',
		defaultMessage: 'We need camera access to complete the KYC process'
	},
	takePhoto: {
		id: 'fe.take_photo',
		defaultMessage: 'Take photo'
	},
	retakePhoto: {
		id: 'fe.retake_photo',
		defaultMessage: 'Retake photo'
	},
	confirm: {
		id: 'fe.confirm',
		defaultMessage: 'Confirm'
	},
	positionFrontDocument: {
		id: 'fe.position_front_document',
		defaultMessage: 'Position the front of your document in the frame'
	},
	positionBackDocument: {
		id: 'fe.position_back_document',
		defaultMessage: 'Position the back of your document in the frame'
	},
	positionFace: {
		id: 'fe.position_your_face',
		defaultMessage: 'Position your face inside the frame and take a selfie'
	},
	idFrontTitle: {
		id: 'fe.id_front_title',
		defaultMessage: 'Take a photo of your ID card’s front'
	},
	idFrontDescription: {
		id: 'fe.id_front_description',
		defaultMessage:
			'Make sure that the whole front of the card is clearly visible inside the frame.'
	},
	idBackTitle: {
		id: 'fe.id_back_title',
		defaultMessage: 'Take a photo of your ID card’s back'
	},
	idBackDescription: {
		id: 'fe.id_back_description',
		defaultMessage:
			'Make sure that the whole back of the card is clearly visible inside the frame.'
	},
	residencePermitFrontTitle: {
		id: 'fe.residence_permit_front_title',
		defaultMessage: 'Take a photo of your residence permit’s front'
	},
	residencePermitFrontDescription: {
		id: 'fe.residence_permit_front_description',
		defaultMessage:
			'Make sure that the whole front of the residence permit is clearly visible inside the frame.'
	},
	residencePermitBackTitle: {
		id: 'fe.residence_permit_back_title',
		defaultMessage: 'Take a photo of your residence permit’s back'
	},
	residencePermitBackDescription: {
		id: 'fe.residence_permit_back_description',
		defaultMessage:
			'Make sure that the whole back of the residence permit is clearly visible inside the frame.'
	},
	driversLicenceFrontTitle: {
		id: 'fe.drivers_licence_front_title',
		defaultMessage: "Take a photo of your driver's licence front"
	},
	driversLicenceFrontDescription: {
		id: 'fe.drivers_licence_front_description',
		defaultMessage:
			"Make sure that the whole front of the driver's licence is clearly visible inside the frame."
	},
	driversLicenceBackTitle: {
		id: 'fe.drivers_licence_back_title',
		defaultMessage: "Take a photo of your driver's licence back"
	},
	driversLicenceBackDescription: {
		id: 'fe.drivers_licence_back_description',
		defaultMessage:
			"Make sure that the whole back of the driver's licence is clearly visible inside the frame."
	},
	passportCoverTitle: {
		id: 'fe.passport_cover_title',
		defaultMessage: 'Take a photo of your passport cover'
	},
	passportCoverDescription: {
		id: 'fe.passport_cover_description',
		defaultMessage: 'Make sure that the passport cover clearly visible inside the frame.'
	},
	passportPageTitle: {
		id: 'fe.passport_page_title',
		defaultMessage: 'Take a photo of your passport’s page with your photo'
	},
	passportPageDescription: {
		id: 'fe.passport_page_description',
		defaultMessage:
			'Make sure that the page with your photo is clearly visible inside the frame.'
	},
	confirmTitle: {
		id: 'fe.confirm_title',
		defaultMessage: 'Does your photo look like the sample?'
	},
	confirmDescription: {
		id: 'fe.confirm_description',
		defaultMessage: 'Make sure that the document is well focused.'
	},
	selfieTitle: {
		id: 'fe.selfie_title',
		defaultMessage: 'Take a selfie holding the document'
	},
	selfieDescription: {
		id: 'fe.selfie_description',
		defaultMessage:
			'Make sure your face is aligned in the frame and if you wear glasses or head covers of any sorts, please remove them.'
	},
	selfieConfirmDescription: {
		id: 'fe.selfie_confirm_description',
		defaultMessage: 'Make sure that the photo is focused and in good light.'
	},
	brightnessBrightTitle: {
		id: 'fe.brightness_bright_title',
		defaultMessage: 'Your image is too bright'
	},
	brightnessDarkTitle: {
		id: 'fe.brightness_dark_title',
		defaultMessage: 'Your image is too dark'
	},
	brightnessBrightDescription: {
		id: 'fe.brightness_bright_description',
		defaultMessage: 'The picture is too bright, please adjust the surrounding light.'
	},
	brightnessDarkDescription: {
		id: 'fe.brightness_dark_description',
		defaultMessage: 'The picture is too dark, please adjust the surrounding light.'
	},
	tooBlurryTitle: {
		id: 'fe.too_blurry_title',
		defaultMessage: 'Your image is too blurry'
	},
	tooBlurryMessage: {
		id: 'fe.too_blurry_message',
		defaultMessage:
			'It looks as if this picture is too blurry. To continue your KYC process you need to retake it.'
	},
	fileTooSmall: {
		id: 'fe.document_too_small_upload_new_one',
		defaultMessage: 'Empty file has been uploaded, please <button>upload a new one</button>'
	},
	fileTooBig: {
		id: 'fe.document_size_exceeds_x_upload_new_one',
		defaultMessage:
			'Maximum file size of {fileSize} exceeded, please <button>upload a new one</button>'
	},
	fileFormatIncorrect: {
		id: 'fe.incorrect_format',
		defaultMessage: 'Required document is in incorrect format <button>upload a new one</button>'
	},
	fileIsTooSmall: {
		id: 'fe.document_too_small',
		defaultMessage: 'Empty file has been uploaded'
	},
	fileIsTooBig: {
		id: 'fe.document_size_exceeds_x',
		defaultMessage: 'Maximum file size of {fileSize} exceeded'
	},
	fileFormatIsIncorrect: {
		id: 'fe.incorrect_file_format',
		defaultMessage: 'Required document is in incorrect format'
	},
	fileTypeSizeIsTooBig: {
		id: 'fe.file_type_size_too_big',
		defaultMessage: 'All files for single type must not exceed {fileSize}'
	},
	pleaseTryAgain: {
		id: 'fe.please_try_again',
		defaultMessage: 'please try again'
	},
	uploadDifferent: {
		id: 'fe.upload_a_different',
		defaultMessage: 'upload a different one'
	},
	wasNotUploaded: {
		id: 'fe.was_not_uploaded',
		defaultMessage: 'was not uploaded'
	},
	supportingDocumentsTitle: {
		id: 'fe.upload_documents',
		defaultMessage: 'Upload documents'
	},
	documentUploadDescription: {
		id: 'fe.document_upload_description',
		defaultMessage:
			'Please upload the following documents needed to verify the information provided in your KYC questionnaire.'
	},
	warning: {
		id: 'fe.document_upload_warning',
		defaultMessage:
			'* Please note that documents are accepted in English or Lithuanian. Documents submitted in original languages may be accepted if provided in their original digital format. In other cases, an officially certified English translation (certified as a true copy of the original or legalized with an apostille) may be required.'
	},
	acceptableFormats: {
		id: 'fe.acceptable_formats',
		defaultMessage: '* Supported document formats: PDF, JPG, JPEG and PNG'
	},
	addNew: {
		id: 'fe.add_new_file',
		defaultMessage: 'Upload new file'
	},
	dragAndDrop: {
		id: 'fe.click_to_upload_or_drag_and_drop_files_here',
		defaultMessage: '<a>Click to upload</a> or drag and drop file(s) here'
	},
	iHaveNoRequestedDocuments: {
		id: 'fe.i_have_no_requested_documents',
		defaultMessage: 'I have no requested documents'
	},
	specifyReasonWhyDocumentCannotBeUploaded: {
		id: 'fe.specify_reason_why_document_cannot_be_uploaded',
		defaultMessage: 'Specify the reason why document cannot be uploaded'
	},
	noFileAdded: {
		id: 'fe.no_file_added',
		defaultMessage: 'No file added'
	},
	next: {
		id: 'fe.next',
		defaultMessage: 'Next'
	},
	previous: {
		id: 'fe.previous',
		defaultMessage: 'Back to previous page'
	},
	uploadedSuccessfully: {
		id: 'fe.uploaded_successfully',
		defaultMessage: ' Uploaded successfully'
	},
	scanCode: {
		id: 'fe.scan_code',
		defaultMessage: 'Scan code'
	},
	continueYourVerificationSession: {
		id: 'fe.continue_your_verification_session',
		defaultMessage: 'Continue your verification session'
	},
	continueSessionHereWithCamera: {
		id: 'fe.text_with_camera',
		defaultMessage:
			'If you have started a KYC session in another device and you need to change to a new one you can continue your session here. Your progress has been saved and you will only have to complete the steps you haven’t done yet. You have two options to proceed.'
	},
	continueSessionHere: {
		id: 'fe.text',
		defaultMessage:
			'If you have started a KYC session in another device and you need to change to a new one you can continue your session here. Your progress has been saved and you will only have to complete the steps you haven’t done yet.'
	},
	optionPinTitle: {
		id: 'fe.option_pin_title',
		defaultMessage: 'Enter your 8 character pin'
	},
	optionPinText: {
		id: 'fe.option_pin_text',
		defaultMessage: 'Enter the pin displayed in your current verification session'
	},
	or: {
		id: 'fe.or',
		defaultMessage: 'or'
	},
	scanQRCode: {
		id: 'fe.option_qr_title',
		defaultMessage: 'Scan the QR code'
	},
	scanQRCodeToDownload: {
		id: 'fe.scan_qr_to_download',
		defaultMessage: 'Scan the QR code to download {appName} app and continue your verification'
	},
	downloadAppToContinue: {
		id: 'fe.download_to_continue',
		defaultMessage: 'Download {appName} app and continue your verification'
	},
	scanDisplayedQRCode: {
		id: 'fe.option_qr_text',
		defaultMessage: 'Scan the QR code displayed in your current verification session'
	},
	continueOnOurApp: {
		id: 'fe.downloadAppHeader',
		defaultMessage: 'Continue on our AutoKYC app'
	},
	youCanFinishKYCInApp: {
		id: 'fe.downloadAppText',
		defaultMessage: 'You can also finish your KYC session in our AutoKYC app'
	},
	done: {
		id: 'fe.done',
		defaultMessage: 'Done'
	},
	thereWasAnIssue: {
		id: 'fe.there_was_an_issue',
		defaultMessage: 'There was an issue completing your KYC process.'
	},
	yourVerificationSessionKeyIsUnderReview: {
		id: 'fe.your_verification_sessionKey_is_under_review',
		defaultMessage: 'Your verification is under review.'
	},
	reasonOnly: {
		id: 'fe.reason_only',
		defaultMessage: '{failureReason}'
	},
	issueWithReason: {
		id: 'fe.there_was_an_issue_reason',
		defaultMessage: 'Error code for this issue is: {failureReason}.'
	},
	pressDoneToGoBackToX: {
		id: 'fe.press_done',
		defaultMessage: 'Press Done to go back to {companyName} where you can try again.'
	},
	continueInApp: {
		id: 'fe.continue_in_app',
		defaultMessage: 'continue in app'
	},
	introParagraph1: {
		id: 'fe.intro_paragraph_1',
		defaultMessage:
			'Know-your-customer (KYC) is a process by which financial institutions and other obliged entities identify and verify the identity of a client before a business relationship is established, and on an ongoing basis.'
	},
	introParagraphCryptoForest1: {
		id: 'fe.intro_crypto_forest_1',
		defaultMessage: `In accordance with the laws of the Republic of Lithuania regarding the prevention of money laundering and counter
		terrorist financing, the Company’s UAB Crypto Forest Policy on prevention of money laundering and terrorist
		financing, we must obtain information about the customer before starting or continuing a business relationship with
		the customer.`
	},
	introParagraphCryptoForest2: {
		id: 'fe.intro_crypto_forest_2',
		defaultMessage: `The information provided by the customer is considered confidential and will be protected.`
	},
	introParagraph2: {
		id: 'fe.intro_paragraph_2',
		defaultMessage:
			'To perform this procedure, you will need a valid identification document such as an international passport, identity card or residence permit. You will be asked to fill out a brief questionnaire, take photos of your identity document, and take your selfie.'
	},
	introParagraph2NoResidencePermit: {
		id: 'fe.intro_paragraph_2_no_residence_permit',
		defaultMessage:
			'To perform this procedure, you will need a valid identification document such as an international passport or identity card. You will be asked to fill out a brief questionnaire, take photos of your identity document, and take your selfie.'
	},
	loadingTitle: {
		id: 'fe.loading_title',
		defaultMessage: 'Your documents are being processed'
	},
	loadingText: {
		id: 'fe.loading_text',
		defaultMessage: 'Please do not leave this page while we upload and process your documents'
	},
	permissionsBiometricPervesk: {
		id: 'fe.permissions_biometric_pervesk',
		defaultMessage: `By marking this checkbox I agree to my biometric information, i.e. my face image, obtained during the verification procedure, being processed by Pervesk for the Know Your Customer (“KYC”) purposes.\n\nIn case you disagree and leave this box unmarked, unfortunately, we will not be able to offer you the services you are applying for.`
	},
	permissionsBiometric: {
		id: 'fe.permissions_biometric',
		defaultMessage: `By marking this checkbox I agree to my biometric information, i.e. my face image, obtained during the verification procedure, being processed by {companyTitle} for the Know Your Customer (“KYC”) purposes.\n\nIn case you disagree and leave this box unmarked, unfortunately, we will not be able to offer you the services you are applying for.\n\nTo know more about processing of your biometric information and other personal data, please refer to {companyTitle} Privacy Policy.`
	},
	iAgreeToPrivacyPolicyAgreement: {
		id: 'fe.privacy_policy_agreement',
		defaultMessage:
			'I have read and agree to the {PrivacyPolicy} regarding the processing of my personal data.'
	},
	privacyPolicy: {
		id: 'fe.privacy_policy',
		defaultMessage: 'Privacy Policy'
	},
	generalTermsAndConditions: {
		id: 'fe.general_terms_and_conditions',
		defaultMessage: 'General Terms and Conditions'
	},
	permissionsSingleBiometric: {
		id: 'fe.permissions_single_biometric',
		defaultMessage: `By marking this checkbox, I agree to my biometric information, i.e. my face image obtained during the verification procedure, being processed {getCompanyTitle} for the Know Your Client (KYC) purpose.`
	},
	permissionsDisagreement: {
		id: 'fe.permissions_disagreement',
		defaultMessage: `If you disagree and leave the box unmarked, unfortunately, we will not be able to offer you the services you are applying for.`
	},
	singlePermissionPolicy: {
		id: 'fe.single_permission_policy',
		defaultMessage: `To know more about the processing of your biometric information and other personal data, please refer to {companyTitle} {privacyPolicyLink}`
	},
	singlePermissionPolicyWithTC: {
		id: 'fe.single_permission_policy_with_TC',
		defaultMessage: `To know more about the processing of your biometric information and other personal data, please refer to {companyTitle}, {privacyPolicyLink} and {termsAndConditionsLink}.`
	},
	privacyPolicyLink: {
		id: 'fe.privacy_policy_link',
		defaultMessage: `<a>{privacyPolicy}</a>`
	},
	termsAndConditionsLink: {
		id: 'fe.terms_and_conditions_link',
		defaultMessage: `<a>{termsAndConditions}</a>`
	},
	continue: {
		id: 'fe.continue',
		defaultMessage: 'Continue'
	},
	continueOnApp: {
		id: 'fe.continue_on_app',
		defaultMessage: 'Continue on {appName} App'
	},
	continueOnDifferentDevice: {
		id: 'fe.continue_on_different_device',
		defaultMessage: 'Continue on a different device'
	},
	recommendContinueInAppText: {
		id: 'fe.recommend_continue_in_app_text',
		defaultMessage: 'We highly recommend you to continue the procedure via {appName} app.'
	},
	continueOnThisDevice: {
		id: 'fe.continue_on_this_device',
		defaultMessage: 'Continue on this device'
	},
	toDownloadItClickButtonBelow: {
		id: 'fe.to_download_it_click_button_below',
		defaultMessage: 'To download it, click the button below.'
	},
	enterYourSessionKey: {
		id: 'fe.enter_your_session_key',
		defaultMessage: 'Enter your session key'
	},
	qrContinueOnApp: {
		id: 'fe.qr_continue_on_app',
		defaultMessage: 'Continue on {appName} app'
	},
	qrContinueOnDifferentDevice: {
		id: 'fe.qr_continue_on_different_device',
		defaultMessage: 'Continue verification on a different device'
	},
	qrDownloadApp: {
		id: 'fe.qr_download_app',
		defaultMessage:
			'Download {appName} app to continue verification and start using {appName} services!'
	},
	qrScanCode: {
		id: 'fe.qr_scan_code',
		defaultMessage: 'Scan QR code to continue verification'
	},
	qrText: {
		id: 'fe.qr_text',
		defaultMessage:
			'According to the regulatory requirements, identity can be remotely verified by electronic means via a live photo or video transmission and, therefore, we need live camera access.'
	},
	qrContinueInAppText: {
		id: 'fe.qr_continue_in_app_text',
		defaultMessage: 'We highly recommend to continue the process via <b>{appName}</b> app!'
	},
	qrBottomText: {
		id: 'fe.qr_bottom_text',
		defaultMessage:
			'You may also continue the procedure by scanning the QR code or entering your PIN manually with another device.'
	},
	qrOpenModalButtonText: {
		id: 'fe.continue_on_another_device',
		defaultMessage: 'Continue on another device'
	},
	qrModalTitle: {
		id: 'fe.scan_qr_code',
		defaultMessage: 'Scan QR code'
	},
	qrModalBody: {
		id: 'fe.qr_modal_body_text',
		defaultMessage: 'Or go to <a>{url}</a> and enter the PIN manually'
	},
	close: {
		id: 'fe.close',
		defaultMessage: 'Close'
	},
	copied: {
		id: 'fe.copied',
		defaultMessage: 'Copied'
	},
	qrUseThisDeviceTitle: {
		id: 'fe.qr_use_this_device_title',
		defaultMessage:
			'A. Use this device to complete the first part (KYC questionnaire) and use another device for the second part (remote identification).'
	},
	qrUseThisDeviceText: {
		id: 'fe.qr_use_this_device_text',
		defaultMessage:
			'We will prompt you to change devices between steps. Your progress will be saved.'
	},
	qrChangeDeviceTitle: {
		id: 'fe.change_device_title',
		defaultMessage: 'B. Change to a different device now.'
	},
	downloadApp: {
		id: 'fe.download_app',
		defaultMessage: 'Download app'
	},
	goTo: {
		id: 'fe.go_to',
		defaultMessage: 'Go to'
	},
	enter8CharPin: {
		id: 'fe.enter_character_pin',
		defaultMessage: 'enter 8 character pin'
	},
	downloadAppHeader: {
		id: 'fe.downloadAppHeader',
		defaultMessage: 'Continue on our AutoKYC app'
	},
	downloadAppText: {
		id: 'fe.downloadAppText',
		defaultMessage: 'You can also finish your KYC session in our AutoKYC app'
	},
	makeSureCodeIsCentered: {
		id: 'fe.qr_reader_text',
		defaultMessage: 'Make sure the code is centred on the square.'
	},
	kycProcessCompleted: {
		id: 'fe.success_text_short',
		defaultMessage: 'KYC process was completed!'
	},
	kycProcessCompletedCompany: {
		id: 'fe.success_text',
		defaultMessage:
			'KYC process was completed! Press Done to go back to {companyName} where you will be notified of the result'
	},
	kycProcessCompletedMobile: {
		id: 'fe.success_text_mobile',
		defaultMessage:
			'Verification is now going to be processed. You will find it’s results on your providers web or application. You can close this app now.'
	},
	weNeedCameraAccess: {
		id: 'fe.unavailable_title',
		defaultMessage: 'We need camera access...'
	},
	unavailableText: {
		id: 'fe.unavailable_text',
		defaultMessage:
			'Regulatory requirements state that KYC procedure has to be performed via a live session and therefore we need live camera access. In order to ensure strict compliance with regulations, we kindly ask you to use our app to complete your KYC process.'
	},
	pleaseSelectAllCountriesWhereYouAreTaxResident: {
		id: 'fe.please_select_all_countries_where_you_are_tax_resident',
		defaultMessage: 'Please select all countries where you are a tax resident'
	},
	selectAllCountries: {
		id: 'fe.select_all_countries',
		defaultMessage: 'Select all countries'
	},
	selectCountry: {
		id: 'fe.select_country',
		defaultMessage: 'Select country'
	},
	chooseCountry: {
		id: 'fe.choose_country',
		defaultMessage: 'Choose country'
	},
	invalidDate: {
		id: 'fe.invalid_date',
		defaultMessage: 'Invalid date'
	},
	minimumAge: {
		id: 'fe.minimum_age',
		defaultMessage: 'Minimum age to verify your account is {minVerifiedAge}'
	},
	maximumAge: {
		id: 'fe.maximum_age',
		defaultMessage: 'Maximum age to verify your account is {maxVerifiedAge}'
	},
	turnover1000: {
		id: 'fe.turnover_1000',
		defaultMessage: '1 000 - 5 000'
	},
	turnover5000: {
		id: 'fe.turnover_5000',
		defaultMessage: '5 000 - 15 000'
	},
	turnover15000: {
		id: 'fe.turnover_15000',
		defaultMessage: '15 000 - 50 000'
	},
	turnoverLessThan1000: {
		id: 'fe.turnover_0',
		defaultMessage: '< 1 000'
	},
	turnoverLessThan5000: {
		id: 'fe.turnover_business_0',
		defaultMessage: '< 5 000'
	},
	turnover100000: {
		id: 'fe.turnover_business_100000',
		defaultMessage: '50 000 - 100 000'
	},
	turnover300000: {
		id: 'fe.turnover_business_300000',
		defaultMessage: '100 000 - 300 000'
	},
	turnoverMoreThan15000: {
		id: 'fe.turnover_more_than_15000',
		defaultMessage: '> 15 000'
	},
	turnoverMoreThan300000: {
		id: 'fe.turnover_business_more_than_300000',
		defaultMessage: '> 300 000'
	},
	selectAllCountriesThatApply: {
		id: 'fe.select_all_countries_that_apply',
		defaultMessage: 'Select all countries that apply'
	},
	transactions10: {
		id: 'fe.transactions_10',
		defaultMessage: '10 - 30'
	},
	transactions10to29: {
		id: 'fe.transactions_10_29',
		defaultMessage: '10 - 29'
	},
	transactions30: {
		id: 'fe.transactions_30',
		defaultMessage: '30 - 60'
	},
	transactionsLessThan10: {
		id: 'fe.transactions_less_than_10',
		defaultMessage: '< 10'
	},
	transactionsMoreThan60: {
		id: 'fe.transactions_more_than_60',
		defaultMessage: '> 60'
	},
	invalidInputValue: {
		id: 'fe.invalid_input_value',
		defaultMessage: 'Please enter the upper boundary in numbers only'
	},
	tinyInputValue: {
		id: 'fe.tiny_input_value',
		defaultMessage:
			'Entered amount falls within the intervals defined above. Please select a relevant interval'
	},
	selectRelevantSector: {
		id: 'fe.select_most_relevant_sector',
		defaultMessage: 'Select the most relevant sector'
	},
	selectMultiSectors: {
		id: 'fe.select_relevant_sector',
		defaultMessage: 'Select relevant sectors'
	},
	cashTurnoverOption1Business: {
		id: 'fe.turnover_in_cash_1',
		defaultMessage: '1-10% (little of my turnover is in cash)'
	},
	cashTurnoverOption1: {
		id: 'fe.turnover_in_cash_0',
		defaultMessage: '0-10% (none or little of my turnover is in cash)'
	},
	cashTurnoverOption2: {
		id: 'fe.turnover_in_cash_10',
		defaultMessage: '10-30% (some of my turnover is in cash)'
	},
	cashTurnoverOption3: {
		id: 'fe.turnover_in_cash_30',
		defaultMessage: '30-60% (a big part of my turnover is in cash)'
	},
	cashTurnoverOption4: {
		id: 'fe.turnover_in_cash_60',
		defaultMessage: '60-90% (most of my turnover is in cash)'
	},
	cashTurnoverOption5: {
		id: 'fe.turnover_in_cash_90',
		defaultMessage: '90% or more (all or almost all of my turnover is in cash)'
	},
	cashTurnoverOption0: {
		id: 'fe.turnover_in_cash_none',
		defaultMessage: '0 (none of my turnover is in cash)'
	},
	cashTurnoverOption11: {
		id: 'fe.turnover_in_cash_up_to_10',
		defaultMessage: 'Up to 10% (little of my turnover is in cash)'
	},
	cashTurnoverOption12: {
		id: 'fe.turnover_in_cash_10_29',
		defaultMessage: '10-29% (some of my turnover is in cash)'
	},
	cashTurnoverOption13: {
		id: 'fe.turnover_in_cash_30_59',
		defaultMessage: '30-59% (a big part of my turnover is in cash)'
	},
	cashTurnoverOption14: {
		id: 'fe.turnover_in_cash_60_89',
		defaultMessage: '60-89% (most of my turnover is in cash)'
	},
	addAnotherCountry: {
		id: 'fe.addAnotherCountry',
		defaultMessage: '+ Add another country'
	},
	removeLastCountry: {
		id: 'fe.removeLastCountry',
		defaultMessage: '- Remove last country'
	},
	addPosition: {
		id: 'fe.add_position',
		defaultMessage: '+ Add position'
	},
	removeLastPosition: {
		id: 'fe.remove_last_position',
		defaultMessage: '- Remove last position'
	},
	addCompany: {
		id: 'fe.add_company',
		defaultMessage: '+ Add company'
	},
	addSector: {
		id: 'fe.add_sector',
		defaultMessage: '+ Add sector'
	},
	removeLastSector: {
		id: 'fe.remove_last_sector',
		defaultMessage: '- Remove last sector'
	},
	selectAllSourcesOfIncome: {
		id: 'fe.select_all_sources_of_income',
		defaultMessage: 'Select all sources of income'
	},
	whichOptionsDescribesEmploymentStatus: {
		id: 'fe.which_options_best_describes_your_employment_status',
		defaultMessage: 'Which option(s) best describes your employment status?'
	},
	whatIsTheSourceOfFunds: {
		id: 'fe.what_is_the_source_of_funds',
		defaultMessage: 'What is the source of funds which will come to the account?'
	},
	howDoYouPlanToUseTheAccount: {
		id: 'fe.how_do_you_plan_to_use_the_account',
		defaultMessage: 'How do you plan to use the account? '
	},
	bwIntroTitle: {
		id: 'fe.title',
		defaultMessage: 'Identity verification'
	},
	introParagraph1WithCompanyName: {
		id: 'fe.paragraph_1_with_company_name',
		defaultMessage:
			'In order for {companyName} to provide financial services to you, we need to verify your identity. The information you provide will be used to setup your account, fraud prevention and to comply with legal requirements.'
	},
	finraxIntroParagraph1: {
		id: 'fe.FBparagraph_1',
		defaultMessage:
			'In order for Finrax to provide financial services to you, we need to verify your identity. The information you provide will be used to setup your account, fraud prevention and to comply with legal requirements.'
	},
	phoenixIntroParagraph1: {
		id: 'fe.phoenix_paragraph_1',
		defaultMessage:
			'In order for Phoenix to provide financial services to you, we need to verify your identity. The information you provide will be used to setup your account, fraud prevention and to comply with legal requirements.'
	},
	neoCardIntroParagraph1: {
		id: 'fe.neoCard_paragraph_1',
		defaultMessage:
			'In order for NEOCARD to provide financial services to you, we need to verify your identity. The information you provide will be used to setup your account, fraud prevention and to comply with legal requirements.'
	},
	bwIntroParagraph1: {
		id: 'fe.BWparagraph_1',
		defaultMessage:
			'In order for Bankera to provide financial services to you, we need to verify your identity. The information you provide will be used to setup your account, fraud prevention and to comply with legal requirements.'
	},
	bwIntroParagraph2: {
		id: 'fe.BWparagraph_2',
		defaultMessage:
			'To perform this procedure you will need a valid international passport or identity card. You will be asked to take pictures of your identity document and your selfie. You will also be asked to fill out a brief questionnaire.'
	},
	bwIntroStep1Title: {
		id: 'fe.step1Title',
		defaultMessage: 'Step 1'
	},
	bwIntroStep2Text: {
		id: 'fe.BWstep1Description',
		defaultMessage: 'Submit a copy of your identity document'
	},
	bwIntroStep2Title: {
		id: 'fe.step2Title',
		defaultMessage: 'Step 2'
	},
	bwIntroStep3Text: {
		id: 'fe.BWstep2Description',
		defaultMessage: 'Take a selfie'
	},
	bwIntroStep3Title: {
		id: 'fe.step3Title',
		defaultMessage: 'Step 3'
	},
	bwIntroStep1Text: {
		id: 'fe.BWstep3Description',
		defaultMessage: 'Answer a few short questions'
	},
	introTitleOtherTiers: {
		id: 'fe.title_other_tiers',
		defaultMessage: 'Customer questionnaire'
	},
	introParagraphOtherTiers: {
		id: 'fe.BWparagraph_other_tiers',
		defaultMessage:
			'In order for Bankera to comply with legal requirements, we ask you to fill out a brief questionnaire. The information you provide will be used to update your account, fraud prevention and to increase your annual account limits.'
	},
	introParagraphOtherTiersWithCompanyName: {
		id: 'fe.BWparagraph_other_tiers_with_company_name',
		defaultMessage:
			'In order for {companyName} to comply with legal requirements, we ask you to fill out a brief questionnaire. The information you provide will be used to update your account, fraud prevention and to increase your annual account limits.'
	},
	kvixIntroParagraphOtherTiers: {
		id: 'fe.kvix_paragraph_other_tiers',
		defaultMessage:
			'In order for Kvix to comply with legal requirements, we ask you to fill out a brief questionnaire. The information you provide will be used to update your account, fraud prevention and to increase your annual account limits.'
	},
	phoenixIntroParagraphOtherTiers: {
		id: 'fe.phoenix_paragraph_other_tiers',
		defaultMessage:
			'In order for Phoenix to comply with legal requirements, we ask you to fill out a brief questionnaire. The information you provide will be used to update your account, fraud prevention and to increase your annual account limits.'
	},
	neoCardIntroParagraphOtherTiers: {
		id: 'fe.neoCard_paragraph_other_tiers',
		defaultMessage:
			'In order for NEOCARD to comply with legal requirements, we ask you to fill out a brief questionnaire. The information you provide will be used to update your account, fraud prevention and to increase your annual account limits.'
	},
	backToPreviousPage: {
		id: 'fe.back_to_previous_page',
		defaultMessage: 'back to previous page'
	},
	back: {
		id: 'fe.back',
		defaultMessage: 'back'
	},
	addAnotherPEP: {
		id: 'fe.add_another_pep',
		defaultMessage: '+ Add another PEP'
	},
	removeLastPEP: {
		id: 'fe.remove_last_pep',
		defaultMessage: '- Remove last PEP'
	},
	pepTooltip: {
		id: 'fe.pep_tooltip',
		defaultMessage: `A natural person who is or who has been entrusted with prominent public functions and his/her immediate family members or close associates of such person.

Immediate family members – the spouse, the person with whom partnership has been registered, parents, brothers, sisters, children, children’s spouses and children’s registered partners

Close associate:
- a natural person who participates in the same legal person or an organization not having legal personality, or maintains any other business relationship, with the person who is a PEP;
- a natural person who has sole beneficial ownership of the legal person or an organization not having legal personality which has been set up or is operating for the de facto financial or any other private benefit of the person who is a PEP.`
	},
	addAnotherCitizenship: {
		id: 'fe.add_another_citizenship',
		defaultMessage: '+ Add another citizenship'
	},
	addAnotherUBO: {
		id: 'fe.add_another_ubo',
		defaultMessage: '+ Add another ultimate beneficial owner'
	},
	removeUBO: {
		id: 'fe.remove_last_ubo',
		defaultMessage: '- Remove last ultimate beneficial owner'
	},
	addAnotherUSPerson: {
		id: 'fe.add_another_us_person',
		defaultMessage: '+ Add another US person'
	},
	removeUSPerson: {
		id: 'fe.remove_last_us_person',
		defaultMessage: '- Remove last US person'
	},
	invalidFullName: {
		id: 'fe.this_person_is_already_provided_as_UBO',
		defaultMessage: 'This person has already been provided as ultimate beneficial owner'
	},
	invalidTin: {
		id: 'fe.invalid_tin',
		defaultMessage: 'TIN is invalid. Please provide the valid TIN.'
	},
	invalidPersonalCode: {
		id: 'fe.invalid_personal_code',
		defaultMessage: 'Personal code is invalid. Please provide the valid personal code.'
	},
	invalidEmail: {
		id: 'fe.invalid_email',
		defaultMessage: 'Invalid email'
	},
	invalidPhoneNumber: {
		id: 'fe.invalid_phone_number',
		defaultMessage: 'Invalid phone number'
	},
	assetsOption1: {
		id: 'fe.less_than_million',
		defaultMessage: 'Less than 1,000,000'
	},
	assetsOption2: {
		id: 'fe.million_ten_million',
		defaultMessage: '1,000,000 - 10,000,000'
	},
	assetsOption3: {
		id: 'fe.ten_million_twenty_million',
		defaultMessage: '10,000,000 - 20,000,000'
	},
	assetsOption4: {
		id: 'fe.above_twenty_million',
		defaultMessage: 'Above 20,000,000'
	},
	addAnotherDirector: {
		id: 'fe.add_another_director',
		defaultMessage: '+ Add another director'
	},
	removeDirector: {
		id: 'fe.remove_last_director',
		defaultMessage: '- Remove last director'
	},
	addAnotherCMS: {
		id: 'fe.add_another_cms',
		defaultMessage: '+ Add another shareholder/participant'
	},
	removeLastCMS: {
		id: 'fe.remove_shareholder',
		defaultMessage: '- Remove last shareholder/participant'
	},
	lessThan10000: {
		id: 'fe.less_than_ten_k',
		defaultMessage: 'Less than 10,000'
	},
	tenKToFiftyK: {
		id: 'fe.ten_k_fifty_k',
		defaultMessage: '10,000 - 50,000'
	},
	fiftyKToHundredK: {
		id: 'fe.fifty_k_hundred_k',
		defaultMessage: '50,000 - 100,000'
	},
	aboveHundredK: {
		id: 'fe.above_hundred_k',
		defaultMessage: 'Above 100,000'
	},
	cryptoForestConfirmation1: {
		id: 'fe.crypto_forest_confirmation_1',
		defaultMessage: `I confirm that the information provided in the questionnaire is correct and that I have all the authority to complete,
		sign and submit this questionnaire. Directly, or on behalf of the customer if I act as a representative, I confirm and
		guarantee the obligation to immediately inform about the change of the data indicated in the questionnaire. I
		understand that the data (and supporting documents) indicated in the questionnaire may be transferred to third
		parties in accordance with the Law on the Prevention of Money Laundering and Counter Terrorist Financing of
		the Republic of Lithuania and legislation implementing it.`
	},
	cryptoForestConfirmation2: {
		id: 'fe.crypto_forest_confirmation_2',
		defaultMessage: `I understand that my personal data will be processed for the purposes of implementing the Law on the Prevention
		of Money Laundering and Counter Terrorist Financing of the Republic of Lithuania.`
	},
	blackridgeIntro1: {
		id: 'fe.intro1',
		defaultMessage:
			'In order for Blackridge Capital Management to provide financial services to you, we need to verify your identity. The information you provide will be used to setup your account, fraud prevention and to comply with legal requirements.'
	},
	blackridgeIntro2: {
		id: 'fe.intro2',
		defaultMessage:
			'To perform this procedure you will need a valid identity document You will be asked to take pictures of your identity document and your selfie. You will also be asked to fill out a brief questionnaire.'
	},
	identityVerification: {
		id: 'fe.identity_verification',
		defaultMessage: 'Identity verification'
	},
	paxfulIntroParagraph: {
		id: 'fe.intro_paragraph_paxful',
		defaultMessage:
			'To perform this procedure you will need a valid international passport or identity card. You will be asked to take pictures of your identity document and your selfie. You will also be asked to fill out a brief questionnaire.'
	},
	paxfulConfirmationText: {
		id: 'fe.paxful_confirmationText',
		defaultMessage: `
		I hereby certify that I am the ultimate benefial owner of the transaction.{linebreak}
		I hereby certify that the information provided in the customer questionnaire is complete and true.{linebreak}
		I am duly informed that I must notify you immediately in writing about any changes in the information provided, as well as provide additional information or documentation when requested by you.
		`
	},
	questionnaireInstructionText: {
		id: 'fe.questionnaire_instruction_text',
		defaultMessage: `Press next to start your photo verification. Make sure
		you have your identification document with you as it will be necessary
		to complete the process.`
	},
	addAnotherEmployment: {
		id: 'fe.addAnotherEmployment',
		defaultMessage: '+ Add another employment'
	},
	removeLastEmployment: {
		id: 'fe.removeLastEmployment',
		defaultMessage: '- Remove last employment'
	},
	addAnotherCompany: {
		id: 'fe.addAnotherCompany',
		defaultMessage: '+ Add another company'
	},
	removeLastCompany: {
		id: 'fe.removeLastCompany',
		defaultMessage: '- Remove last company'
	},
	agreeToCompanyPrivacyPolicy: {
		id: 'fe.agree_privacy_policy',
		defaultMessage: `I agree with {companyTitle} Privacy policy`
	},
	agreeToServiceAgreementWithCompany: {
		id: 'fe.agree_general_service_agreement',
		defaultMessage: `I agree with {companyTitle} General service agreement`
	},
	agreeToPaymentAccountAgreementWithCompany: {
		id: 'fe.agree_payment_account_agreement',
		defaultMessage: `I agree with {companyTitle} Electronic money and payment account agreement`
	},
	errorOccuredContactSupport: {
		id: 'fe.error_occured_please_contact_support',
		defaultMessage: 'Error occured, please contact support.'
	},
	disabledCountryDocument: {
		id: 'fe.disabled_country',
		defaultMessage:
			'Unfortunately, documents issued by {country} are not accepted for verification purposes.'
	},
	percentageTurnoverCryptocurrency0: {
		id: 'fe.percentage_turnover_cryptocurrency_0',
		defaultMessage: '0-10% (none or little of my turnover is in cryptocurrency)'
	},
	percentageTurnoverCryptocurrency10: {
		id: 'fe.percentage_turnover_cryptocurrency_10',
		defaultMessage: '10-30% (some of my turnover is in cryptocurrency)'
	},
	percentageTurnoverCryptocurrency30: {
		id: 'fe.percentage_turnover_cryptocurrency_30',
		defaultMessage: '30-60% (a big part of my turnover is in cryptocurrency)'
	},
	percentageTurnoverCryptocurrency60: {
		id: 'fe.percentage_turnover_cryptocurrency_60',
		defaultMessage: '60-90% (most of my turnover is in cryptocurrency)'
	},
	percentageTurnoverCryptocurrency90: {
		id: 'fe.percentage_turnover_cryptocurrency_90',
		defaultMessage: '90-100% (all or almost all of my turnover is in cryptocurrency)'
	},
	plannedTurnover1000: {
		id: 'fe.turnover_1000',
		defaultMessage: '1 000 - 5 000'
	},
	plannedTurnover5000: {
		id: 'fe.turnover_5000',
		defaultMessage: '5 000 - 15 000'
	},
	plannedTurnover15k30k: {
		id: 'fe.turnover_15000_30000',
		defaultMessage: '15 000 - 30 000'
	},
	plannedTurnover30k50k: {
		id: 'fe.turnover_30000_50000',
		defaultMessage: '30 000 - 50 000'
	},
	plannedTurnover50k100k: {
		id: 'fe.turnover_50000_100000',
		defaultMessage: '50 000 - 100 000'
	},
	plannedTurnover15000: {
		id: 'fe.turnover_15000',
		defaultMessage: '15 000 - 50 000'
	},
	plannedTurnover50000: {
		id: 'fe.turnover_50000',
		defaultMessage: '50 000+'
	},
	plannedTurnover1k4999: {
		id: 'fe.turnover_1000_4999',
		defaultMessage: '1 000 - 4 999'
	},
	plannedTurnover5k14999: {
		id: 'fe.turnover_5000_14999',
		defaultMessage: '5 000 - 14 999'
	},
	plannedTurnover15k29999: {
		id: 'fe.turnover_15000_29999',
		defaultMessage: '15 000 -29 999'
	},
	plannedTurnover30k49999: {
		id: 'fe.turnover_30000_49999',
		defaultMessage: '30 000 - 49 999'
	},
	plannedTurnover50k99999: {
		id: 'fe.turnover_50000_99999',
		defaultMessage: '50 000 - 99 999'
	},
	addAnotherAccount: {
		id: 'fe.add_another_account',
		defaultMessage: '+ Add another account'
	},
	removeLastAccount: {
		id: 'fe.remove_last_account',
		defaultMessage: '- Remove last account'
	},
	removeLastCitizenship: {
		id: 'fe.remove_last_citizenship',
		defaultMessage: '- Remove last citizenship'
	},
	invalidTurnover: {
		id: 'fe.invalid_turnover',
		defaultMessage:
			'Your estimated yearly turnover does not correspond to the estimated monthly incoming and outgoing turnover.'
	},
	requiredField: {
		id: 'fe.required_field',
		defaultMessage: 'Please fill out all the fields'
	},
	addAnotherName: {
		id: 'fe.add_another_name',
		defaultMessage: '+ Add another name'
	},
	removeLastName: {
		id: 'fe.remove_last_name',
		defaultMessage: '- Remove last name'
	},
	addAnotherWebsite: {
		id: 'fe.add_another_website',
		defaultMessage: '+ Add another website'
	},
	removeLastWebsite: {
		id: 'fe.remove_last_website',
		defaultMessage: '- Remove last website'
	},
	addAnotherLicenseOrAuthorization: {
		id: 'fe.add_another_license_or_authorization',
		defaultMessage: '+ Add another license/authorization'
	},
	removeLastLicenseOrAuthorization: {
		id: 'fe.remove_last_license_or_authorization',
		defaultMessage: '- Remove last license/authorization'
	},
	addAnotherPartner: {
		id: 'fe.add_another_partner',
		defaultMessage: '+ Add another partner'
	},
	removeLastPartner: {
		id: 'fe.remove_last_partner',
		defaultMessage: '- Remove last partner'
	},
	percentageTurnover0: {
		id: 'fe.percentage_turnover_0',
		defaultMessage: '0-10% (none or little of my turnover is in cash)'
	},
	percentageTurnover10: {
		id: 'fe.percentage_turnover_10',
		defaultMessage: '10-30% (some of my turnover is in cash)'
	},
	percentageTurnover30: {
		id: 'fe.percentage_turnover_30',
		defaultMessage: '30-60% (a big part of my turnover is in cash)'
	},
	percentageTurnover60: {
		id: 'fe.percentage_turnover_60',
		defaultMessage: '60-90% (most of my turnover is in cash)'
	},
	percentageTurnover90: {
		id: 'fe.percentage_turnover_90',
		defaultMessage: '90-100% (all or almost all of my turnover is in cash)'
	},
	purposeOfIdentificationSubtitle: {
		id: 'fe.purpose_of_identification_subtitle',
		defaultMessage: 'Select the purpose of identity verification'
	},
	specify: {
		id: 'fe.specify',
		defaultMessage: 'Specify'
	},
	turnoverPercentageOption1: {
		id: 'fe.none_turnover_in_crypto',
		defaultMessage: '0 (none of my turnover is in cryptocurrency)'
	},
	turnoverPercentageOption2: {
		id: 'fe.one_to_ten_turnover_in_crypto',
		defaultMessage: '1-10% (little of my turnover is in cryptocurrency)'
	},
	turnoverPercentageOption3: {
		id: 'fe.ten_to_thirty_turnover_in_crypto',
		defaultMessage: '10-30% (some of my turnover is in cryptocurrency)'
	},
	turnoverPercentageOption4: {
		id: 'fe.thirty_to_sixty_turnover_in_crypto',
		defaultMessage: '30-60% (a big part of my turnover is in cryptocurrency)'
	},
	turnoverPercentageOption5: {
		id: 'fe.sixty_to_ninety_turnover_in_crypto',
		defaultMessage: '60-90% (most of my turnover is in cryptocurrency)'
	},
	turnoverPercentageOption6: {
		id: 'fe.ninety_and_more_turnover_in_crypto',
		defaultMessage: '90% or more (all or almost all of my turnover is in cryptocurrency)'
	},
	turnoverPercentageOptionUpTo10: {
		id: 'fe.up_to_ten_turnover_in_crypto',
		defaultMessage: 'Up to 10% (little of my turnover is in cryptocurrency)'
	},
	turnoverPercentageOption10To29: {
		id: 'fe.turnover_in_crypto_10_to_29',
		defaultMessage: '10-29% (some of my turnover is in cryptocurrency)'
	},
	turnoverPercentageOption30To59: {
		id: 'fe.turnover_in_crypto_30_to_59',
		defaultMessage: '30-59% (a big part of my turnover is in cryptocurrency)'
	},
	turnoverPercentageOption60To89: {
		id: 'fe.turnover_in_crypto_60_to_89',
		defaultMessage: '60-89% (most of my turnover is in cryptocurrency)'
	},
	addAnotherHead: {
		id: 'fe.add_another_head',
		defaultMessage: '+ Add another head of the customer'
	},
	removeHead: {
		id: 'fe.remove_last_head',
		defaultMessage: '- Remove last head of the customer'
	},
	uboTooltip: {
		id: 'fe.ubo_tooltip',
		defaultMessage:
			'A natural person who owns or controls the customer (a legal person or a foreign undertaking) and/or the natural person on whose behalf a transaction or activity is being conducted.'
	},
	day: {
		id: 'fe.day',
		defaultMessage: 'Day'
	},
	month: {
		id: 'fe.month',
		defaultMessage: 'Month'
	},
	year: {
		id: 'fe.year',
		defaultMessage: 'Year'
	},
	optional: {
		id: 'fe.optional',
		defaultMessage: '(optional)'
	},
	UBOAndCMSError: {
		id: 'fe.changed_values_please_select_different_answer',
		defaultMessage: 'Values have changed, please update your answer'
	},
	invalidCharacters: {
		id: 'fe.invalid_characters',
		defaultMessage: 'Please provide your answer in Latin letters'
	},
	numbersOnly: {
		id: 'fe.numbers_only',
		defaultMessage: 'Please provide your answer in numbers only'
	},
	uboClientConfirmation: {
		id: 'fe.ubo_client_confirmation_text',
		defaultMessage: `I, the Client, hereby certify that I am the ultimate beneficial owner of the account and the funds in the account.`
	},
	uboConfirmation: {
		id: 'fe.ubo_confirmation_text',
		defaultMessage: `I hereby certify that I am the ultimate beneficial owner of the account and the funds in the account.`
	},
	authorizationConfirmation: {
		id: 'fe.authorization_confirmation_text',
		defaultMessage: `I confirm that I am fully authorized to sign this Questionnaire.`
	},
	authorizationConfirmationSC: {
		id: 'fe.authorization_confirmation_text_sc',
		defaultMessage: 'I confirm that I am fully authorised to sign this Questionnaire.'
	},
	PPBUboConfirmation: {
		id: 'fe.ppb_ubo_confirmation_text',
		defaultMessage: `I hereby certify that I am the ultimate beneficial owner of the account and the funds in the account.`
	},
	confirmationText: {
		id: 'fe.confirmationText',
		defaultMessage: `I hereby certify that the information provided in the customer questionnaire
		is complete and true. I agree to inform {companyTitle} immediately in
		writing about any changes in the information provided, as well as provide
		additional information or documentation when requested by {companyTitle}. I
		will use {companyTitle} services for legitimate purposes only and I
		understand that if the information in this questionnaire is inaccurate or
		misleading, relevant authorities may be informed about it and it may lead to
		unilateral termination of the business relationship.`
	},
	confirmationTextSC: {
		id: 'fe.confirmation_text_sc',
		defaultMessage: `I hereby certify that the information provided in the customer questionnaire is complete and true. I agree to inform {companyTitle} immediately in writing about any changes in the information provided, as well as provide additional information or documentation when requested by {companyTitle}. I will use {companyTitle} services for legitimate purposes only, and I understand that if the information in the questionnaire is inaccurate or misleading, relevant authorities may be informed about it, and it may lead to unilateral termination of the business relationship and services provision.`
	},
	confirmationTextBNK: {
		id: 'fe.confirmation_text_bnk',
		defaultMessage: `I hereby certify that the information provided in this questionnaire, including all uploaded documents and supporting evidence, is complete, true, and authentic. I agree to notify immediately in writing of any changes to this information or documentation. I will use the services for legitimate purposes only and understand that providing inaccurate, misleading, or falsified information or documents may lead to relevant authorities being informed and the unilateral termination of the business relationship.`
	},
	goToNextPage: {
		id: 'fe.go_to_next_page',
		defaultMessage: 'Go to the next page'
	},
	mediaAppPromoText: {
		id: 'fe.media_app_promo_text',
		defaultMessage:
			'If you are experiencing issues with your camera you can <a>continue in app</a>'
	},
	changeDocument: {
		id: 'fe.change_document',
		defaultMessage: `Choose different <b>Document type</b>`
	},
	documentIssueCountry: {
		id: 'fe.your_document_issue_country',
		defaultMessage: 'Issuing country for the identification document used for KYC'
	},
	selectCitizenship: {
		id: 'fe.your_citizenship',
		defaultMessage: 'Please select your citizenship'
	},
	residencePermitDescription: {
		id: 'fe.residence_permit_description',
		defaultMessage: ' '
	},
	identityCardDescription: {
		id: 'fe.identity_card_description',
		defaultMessage: 'Only EU/EEA identity cards are accepted'
	},
	internationalPassportDescription: {
		id: 'fe.international_passport_description',
		defaultMessage: 'Local passports without MRZ are not accepted'
	},
	driversLicenceDescription: {
		id: 'fe.drivers_licence_description',
		defaultMessage: ' '
	},
	errorSectionsRequireClarification: {
		id: 'fe.error_sections_require_clarification',
		defaultMessage:
			'The following highlighted sections require further clarification or additional information. Please update them accordingly.'
	},
	noErrorsInPage: {
		id: 'fe.no_errors_in_page',
		defaultMessage:
			'No errors were found in this page! You can double check your data or proceed to the next page.'
	},
	youMustAnswerAllQuestions: {
		id: 'fe.you_must_answer_all_questions',
		defaultMessage: 'You must answer all questions in this page before proceeding'
	},
	hanvingIssuesContinueDifferentDevice: {
		id: 'fe.having_issues_continue_different_device',
		defaultMessage:
			'If you are having issues with your KYC session you can continue in a different device.'
	},
	yourSessionKey: {
		id: 'fe.your_session_key',
		defaultMessage: 'Your session key:'
	},
	additionalAssistance: {
		id: 'fe.if_need_additional_assistance_contact_live_chat',
		defaultMessage:
			'If you need any extra assistance please get in contact with our support through the live chat.'
	},
	goToAutoKYCOrDownloadapp: {
		id: 'fe.go_to_autokyc_or_download_app',
		defaultMessage: 'Go to <a>https://kyc.autokyc.com</a> or download our AutoKYC app'
	},
	headOfCustomerNameSubtitle: {
		id: 'fe.head_of_customer_name_subtitle',
		defaultMessage: 'Name as displayed on passport, Latin Characters only'
	},
	listOfPreferentialZones: {
		id: 'fe.list_of_preferential_zones',
		defaultMessage: 'List of preferential zones can be found {link}'
	},
	pin: {
		id: 'fe.pin',
		defaultMessage: 'PIN'
	},
	qrCode: {
		id: 'fe.qr_code',
		defaultMessage: 'QR code'
	},
	selectDocument: {
		id: 'fe.select_document',
		defaultMessage: 'Select document'
	},
	transactionsOption2: {
		id: 'fe.transactions_10',
		defaultMessage: '10 - 30'
	},
	transactionsOption3: {
		id: 'fe.transactions_30',
		defaultMessage: '30 - 60'
	},
	transactionsOption4: {
		id: 'fe.transactions_other',
		defaultMessage: 'Other'
	},
	confirmPrivacyPolicy: {
		id: 'fe.confirm_pervesk_privacy_policy_with_link',
		defaultMessage: 'I confirm that I have read and accept Pervesk {link}.'
	},
	documentTypesExplained: {
		id: 'fe.document_types_explained',
		defaultMessage: 'Document types explained'
	},
	perveskAccountAgreement: {
		id: 'fe.pervesk_account_agreement',
		defaultMessage: `<h1>Electronic money and payment account agreement</h1>
		<ol>
			<li>
				<p>
					<strong> Terms Used in the Agreement </strong>
				</p>
				<ol>
					<li>
						<p>
							General Service Agreement is the General Service Agreement concluded
							between the Institution - UAB “Pervesk”, company code 304186270,
							registered address Ausros al. 68, LT-76233 Siauliai, Lithuania
							(correspondence address Vilniaus g. 31, Vilnius, Lithuania, e-mail
							address {link}) and
							the Client, including all amendments and supplements, and which is
							an integral part of the Account Agreement and which the Client can
							also access on the Institution’s website ________________________.
						</p>
					</li>
					<li>
						<p>
							Electronic Money is money deposited/transferred to the Account
							managed by the Institution on behalf of the Client for the purpose
							of making payments (in the Agreement, Electronic Money can be simply
							referred to as funds).
						</p>
					</li>
					<li>
						<p>
							Client is a person who has concluded this Agreement with the
							Institution.
						</p>
					</li>
					<li>
						<p>
							Account is an electronic money and payment account in the IBAN
							(International Bank Account Number) form
							No.____________________________________________ opened by the
							Institution on behalf of the Client to which the Client can
							deposit/transfer funds and store them, execute fund transfers and
							other payment transactions allowed by the Institution.
						</p>
					</li>
					<li>
						<p>
							Standard Rates – the rates approved by the Institution for the
							provision of services and transactions that are an integral and
							inseparable part of this Agreement.
						</p>
					</li>
					<li>
						<p>
							Other terms used in the Agreement are in accordance with the terms
							defined by the General Service Agreement, the Law on Payments of the
							Republic of Lithuania and the Law on Electronic Money and Electronic
							Money Institutions of the Republic of Lithuania.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> Subject of the Agreement </strong>
				</p>
				<ol>
					<li>
						<p>
							Under this Agreement, the Institution undertakes to open the Account
							No.________________________________________________________ for the
							Client, accept the funds from the Client, issue the appropriate
							amount of electronic money and credit them to the Account opened by
							the Client, execute the Client’s instructions for the transfer and
							redemption of electronic money and other payment transactions, to
							enable the Client to manage the Account by remote electronic means
							and execute other operations performed by the Institution, and the
							Client undertakes to pay to the Institution for the provided
							services and performed operations.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> Know Your Customer </strong>
				</p>
				<ol>
					<li>
						<p>
							By signing this Agreement, the Client agrees that the Institution,
							both by itself and through third parties, can verify and evaluate
							the Client’s and its beneficiaries’ identity, activity, origin of
							the funds, risks and any other information required to properly know
							the Client. The Client undertakes to provide the Institution with
							all information and documents requested by it for the purposes of
							getting to know the Client within the deadline specified by the
							Institution and in the form and language specified by the
							Institution. If the Institution cannot properly and fully get to
							know the Client, this Agreement is not concluded, and, if it has
							been concluded, it is immediately and without notice terminated.
						</p>
					</li>
					<li>
						<p>
							The Client agrees and undertakes at any time at the request of the
							Institution to update and/or submit to the Institution additional
							information and documents about the identity of the Client and its
							beneficiaries, origin of the funds used, activities and other
							information requested by the Institution to get to know the Client,
							within the timeframe specified by the Institution and in the form
							and language indicated by the Institution.
						</p>
					</li>
					<li>
						<p>
							Upon change of any data indicated by the Client during the last
							procedure of getting to know the Client, the Client undertakes to
							notify the Institution immediately and not later than within one
							working day in writing, including by e-mail, and provide the
							documents related to such changes. In case of failure to fulfil the
							obligations provided for in this clause, the Client is solely
							responsible for all consequences arising out of non-communication in
							a timely manner and agrees that the actions of the Institution,
							carried out using the last contact details known to the Institution
							and power of attorneys, shall be deemed to have been performed
							properly.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>
						Use of the Account and the Conditions for the Issuance and Redemption of
						Electronic Money
					</strong>
				</p>
				<ol>
					<li>
						<p>
							The Account is opened for the Client for the term of the Agreement.
						</p>
					</li>
					<li>
						<p>
							The Client can use the Account on the Internet by connecting to the
							server of the Institution.
						</p>
					</li>
					<li>
						<p>
							The Client may deposit funds into the Account, withdraw funds from
							the Account, hold funds in the Account, transfer, accept and perform
							other operations which the Institution allows to execute with the
							Account.
						</p>
					</li>
					<li>
						<p>
							The funds in the Account are the property of the Client, except for
							the fees, losses and other similar amounts payable to the
							Institution, as provided by this Agreement, the General Service
							Agreement, other agreements between the Institution and the Client
							or the legal acts.
						</p>
					</li>
					<li>
						<p>
							The funds kept in the Account are Electronic Money. When the Client
							makes a deposit and/or receives money in the Account, the
							Institution will issue Electronic Money and credit them to the
							Account at the nominal value of the funds deposited and/or accepted
							(after paying the Institution fees, if applicable).
						</p>
					</li>
					<li>
						<p>
							Electronic Money in the Account is not considered as a deposit or
							other repayable funds; for it the Institution does not pay interest
							and does not provide other benefits related to the duration of
							holding Electronic Money in the Account.
						</p>
					</li>
					<li>
						<p>
							The Client is entitled to withdraw Electronic Money from the Account
							at any time, except in cases where the Account and/or the provision
							of the Institution’s services to the Client are blocked or otherwise
							restricted in accordance with this Agreement, the General Service
							Agreement, other agreements between the Institution and the Client
							or the legal acts. When withdrawing Electronic Money from the
							Account, the amount of Electronic Money withdrawn by the Client
							(after deduction of the Institution fees, if applicable) is redeemed
							by the Institution at par value and transferred to the bank or other
							type of account specified by the Client or transferred by other
							methods supported by the Institution. During the term of the
							Agreement, the Client may withdraw all or part of the Electronic
							Money from the Account. Upon termination of the Agreement, the
							Client may only withdraw from the Account all Electronic Money.
						</p>
					</li>
					<li>
						<p>
							Fees for using the Account, including fees for the issuance and
							redemption of Electronic Money, are indicated in the Standard Rates.
						</p>
					</li>
					<li>
						<p>
							The fee for the redemption of Electronic Money only applies in the
							following cases:
						</p>
						<ol>
							<li>
								<p>
									The Client requests to redeem Electronic Money before the
									expiry of the term of the Agreement;
								</p>
							</li>
							<li>
								<p>
									The Client terminates the Agreement before the expiry date
									specified in the Agreement;
								</p>
							</li>
							<li>
								<p>
									The Client requests to redeem the Electronic Money more than
									one year after the expiration of the term of the Agreement.
								</p>
							</li>
						</ol>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> The Institution Undertakes: </strong>
				</p>
				<ol>
					<li>
						<p>
							To open for the Client the Account specified in the Agreement in
							Euro or in another currency agreed by the Parties.
						</p>
					</li>
					<li>
						<p>
							To credit funds transferred or paid in cash and deposited on the
							Institution’s account, to issue Electronic Money at the nominal
							value of money and to credit them to the Client’s Account.
						</p>
					</li>
					<li>
						<p>
							To execute payment orders submitted by the Client or his
							representative in accordance with the terms and conditions
							stipulated by the agreements between the Institution and the Client
							and the laws of the Republic of Lithuania, provided that the Account
							contains sufficient funds for execution of payment orders and
							payment of fees for the services rendered and operations performed
							by the Institution in accordance with the Standard Rates at the time
							of the Institution’s working day, but not later than stipulated by
							the agreements between the Institution and the Client and the laws
							of the Republic of Lithuania.
						</p>
					</li>
					<li>
						<p>
							To provide services and execute operations in the Account using the
							Standard Rates approved by the Institution and valid at that time,
							unless the Parties agreed upon otherwise. Information on Standard
							Rates and their fluctuations are available on the Institution’s
							website ________________________. If the Client does not submit a
							written request to terminate the Agreement within the time period
							specified in the General Service Agreement, the Client shall be
							deemed to have consented to the changed Standard Rates.
						</p>
					</li>
					<li>
						<p>
							To only provide information about the status of the Account, as well
							as the Account statements, which indicate the balance of the Account
							and the operations performed to the Client, as well as to the
							Client’s representative. In the absence of the Client’s consent, to
							only provide the information in cases provided for by the laws of
							the Republic of Lithuania.
						</p>
					</li>
					<li>
						<p>
							To provide advice to the Client on the matters of Account
							management.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> The Client Undertakes: </strong>
				</p>
				<ol>
					<li>
						<p>
							When opening, processing, and closing the Account, to submit the
							required documents to the Institution, confirming the right of the
							Client or the Client’s representative to manage the Client’s Account
							and the funds therein.
						</p>
					</li>
					<li>
						<p>
							To pay to the Institution a standard fee for the services rendered
							and transactions executed by the Institution, which the Institution
							has the right to deduct from the Account on the day the operation is
							executed. If, on the day of the transaction, the Account does not
							have sufficient funds to deduct the Institution’s fee, the Client
							agrees that the fee for the executed transaction or rendered
							services will be deducted on any other day when the balance of the
							Client’s Account is sufficient.
						</p>
					</li>
					<li>
						<p>
							To ensure that the Account has sufficient funds to execute the
							payment order and to pay for services rendered and payments
							executed. If the Account does not have sufficient funds for the
							payment for the services rendered and transactions executed, the
							Client agrees, and the Institution is entitled to deduct this fee
							from other accounts of the Client at the Institution.
						</p>
					</li>
					<li>
						<p>
							In the event of any change in the data provided to the Institution
							by the Client (name, surname, name of legal entity, residence or
							registration address, registration data, persons authorized to
							manage the funds of the Account or their data or other information
							previously provided to the Institution), to immediately, but not
							later than within 3 (three) working days, report this to the
							Institution and provide supporting documents. The Client, having
							failed to properly fulfil the obligations provided for in this
							clause, is solely responsible for all the consequences arising
							therefrom.
						</p>
					</li>
					<li>
						<p>
							To immediately notify the Institution of incorrectly credited or
							debited funds, as well as other mistaken transactions of the
							Account. In the event of insufficient funds to debit the amounts
							incorrectly credited to the Account, the Client unconditionally
							undertakes within 3 (three) business days from the day of reception
							the request from the Institution to return the incorrectly credited
							funds to the Institution.
						</p>
					</li>
					<li>
						<p>
							To ensure that the use of the Account does not violate the
							requirements of the agreements concluded between the Institution and
							the Client and the legal acts, as well as that the funds contained
							in the Account are not used for illicit purposes or would result
							from illegal activity.
						</p>
					</li>
					<li>
						<p>
							Use the Account in accordance with the terms and conditions of its
							use, ensure the security and confidentiality of the Account and
							login data, and take active steps to prevent Account and its login
							data from being used by unauthorized third parties.
						</p>
					</li>
					<li>
						<p>
							Upon becoming aware of the unauthorized use of the Account and/or
							access to the Account or its login data, as well as the evidence or
							suspicions that such information has become known to third parties,
							the Client shall immediately, but not later than within 1 (one)
							business day, notify the Institution or the entity designated by it.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> The Institution Is Entitled To: </strong>
				</p>
				<ol>
					<li>
						<p>
							Refuse to execute the order given by the Client if there is a
							suspicion that the order was submitted by a person unauthorized by
							the Client or documents submitted to the Institution are forged and
							require additional documents and/or information to be submitted.
						</p>
					</li>
					<li>
						<p>
							If the funds have been incorrectly credited to the Account or
							incorrectly deducted from the Account, or other mistakes in
							transactions with the Account have been noticed, to correct these
							errors without the Client’s additional consent.
						</p>
					</li>
					<li>
						<p>
							In the enforcement of a court decision or in other cases provided by
							laws of the Republic of Lithuania, withdraw funds from the Account
							without the consent of the Client.
						</p>
					</li>
					<li>
						<p>
							To suspend the deduction and payment of funds from the Account until
							the Client covers all of its debts to the Institution or in
							accordance with other cases provided by laws of the Republic of
							Lithuania.
						</p>
					</li>
					<li>
						<p>
							Do not accept or execute the Client’s instructions to execute
							transactions in the Account, if the funds in the Account are
							arrested or the Client’s right to manage the funds in the Account is
							otherwise restricted.
						</p>
					</li>
					<li>
						<p>
							For services rendered and transactions performed, the Client shall
							pay the fees payable according to the Standard Rates on the day the
							service to the Client was rendered or transaction was executed,
							except for the case provided for in Clause 6.2 of the Agreement and
							cases where the agreements concluded between the Institution and the
							Client provide otherwise.
						</p>
					</li>
					<li>
						<p>
							If the claims (orders) for debiting funds from the Account provided
							by law are provided by third parties, also if the Agreement or other
							agreements concluded between the Client and the Institution provides
							for the Institution to deduct the funds payable to the Institution
							by the Client from the Account, the Client’s instructions to deduct
							funds from the Account are executed only after fulfilling the claims
							(instructions) submitted by third parties to deduct funds from the
							Account and debits the amounts due from the Account to the
							Institution.
						</p>
					</li>
					<li>
						<p>
							If the Client’s representative wishes to receive a service or
							execute a transaction on behalf of the Client who submits to the
							Institution the documents proving he is representing the Client, the
							Institution has the right to render the service or execute the
							payment order of the Client representative’s only after verifying
							the authenticity of the documents submitted by the Client’s
							representative and the legitimacy of the authorization. The
							authority of the Client’s representative shall be determined in
							accordance with the documents required by the Institution.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> The Client Is Entitled To: </strong>
				</p>
				<ol>
					<li>
						<p>
							In compliance with this Agreement, the General Service Agreement, as
							well as other agreements concluded with the Institution, to execute
							payments and other operations with funds in the Account and use
							other services provided by the Institution.
						</p>
					</li>
					<li>
						<p>
							To submit a request to the Institution for concluding the agreements
							for services provided by the Institution.
						</p>
					</li>
					<li>
						<p>
							To conclude additional agreements with the Institution on special
							terms of the Agreement.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> Duration, Amendment and Termination of the Agreement </strong>
				</p>
				<ol>
					<li>
						<p>
							The Agreement enters into force on the day it is signed, and is
							valid indefinitely until the termination of the Agreement.
						</p>
					</li>
					<li>
						<p>
							The Agreement may be amended or supplemented only by written
							agreement between the Parties, with the exception of the exceptions
							provided for in the Agreement.
						</p>
					</li>
					<li>
						<p>
							The Institution has the right, for important reasons, to
							unilaterally change the terms of the Agreement, as well as the terms
							of the General Service Agreement and Standard Rates, informing the
							Client thereof no later than 60 (sixty) calendar days before the
							effective date of these amendments.
						</p>
					</li>
					<li>
						<p>
							The Client is deemed to consent to the amendments specified in
							Clause 9.3 of the Agreement if he does not notify the Institution
							before the amendments take effect that he does not consent to them.
							If the Client informs that he does not agree to the amendments
							specified in Clause 9.3 of the Agreement, the Client has the right
							to terminate the Agreement before the date on which the amendments
							will take effect. If the Client does not exercise the right to
							terminate the Agreement before the amendments enter into force, the
							Client is deemed to accept the amendments to the Agreement.
						</p>
					</li>
					<li>
						<p>
							The Agreement may be terminated by agreement of the Parties or by a
							unilateral declaration of one of the Parties as provided for in this
							Agreement.
						</p>
					</li>
					<li>
						<p>
							The Client is entitled to terminate the Agreement upon notification
							to the Institution 30 (thirty) calendar days from the submission of
							the notification or under the conditions provided for by Clause 9.4
							of the Agreement.
						</p>
					</li>
					<li>
						<p>
							The Institution may unilaterally terminate the Agreement concluded
							for indefinite term by out-of-court procedure by giving notice of
							termination to the Client not later than 60 (sixty) calendar days in
							advance, except in cases provided for in Clause 9.8 and 9.9 of the
							Agreement.
						</p>
					</li>
					<li>
						<p>
							The Institution is entitled to unilaterally and out-of-court
							terminate the Agreement by giving notice of termination 14
							(fourteen) calendar days in advance to the Client, if the Client
							fails to perform or improperly performs the obligations provided for
							in the Agreement or it becomes evident that the Client, at the time
							of the conclusion of the Agreement or later submitted to the
							Institution incorrect or misleading information, the Client engages
							in an activity unacceptable to the Institution, or the actions
							performed by the Client have, or could have, damaged the
							Institution’s reputation, or there are other cases listed in the
							General Service Agreement.
						</p>
					</li>
					<li>
						<p>
							The Institution has the right to unilaterally terminate the
							Agreement without additional notice, if no operations have been
							performed in the Account for one calendar year (automatic payment of
							the administration fee is not considered as transactions). Upon
							termination of the Agreement, the Institution, given the instruction
							of the Client, pays the balance of the Account in cash or transfers
							funds to another account of the credit, electronic money or payment
							institution indicated by the Client. If the Client has not given an
							order to transfer funds to another account, the Institution
							transfers funds to internal accounts of the Institution and informs
							the Client about it.
						</p>
					</li>
					<li>
						<p>
							Termination of the Agreement is the basis for the closure of the
							Account.
						</p>
					</li>
					<li>
						<p>
							The Account cannot be closed at the request of the Client if the
							Account is arrested or other restrictions apply to the Account.
						</p>
					</li>
					<li>
						<p>
							In case of termination of the Agreement, the Client and the
							Institution must comply with all of their obligations stipulated by
							the Agreement and arising during its validity period.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> Liability of the Parties </strong>
				</p>
				<ol>
					<li>
						<p>
							The Institution is liable for improperly executed payment orders in
							accordance with the procedure established by laws and other legal
							acts of the Republic of Lithuania.
						</p>
					</li>
					<li>
						<p>
							The Institution is not liable for errors committed by correspondent
							banks and other banks (including credit, electronic money or payment
							institutions), and actions thereof which may lead to failing to
							fulfil the obligations or they are delayed.
						</p>
					</li>
					<li>
						<p>
							The Institution is not responsible for relations and claims between
							payers and payees and does not investigate them.
						</p>
					</li>
					<li>
						<p>
							The Client is liable for incorrect and inaccurate information
							provided to the Institution and reimburses all losses incurred by
							the Institution in accordance with the procedure established by laws
							and other legal acts of the Republic of Lithuania.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> Other Conditions </strong>
				</p>
				<ol>
					<li>
						<p>
							The Institution manages personal data provided by the Client or
							Client’s representative. The purpose of personal data management is
							to open the Account for the Client, execute all legitimate Account
							operations, execute direct marketing and, if necessary, to recover
							the debt from the Client and provide personal data to third parties
							in the cases and according to the procedure established in this
							Agreement and the Law on the Protection of Personal Data of the
							Republic of Lithuania. The Institution collects, stores, manages the
							data of the Client or the Client’s representative under the
							conditions provided for in the Agreement during the term of the
							Agreement and 10 (ten) years after the termination of the Agreement.
						</p>
					</li>
					<li>
						<p>
							The Client’s representative may act on behalf of the Client,
							provided the appropriate power of attorney and a personal identity
							document (with personal code, photo, signature) and other documents
							and information requested by the Institution that prove the fact of
							representation are submitted to the Institution.
						</p>
					</li>
					<li>
						<p>
							Last month’s Account statements are deemed approved by the Client,
							if the Client does not comment on the statements within 15 (fifteen)
							calendar days from the receipt of the statement.
						</p>
					</li>
					<li>
						<p>
							The terms of the Agreement are confidential and are not made public
							without the consent of the other Party, except in the cases provided
							by the laws of the Republic of Lithuania.
						</p>
					</li>
					<li>
						<p>
							The Parties declare that, at the time of signing the Agreement, they
							are not aware of any circumstances prohibiting the conclusion of
							this Agreement or restricting the right of the Parties to conclude
							this Agreement. The Client declares that all the conditions of the
							Agreement are in accordance with his will, the terms and conditions
							of the Agreement, its content and the consequences of its conclusion
							are understandable and clear to him.
						</p>
					</li>
					<li>
						<p>
							The Client is not entitled to transfer the rights and obligations
							arising from this Agreement to third parties without the prior
							written consent of the Institution. The Institution has the right at
							any time to transfer the rights and obligations arising from this
							Agreement to third parties without the consent of the Client, unless
							such transfer of rights and obligations is in conflict with legal
							acts.
						</p>
					</li>
					<li>
						<p>
							The law of the Republic of Lithuania is applicable to this
							Agreement.
						</p>
					</li>
					<li>
						<p>
							The execution of this Agreement is also governed by the Civil Code
							of the Republic of Lithuania, the Law on Electronic Money and
							Electronic Money Institutions of the Republic of Lithuania, the Law
							on Payments of the Republic of Lithuania, other laws and legal acts,
							as well as the General Service Agreement and other internal
							Institution’s acts regulating the performance of operations.
						</p>
					</li>
					<li>
						<p>
							The Client and his representative, upon signing this Agreement,
							declare that they are familiar with and committed to comply with the
							conditions provided for in the General Service Agreement, which are
							an integral part of this Agreement, and have been informed that
							amendments to the General Service Agreement are available on the
							Institution’s website ________________________.
						</p>
					</li>
					<li>
						<p>
							The Parties agree that all disputes shall be resolved through
							negotiations. Any dispute, not settled by negotiations or other
							pre-trial procedures, shall be settled in the competent court of the
							Republic of Lithuania according to the registered address of the
							Institution.
						</p>
					</li>
					<li>
						<p>The Agreement is concluded in two copies – one for each Party.</p>
					</li>
				</ol>
			</li>
		</ol>`
	},
	perveskPrivacyPolicy: {
		id: 'fe.pervesk_privacy_policy',
		defaultMessage: `<h1>UAB “Pervesk” Privacy Policy</h1>
		<ol>
			<li>
				<p>
					<strong> General Provisions </strong>
				</p>
				<ol>
					<li>
						<p>
							UAB “Pervesk”, company code 304186270, with its registered office at
							Rinktines str. 5, Vilnius, the Republic of Lithuania (“Pervesk”,
							“Company, “we” or “us”) is a licensed electronic money institution
							(electronic money institution license No. 17, Issuing and
							Supervisory Authority – Bank of Lithuania), which directly or
							through the intermediaries provides services which are allowed under
							our electronic money institution license and which are described on
							the website {link} (the "Services"). Services may be available through our or our
							intermediaries’ internet banking systems (ib.pervesk.lt,
							ib.bankera.com or other), mobile apps or application programming
							interfaces (all of them or any of them hereinafter may be referred
							to as the “Platform”). The Services that Pervesk provides are
							subject to the relevant terms and conditions, which are presented in
							the respective Platform (the "Services").
						</p>
					</li>
					<li>
						<p>
							In order to provide Services, we may process personal data of our
							customers, their clients or representative, other related persons,
							such as beneficial owners, transaction senders, etc. (all together
							referred to as "Customer" or "you"). Any personal data we gather,
							use or share about you is processed in accordance with the
							Regulation (EU) 2016/679 of the European Parliament and of the
							Council of 27 April 2016 on the protection of natural persons with
							regard to the processing of personal data and on the free movement
							of such data, and repealing Directive 95/46/EC (General Data
							Protection Regulation) ("GDPR") and other applicable laws.
						</p>
					</li>
					<li>
						<p>
							This Privacy Policy (“Policy”) applies to your use of the Platform
							and any of Services, available through it. The Policy explains how
							we process your personal data through any relationship we have,
							whether it would be use of the Services on the Platform, online
							support services or any other possible mean. In case you provide
							information about other natural persons to the Company, you
							undertake to make this Policy known to them before the disclosure of
							such information to the Company.
						</p>
					</li>
					<li>
						<p>
							By contacting us, using this Platform and / or our Services you
							confirm you have read, understood and agreed with this Policy.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<strong>PRINCIPLES OF PERSONAL DATA PROCESSING FOLLOWED BY THE COMPANY</strong>
				<ol>
					<li>
						<p>The Company undertakes to ensure your personal data is:</p>
						<ol>
							<li>
								<p>
									processed lawfully, fairly, and in a transparent manner in
									relation to you;
								</p>
							</li>
							<li>
								<p>
									collected for specified, explicit and legitimate purposes
									(e.g. prevention of money laundering and terrorist
									financing, performance of Services, etc.), and not further
									processed in a manner that is incompatible with those
									purposes;
								</p>
							</li>
							<li>
								<p>
									adequate, relevant and limited to what is necessary in
									relation to the purposes for which they are processed;
								</p>
							</li>
							<li>
								<p>accurate and, where necessary, kept up to date; </p>
							</li>
							<li>
								<p>
									kept in a form which permits your identification for no
									longer than is necessary for the purposes for which the
									personal data are processed;
								</p>
							</li>
							<li>
								<p>
									processed in a manner that ensures appropriate security of
									your personal data.
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							The Company follows the above indicated principles strictly during
							the processing of your personal data and request the same from the
							data processors which it may use to process personal data on behalf
							of the Company.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<strong>LAWFULNESS OF PERSONAL DATA PROCESSING</strong>
				<ol>
					<li>
						<p>Your personal data will be processed if:</p>
						<ol>
							<li>
								<p>
									you have given consent to the processing of your personal
									data for one or more specific purposes; and/or
								</p>
							</li>
							<li>
								<p>
									processing is necessary for the performance of a contract to
									which you are party or in order to take steps at your
									request prior to entering into a contract; and/or
								</p>
							</li>
							<li>
								<p>
									processing is necessary for compliance with a legal
									obligation to which we are subject; and/or
								</p>
							</li>
							<li>
								<p>
									processing is necessary for the purposes of the legitimate
									interests pursued by us or the third party.
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							If Services are allowed by us and available for the child under the
							age of 16, their personal data will be processed only with the
							consent of the holders of parental responsibility, and only to the
							extent that such consent or permit is given.
						</p>
					</li>
					<li>
						<p>
							The Company may subject its Customers to decisions based solely on
							automated processing, including profiling, only if it is necessary
							for conclusion of a contract between you and the Company or due to
							provision of the Services under such contract, it is authorised by
							the law or you have expressed an explicit consent to such
							processing.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<strong>PURPOSES FOR THE COLLECTION AND USE OF YOUR PERSONAL DATA</strong>
				<ol>
					<li>
						<p>Your personal data is being processed for the purposes of:</p>
						<ol>
							<li>
								<p>
									provision of the Services (account opening, transfers of
									funds, payment collection and other payment services);
								</p>
							</li>
							<li>
								<p>
									prevention of money laundering and terrorist financing
									(implementation of the principle "Know Your Customer");
								</p>
							</li>
							<li>
								<p>implementation of international sanctions;</p>
							</li>
							<li>
								<p>Services support;</p>
							</li>
							<li>
								<p>quality assurance;</p>
							</li>
							<li>
								<p>use of the Company’s social networks accounts;</p>
							</li>
							<li>
								<p>
									proper and secure use of the Platform and of Customer’s
									online account
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							The processing of your personal data is necessary for the
							implementation of the above indicated purpose(s), therefore, if you
							fail to provide the requested data the Company may not be able to
							provide your requested Services.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<strong>METHODS OF PERSONAL DATA COLLECTION USED BY THE COMPANY</strong>
				<ol>
					<li>
						<p>
							The Company collects your personal data directly from you or from
							the third parties when:
						</p>
						<ol>
							<li>
								<p>you use or view the Platform;</p>
							</li>
							<li>
								<p>you register to the Platform;</p>
							</li>
							<li>
								<p>you request or use our Services;</p>
							</li>
							<li>
								<p>you request Services support;</p>
							</li>
							<li>
								<p>
									we execute Customer’s due diligence or ongoing due
									diligence;
								</p>
							</li>
							<li>
								<p>we monitor your transactions;</p>
							</li>
							<li>
								<p>
									we check whether you are not related to fraudulent
									activities;
								</p>
							</li>
							<li>
								<p>
									we receive requests, orders, decisions or etc. from the
									third parties regarding you.
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							The Company may from time to time renew personal data related to
							Customer’s profile based on the up-to-date information received from
							the respectable third parties.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<strong>CATEGORIES OF PERSONAL DATA THE COMPANY MAY PROCESS ABOUT YOU</strong>
				<ol>
					<li>
						<p>
							The scope of the Customer‘s personal data indicated below which
							could be requested by the Company and further processed in order to
							provide the Services for the purposes indicated in article 4 of this
							Policy may vary depending on the type of Services chosen
							particularly by the Customer and Company‘s applied verification
							procedures to execute it, as well as, legal requirements applied for
							such provision of the Services in order to prevent possible risks
							and various crimes.
						</p>
					</li>
					<li>
						<p>
							In order to provide the Services, we may process your personal data
							categories, such as (including but not limited):
						</p>
						<ol>
							<li>
								<p>
									General data: name, surname, personal code, date of birth,
									citizenship(s), place of birth (city, country), country of
									residence for tax purpose, taxpayer identification number
									(TIN), address, city/town, postal code, phone number,
									e-mail, selfie with the identity document, video, data about
									Customer which may be provided in double-checking systems;
								</p>
							</li>
							<li>
								<p>
									Other Customer‘s profile information: profile type, unique
									character sequence assigned to the Customer for
									identification, executed Customer’s assessment (evaluation)
									results, chosen means of identification, 2FA information,
									Customer’s number, user ID, referral code, referral ID,
									session ID, login status, email confirmed status, phone
									confirmed status, compliance officer comments;
								</p>
							</li>
							<li>
								<p>
									Social network data: social network profile photo, name,
									surname, your comments, emotions and other actions expressed
									via our social network account, other your social network
									profile information provided by you;
								</p>
							</li>
							<li>
								<p>
									Identity document data: ID Type (Passport / Identity Card /
									Residence permit), its copy, MRZ, document number, date of
									issue, date of expiry;
								</p>
							</li>
							<li>
								<p>
									Data obtained and/or created while performing legal
									obligation: inquiries, requests, notifications, orders,
									courts decisions or other data related to the specific
									Customer(s) which may be received by or provided to the
									police, courts, investigative bodies, notaries, tax
									administrator, courts, bailiffs and other institutions;
								</p>
							</li>
							<li>
								<p>
									Information about Customer‘s occupation and income sources:
								</p>
								<ol>
									<li>
										<p>
											Specific occupation: paid employee (position) /
											owner of legal entity (company name) / registered
											self-employee / unemployed / other;
										</p>
									</li>
									<li>
										<p>
											Main sectors of customer’s occupation, individual or
											business activity;
										</p>
									</li>
									<li>
										<p>
											Information regarding countries in which customer is
											employed, carries out individual activity or
											business: countries, whereas activity or business is
											conducted or registered in preferential tax zone,
											percentage of turnover in cash for such activity or
											business;
										</p>
									</li>
								</ol>
							</li>
							<li>
								<p>Payment account opening information:</p>
								<ol>
									<li>
										<p>Purpose for account opening;</p>
									</li>
									<li>
										<p>Source of Customer’s income and wealth;</p>
									</li>
									<li>
										<p>Services which the Customer plans to use</p>
									</li>
									<li>
										<p>Monthly planned account turnover in EUR;</p>
									</li>
									<li>
										<p>
											Number of transactions and countries from which the
											funds will be received or transferred;
										</p>
									</li>
									<li>
										<p>Account number;</p>
									</li>
								</ol>
							</li>
							<li>
								<p>Information about Politically Exposed Person ("PEP"): </p>
								<ol>
									<li>
										<p>
											Information whether the Customer is PEP itself or
											has an immediate relationship with PEP;
										</p>
									</li>
									<li>
										<p>
											General information regarding PEP: relation, name,
											surname, country, institution, PEP‘s position;
										</p>
									</li>
								</ol>
							</li>
							<li>
								<p>Information about Beneficial Owner ("UBO"):</p>
								<ol>
									<li>
										<p>
											Information whether the Customer is the UBO of the
											account and the funds in the account;
										</p>
									</li>
									<li>
										<p>
											General UBO‘s identification data: name, surname, ID
											copy, date of birth, personal code, citizenship,
											country of residence for tax purposes, tax
											identification number (TIN), place of birth (city,
											country), registered residential address, share of
											benefit;
										</p>
									</li>
								</ol>
							</li>
							<li>
								<p>Financial data: </p>
								<ol>
									<li>
										<p>
											related payment card (i.e. currency, card number,
											validity date, card owner’s name and surname,
											CVV/CVV2);
										</p>
									</li>
									<li>
										<p>
											Customer’s account information (e.g., services,
											transactions type, sender, recipient, amount,
											purpose, extracts etc.)
										</p>
									</li>
									<li>
										<p>
											information about accounts in other financial
											institutions (i.e. name of institution, country,
											account number);
										</p>
									</li>
									<li>
										<p>
											Customer’s creditworthiness information (e.g.
											creditors, type of debt and its amount, due dates,
											debtor’s identification number, etc.).
										</p>
									</li>
								</ol>
							</li>
							<li>
								<p>
									Communication data: date, time, correspondence, video and
									voice calls, chats, etc.
								</p>
							</li>
							<li>
								<p>
									Information related to electronic devices: IP address(es);
									time zone; log-in and log-out register; browser information;
									electronic device‘s operational system information; location
									data (country (code), city), internet service provider
									(ISP); selected language; information regarding Customer‘s
									actions within Platform;
								</p>
							</li>
							<li>
								<p>
									History data: Customer‘s experience using the Platform, the
									register of all Customer‘s actions performed on the Platform
									(i.e. operations, such as funds transactions, linking cards,
									log-in and log-out register, register of reset password);
								</p>
							</li>
							<li>
								<p>
									Other data which may be requested or gathered by the Company
									or provided by the Customer herself/himself or any third
									party.
								</p>
							</li>
						</ol>
					</li>
				</ol>
			</li>
			<li>
				<strong>DISCLOSURE OF PERSONAL DATA TO OTHER PARTIES</strong>
				<ol>
					<li>
						<p>
							Your personal data indicated in article 6 of this Policy may be
							provided by the Company itself or upon respective request to the
							below indicated categories of personal data recipients:
						</p>
						<ol>
							<li>
								<p>
									credit, financial, payment and (or) electronic money
									institutions, agencies, bureaus;
								</p>
							</li>
							<li>
								<p>
									payment services providers, as well as intermediary services
									providers;
								</p>
							</li>
							<li>
								<p>
									authorities (i.e. supervising institutions, law enforcement
									institutions, courts, bailiffs);
								</p>
							</li>
							<li>
								<p>auditors, legal and financial consultants; </p>
							</li>
							<li>
								<p>IT providers;</p>
							</li>
							<li>
								<p>fraud detection services providers;</p>
							</li>
							<li>
								<p>data processors;</p>
							</li>
							<li>
								<p>related business partners;</p>
							</li>
							<li>
								<p>
									other service providers which services may include, or which
									are engaged in personal data processing executed by the
									Company.
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>Personal data may also be provided to other recipients if:</p>
						<ol>
							<li>
								<p>
									the Company has to comply with a legal obligation to which
									it is a subject; or
								</p>
							</li>
							<li>
								<p>
									such requested personal data is necessary for the concrete
									data recipient to carry out a particular inquiry in the
									general interest, in accordance with the European Union or
									Member State law; or
								</p>
							</li>
							<li>
								<p>
									the data requesting party has a legitimate interest to
									request for such information.
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							The Company maintains strong cooperation with local and
							international authorities and institutions, therefore, upon request
							of such party substantiated under article 6.2 of this Policy, your
							personal data may be provided to the requested party without
							permission to notify you.
						</p>
					</li>
					<li>
						<p>
							In general, the Company process your personal data within the
							European Union ("EU") or the European Economic Area ("EEA"),
							however, there might be some cases when the Company cooperates with
							the recipients outside EU or EEA. In such cases the Company makes
							all reasonable efforts to ensure that at least one of the following
							GDPR requirements is complied:
						</p>
						<ol>
							<li>
								<p>
									the recipient is located in the territory which is
									acknowledged by the European Commission as ensuring the
									adequate level of personal data protection;
								</p>
							</li>
							<li>
								<p>
									the recipient is in the United States of America and has
									been certified under Privacy Shield Framework;
								</p>
							</li>
							<li>
								<p>
									the Company and the recipient have concluded the agreement
									with the standard terms and conditions regarding personal
									data security which were approved by the European
									Commission;
								</p>
							</li>
							<li>
								<p>
									the Codes of Conduct or other security measures under GDPR
									has been complied.
								</p>
							</li>
						</ol>
					</li>
				</ol>
			</li>
			<li>
				<strong>PERSONAL DATA RETENTION PERIOD</strong>
				<ol>
					<li>
						<p>
							The Company processes personal data so that it could achieve the
							purposes indicated in article 4 of this Policy.
						</p>
					</li>
					<li>
						<p>
							In order to set the below indicated data retention periods the
							Company has referred to the legal acts and public recommendations
							applicable in the European Union and locally such as compliance with
							legit limitation periods, as well as current business practice.
						</p>
					</li>
					<li>
						<p>
							Depending of the category of personal data and the purpose it is
							being processed your data retention period applied within the
							Company as it is required by the law or business practice to ensure
							smooth delivery of the Services is:
						</p>
						<ol>
							<li>
								<p>
									for the purposes indicated in articles 4.1.1 – 4.1.3 of this
									Policy we process your personal data throughout the term of
									our contractual relationship and store it after this
									relationship ends for as many years as it is required by law
									(for example, it may be required to store your personal data
									for 8 years, whilst the concluded service contract itself
									with the personal data therein may be necessary to store for
									10 years after the contractual relationship ends). The
									personal data processing for such period is based on
									necessity to execute Customer’s due diligence, conduct
									ongoing monitoring, collect supporting evidence and records
									of transactions. In case the contractual relationship has
									not been established based on reasons not related with
									prevention of money laundering and terrorist financing
									(e.g., you decided not to finish application or verification
									procedure due to your own personal reasons) your personal
									data will be stored for 2 years since our last actual
									contact with each other (e.g., our last e-mail to you
									answering your request);
								</p>
							</li>
							<li>
								<p>
									for the purposes indicated in article 4.1.4 – 4.1.5 we
									process your personal data collected via correspondence with
									you throughout the term of our contractual relationship and
									store it after this relationship ends for as many years as
									it is required by law (for example, it may be required to
									store such data for additional 5 years). In case you have
									not established or has already terminated contractual
									relationship with Pervesk, your personal data will be
									processed for these purposes for a period of 2 years since
									our last actual contact with each other (e.g., our last
									e-mail to you answering your request);
								</p>
							</li>
							<li>
								<p>
									for the purposes indicated in article 4.1.6 we process your
									personal data until your social network account or Company’s
									social network account is deleted – whichever comes first;
								</p>
							</li>
							<li>
								<p>
									for the purposes indicated in article 4.1.7 we process your
									personal data throughout the term we support the Platform.
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							Upon the end of retention period, indicated above, your personal
							data is erased or anonymised (irreversibly).
						</p>
					</li>
				</ol>
			</li>
			<li>
				<strong>INFORMATION SECURITY</strong>
				<ol>
					<li>
						<p>
							The Company takes various security ensuring technologies and
							procedures in order to protect your personal data against
							unauthorised or unlawful processing, accidental loss, misuse,
							unauthorized access, illegal usage, destruction, disclosure, damage
							and etc. This includes legal, organisational, technical, and
							physical security measures, such as latest security systems,
							two-factor authentication and passwords, ability to detect cyber
							security attacks and other threats to the integrity of the Platform,
							working only with trustworthy service providers, etc. However, no
							transmission of information via e-mail or other telecommunication
							channels or your access to the Platform or the Services through the
							internet could be fully secured. Therefore, you should take due care
							when you are accessing the Platform or using the Services via
							internet or sharing confidential information via e-mail or other
							telecommunication channels.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<strong>COOKIES</strong>
				<ol>
					<li>
						<p>
							Cookies are small information files found in the Platform you visit
							and stored in your computer or mobile device. In order to get to
							know more about cookies, please read {link2} on the Platform.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<strong>YOUR RIGHTS REGARDING THE PROCESSING OF YOUR PERSONAL DATA</strong>
				<ol>
					<li>
						<p>
							You have certain legal rights in relation to the processing of your
							personal data, including:
						</p>
						<ol>
							<li>
								<p>
									the right to obtain confirmation as to whether or not
									personal data concerning you are being processed, and, where
									that is the case, access to the personal data and the
									information regarding its processing;
								</p>
							</li>
							<li>
								<p>
									the right to obtain from us without undue delay the
									rectification of inaccurate personal data concerning you
									and, taking into account the purpose of the processing, the
									right to have incomplete personal information completed;
								</p>
							</li>
							<li>
								<p>
									the right to obtain from us the erasure of personal data
									concerning you without undue delay if one of the grounds set
									out in article 17 of the GDPR applies;
								</p>
							</li>
							<li>
								<p>
									the right to obtain from us restriction of processing where
									one of the grounds set out in article 18 of the GDPR
									applies;
								</p>
							</li>
							<li>
								<p>
									the right to data portability in accordance with article 20
									of the GDPR;
								</p>
							</li>
							<li>
								<p>
									the right to object at any time to processing of your
									personal data in accordance with article 21 of the GDPR;
								</p>
							</li>
							<li>
								<p>
									the right not to be subject to an automated individual
									decision-making, including profiling in accordance with
									article 22 of the GDPR.
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							The Customer should be aware that the above indicated rights may not
							be absolute – it depends on the particular Customer’s request and
							the purpose and / or basis for his / her personal data processing.
							Also this Policy does not deprive you of any other legal rights you
							may enforce under the applicable law.
						</p>
					</li>
					<li>
						<p>
							The Customer may exercise his / her rights only after the Company
							has successfully identified him / her. If the Company is not sure
							about the identity of the person sending data request, the Company
							may not provide the requested information to him / her, unless the
							Customer‘s identity is confirmed. Therefore, if you like to address
							a request towards the company regarding execution of your rights, we
							suggest you to do once you are logged in to your personal account on
							the Platform (so that we could identify you). In case you decide to
							use other communication channels, such as sending a request via
							email, kindly ask you to indicate in the e-mail your name, surname,
							your date of birth and the last four digitals of your identity
							document number which you used when entering into contractual
							relationship with the us. In addition, the Company keeps the right
							to decide if the other or additional legitimate mean of
							identification proof should be requested, such as a selfie with your
							ID document, certified copy of your ID document, video or voice
							call, or any other additional document or method which could let to
							determine your identity.
						</p>
					</li>
					<li>
						<p>
							The Customer is provided with information related to the exercise of
							his / her rights free of charge. However, the Customer's request for
							the exercise of rights may be waived or may be subject to an
							appropriate fee if the request is manifestly unfounded or excessive,
							in particular because of their repetitive character.
						</p>
					</li>
					<li>
						<p>
							The Company shall provide the Customer with information on the
							actions taken upon receipt of the Customer's request for the
							exercise of his rights or the reasons for the inaction no later than
							within 1 month from the receipt of the request. The period for
							submitting the requested information may be extended, if necessary,
							for 2 more months, depending on the complexity and number of
							requests. When the Customer submits the request by electronic means,
							the information shall also be provided by electronic means.
						</p>
					</li>
					<li>
						<p>
							If the Customer considers that his / her personal data is being
							processed in violation of his / her rights and legitimate interests
							in accordance with applicable law, the Customer shall have the right
							to file a complaint against the processing of personal data to the
							State Data Protection Inspectorate of the Republic of Lithuania.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<strong>YOUR RESPONSIBILITIES</strong>
				<ol>
					<li>
						<p>
							You confirm that you have provided correct data about yourself in
							every required form and that afterwards, when changing or adding any
							data at the Platform, you will enter only correct data. The Company
							will not tolerate invalid, false or otherwise incorrect data and
							will pursue actions in accordance with its legal obligations. You
							shall bear any losses that occur with regard to the submission of
							invalid, false or otherwise incorrect data.
						</p>
					</li>
					<li>
						<p>
							You are responsible for maintaining adequate security and control of
							every identification number, password, and / or any other code that
							you use to access the Platform. If you have not complied with this
							obligation and / or could, but have not prevented it and / or
							performed it on purpose or due to own negligence, you assume the
							losses and undertake to reimburse the losses of other persons
							incurred as a result of your (in)action.
						</p>
					</li>
					<li>
						<p>
							In the event of loss of any password by yourself or if the
							password(s) are disclosed not due to your or Company‘s fault, or in
							case of a real threat that has occurred or may occur to your
							account, you undertake to change the password(s) immediately or, if
							you do not have a possibility to do that, not later than within 1
							calendar day notify the Company. The Company shall not be liable for
							consequences that have originated due to the notification failure or
							unauthorised access to your account not due to the fault of the
							Company.
						</p>
					</li>
					<li>
						<p>
							After the Company receives the notification from you as indicated
							above, the Company shall immediately suspend access to your account
							and provision of the Company’s Services until a new password is
							provided / created for you.
						</p>
					</li>
					<li>
						<p>
							The Company draws your attention to the fact that your user ID,
							email address or any other contact information you have chosen to
							link to your account are used for your identification and
							communication. You undertake responsibility to protect these
							instruments and logins to them. You are responsible for password
							disclosure and for all operations performed after you use the
							password for a relevant account. We recommend to memorize your
							passwords and not to write them down or enter anywhere where they
							may be seen by other persons.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<strong>CONTACT DETAILS</strong>
				<ol>
					<li>
						<p>
							If you have any questions regarding this Policy or your personal
							data protection or if you want to withdraw your consent, or execute
							your rights you may contact our Data Protection Officer who monitors
							that your data processing executed by the Company complies with the
							applicable data protection laws. You can reach our Data Protection
							Officer via e-mail: dpo@pervesk.lt or mail via postal address: UAB
							“Pervesk”, address Rinktinės str. 5, Vilnius, the Republic of
							Lithuania, with a notice "Data Protection Officer".
						</p>
					</li>
				</ol>
			</li>
			<li>
				<strong>FINAL PROVISIONS</strong>
				<ol>
					<li>
						<p>
							This Policy shall be viewed and applied in accordance with the GDPR
							and other applicable laws.
						</p>
					</li>
					<li>
						<p>
							The Company reserves the right to make changes to this Policy from
							time to time. An up-to-date version of the Policy is posted on the
							Platform, therefore, please do review it regularly. Your continued
							use of the Platform and Services following any such revisions to the
							Policy will constitute your acceptance of such changes. If you do
							not agree to any such of such changes, do not continue to use our
							Services.
						</p>
					</li>
					<li>
						<p>
							The Company is not responsible for ensuring clients’ privacy in
							third parties’ websites, even in cases where the client has accessed
							third-party websites by using links provided on the Platform. The
							Company recommends that you familiarize yourself with the privacy
							policies of third-party websites beforehand.
						</p>
					</li>
				</ol>
			</li>
		</ol>`
	},
	perveskTermsAndConditions: {
		id: 'fe.pervesk_terms_and_conditions',
		defaultMessage: `<h1>General service agreement</h1>
		<ol>
			<li>
				<p>
					<strong> Terms Used in the Agreement </strong>
				</p>
				<ol>
					<li>
						<p>
							The Institution – UAB “Pervesk”, company code 304186270, registered
							address Ausros al. 68, LT-76233 Siauliai, Lithuania (correspondence
							address Vilniaus g. 31, Vilnius, Lithuania, e-mail address {link3}), acting as an
							electronic money institution licensed in the Republic of Lithuania
							(electronic money institution license No. 17, Issuing and
							Supervisory Authority – Bank of Lithuania, {link}; data about the Institution are collected and stored in the
							Register of Legal Entities of the Republic of Lithuania, the
							registrar – State Enterprise Center of Registers).
						</p>
					</li>
					<li>
						<p>
							Electronic signature is a means of safe electronic and mobile
							electronic signature issued by third parties, which the Institution
							deems to be the Means of Identification and which are used instead
							of the written signature of the Client and are intended to identify
							the User and to confirm the Orders submitted by the User to the
							Institution using Electronic Channels.
						</p>
					</li>
					<li>
						<p>
							Electronic Money is money deposited/transferred to the Account
							managed by the Institution on behalf of the Client for the purpose
							of making payments (in the Agreement, Electronic Money can be simply
							referred to as funds).
						</p>
					</li>
					<li>
						<p>
							Means of Identification are the login or code, registration
							password, Password Generator, or other means of authentication
							provided to the Client by the Institution for the purpose of
							verifying the User’s identity.
						</p>
					</li>
					<li>
						<p>
							Workday of the Institution is the day when the Institution carries
							out the activities necessary for the execution of payment
							transactions.
						</p>
					</li>
					<li>
						<p>
							Client is a person who has concluded this Agreement with the
							Institution.
						</p>
					</li>
					<li>
						<p>
							Order is an instruction issued by electronic channels to the
							Institution regarding management of funds in the Account or an
							instruction related to other actions regarding management of the
							Account or the services provided by the Institution.
						</p>
					</li>
					<li>
						<p>
							Account is an electronic money and payment account in the IBAN
							(International Bank Account Number) form
							No.____________________________________________ opened by the
							Institution on behalf of the Client to which the Client can
							deposit/transfer funds and store them, execute fund transfers and
							other payment transactions allowed by the Institution.
						</p>
					</li>
					<li>
						<p>
							Password Generator is an electronic device for generating unique
							passwords that are used instead of written Client’s signature and
							intended to identify the User and confirm the Orders sent to to the
							Institution by the User using electronic channels.
						</p>
					</li>
					<li>
						<p>
							Website is the website of the Institution, found at {link2}.
						</p>
					</li>
					<li>
						<p>
							Standard Rates – the rates approved by the Institution for the
							provision of services and transactions that are an integral and
							inseparable part of this Agreement.
						</p>
					</li>
					<li>
						<p>
							User is a Client or a representative of the Client specified in the
							Agreement (a natural person) who has the right to manage the
							Client’s Account using electronic channels and whose details are
							specified in the Special part of the Agreement.
						</p>
					</li>
					<li>
						<p>
							Unique Identifier is the Account number assigned to the Client by
							the Institution, which uniquely identifies the electronic money and
							payment account used for the payment transaction.
						</p>
					</li>
					<li>
						<p>
							Other terms used in the Agreement are in accordance with the terms
							defined by the Law on Payments of the Republic of Lithuania and the
							Law on Electronic Money and Electronic Money Institutions of the
							Republic of Lithuania.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> Application of the Agreement </strong>
				</p>
				<ol>
					<li>
						<p>
							The Agreement applies to all Clients, regardless of what kind of
							Institution’s services the Client uses, including one-time
							electronic money and payment services, as well as services provided
							according to the specific service agreement or any other
							Institution’s Electronic Money and Payment Services used by the
							Client.
						</p>
					</li>
					<li>
						<p>
							The Agreement, together with all annexes, amendments, supplements
							and references to the Website or other websites, is an integral and
							inseparable part of each Agreement concluded between the Institution
							and the Client regarding provision of a particular service and is
							applicable to the Client from the moment of its conclusion.
						</p>
					</li>
					<li>
						<p>
							If there are contradictions or inconsistencies between the specific
							service agreement (Annex) and this Agreement, then the terms of the
							specific service contract (Annex) shall apply, unless otherwise
							specified therein.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> Subject of the Agreement </strong>
				</p>
				<ol>
					<li>
						<p>
							The Institution hereby undertakes to issue, hold and redeem
							electronic money, provide the payment services specified on the
							Website, and provide the User with the opportunity to submit the
							Orders by electronic digital means and thus manage the funds in the
							Account. Unless otherwise specified in the Agreement, the User, who
							has signed this Agreement, shall be entitled, using electronic
							communication means, to manage all Client’s Accounts opened at the
							Institution, including the Accounts which the Institution will open
							for the Client in the future after the signing of this Agreement, in
							which the Institution is authorized to perform operations, and to
							use other services provided by the Institution (including the
							electronic signing of contracts) if the Institution permits such
							actions.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> The Institution Undertakes: </strong>
				</p>
				<ol>
					<li>
						<p>
							To provide, for the fees established by the Institution, Electronic
							Money and Payment Services, issue or change the means of
							identification for the Client or the User that are used for
							accessing the Account by electronic communication means and
							submission of Orders;
						</p>
					</li>
					<li>
						<p>
							Deem the User’s identity to be confirmed and allow the User to use
							the remote electronic services, provided the correct User
							Identification Means were used during the login to the Account.
							Orders, applications, notices or other actions performed by the User
							by electronic communication means shall be separately approved using
							appropriate Identification Means;
						</p>
					</li>
					<li>
						<p>
							To execute the Orders submitted by the User using electronic
							channels within the terms indicated in the Agreement and/or the
							legal acts, provided:
						</p>
						<ol>
							<li>
								<p>
									The Orders submitted by the User using electronic means of
									communication to execute transactions in the Account meet
									the conditions of the Agreement, the requirements of legal
									acts and other requirements established by the Institution;
								</p>
							</li>
							<li>
								<p>
									The Account has sufficient funds for the execution of the
									submitted Order and the fee for the execution of the Order
									according to the rates approved by the Institution;
								</p>
							</li>
							<li>
								<p>
									The funds in the Account are not seized and there is no
									other restriction on the management of funds in the Account;
								</p>
							</li>
							<li>
								<p>
									The Orders are not subject to any restrictions stipulated by
									other legal acts or the Account Agreement concluded between
									the Institution and the Client, when the Institution is
									entitled or obliged not to execute the Orders to debit funds
									from the Client’s Account;
								</p>
							</li>
							<li>
								<p>
									The Client does not exceed the transaction limit imposed by
									the Institution on a particular Means of Identification or
									the Account or chosen by the Client.
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>Provide advice to the Client on using the Account remotely.</p>
					</li>
					<li>
						<p>
							To provide, on paper or on another durable medium (including
							e-mails), information on the terms and conditions of this Agreement
							and the provision of Electronic Money and Payment Services to the
							Client.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> The Client or the User Undertakes: </strong>
				</p>
				<ol>
					<li>
						<p>
							To comply with the obligations and requirements of the Agreement and
							the legal acts;
						</p>
					</li>
					<li>
						<p>
							To ensure that the Account and the Means of Identification provided
							will only be used and accessed by the Users specified in the
							Agreement;
						</p>
					</li>
					<li>
						<p>
							To deem that the User’s Identity is established and the Orders,
							notices or other actions submitted to the Institution using the
							electronic communication means are properly authorized and assume
							all obligations arising from such actions if the appropriate User
							Means of Identification were used at the time of the remote login to
							the Account and the submission of the Orders;
						</p>
					</li>
					<li>
						<p>
							To ensure the security of the Means of Identification and payment
							instruments provided by the Institution, to take actions to protect
							the individual security features of the Means of Identification and
							payment instruments; not to write down the data of the Means of
							Identification and payment instruments on the items hold together
							with them in one place; not to allow third parties to access and/or
							manage them. If the User suspects that the Means of Identification
							or the payment instrument is or can be used without authorization,
							the User has lost it, it has been seized by other person, or the
							User cannot manage it for other reasons, the User shall immediately,
							and not later than within one working day, inform the Institution
							about it.
						</p>
					</li>
					<li>
						<p>
							To pay the transaction and service fees approved by the Institution
							and to ensure that the Account has sufficient funds to execute the
							Orders and pay the applicable fees for issuing and changing of the
							Means of Identification and payment instruments, for the execution
							of Orders provided by electronic communication means and other
							services provided by the Institution;
						</p>
					</li>
					<li>
						<p>
							Upon expiry of the Agreement and/or its termination or at the
							request of the Institution, to return the Means of Identification to
							the Institution;
						</p>
					</li>
					<li>
						<p>
							To provide the Institution with the right to record communication
							between the Institution and the Client/User using telephone or other
							communication means, when the Client/User requests to block the
							provision of remote electronic services or to cancel this blocking.
							Communication records are considered evidence in possible disputes.
						</p>
					</li>
					<li>
						<p>
							Immediately, but not later than within three working days, to inform
							the Institution if the Client’s address, account numbers, mobile
							telephone number or other information and contact details specified
							in the Special part of the Agreement change. If the Client fails to
							comply with this requirement, the Client can not make any claims and
							objections that the actions of the Institution carried out using the
							latest known details of the Client, do not conform to the Agreement
							or that he has not received any communications sent using those
							contact details.
						</p>
					</li>
					<li>
						<p>
							At his own expense, upon request of the Institution, to submit all
							documents and information required by the Institution within the
							deadline specified by the Institution. The Client undertakes to
							submit the documents in the form and language as requested by the
							Institution. If the Client violates the obligations stipulated in
							this clause, the Institution has the right to demand that the Client
							compensates for losses caused by the violation (including, but not
							limited to, the costs for the translation, delivery, and approval of
							the documents).
						</p>
					</li>
					<li>
						<p>
							To guarantee and to ensure that any documents and information
							submitted by the Client or the User to the Institution are correct,
							accurate, and complete.
						</p>
					</li>
					<li>
						<p>
							To actively participate in any investigation related to the Client’s
							or User’s Account, activity or payment transactions, to cooperate in
							providing the Institution with all information and documents
							requested by the Institution.
						</p>
					</li>
					<li>
						<p>
							To prevent any other unauthorized persons and persons unknown to the
							Institution from using the Account and/or services on behalf of the
							Client.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>
						Provision, Use, Change, and Blocking of the Means of Identification
					</strong>
				</p>
				<ol>
					<li>
						<p>
							The Institution and the Client agree that the Means of
							Identification provided to the User by the Institution are used to
							confirm the User’s identity. If a valid Means of Identification of
							the User have been used at the time of login to the Account, the
							User’s identity is deemed to have been confirmed. Orders, requests,
							messages or other actions carried out by the User using electronic
							means of communication will only be executed when they are confirmed
							by the Electronic Signature or the codes generated by the Password
							Generator. Orders electronically submitted to the Institution and
							approved using the Means of Identification, are in all cases deemed
							equivalent to the orders signed by the Client and submitted to the
							Institution; and the agreements concluded with the Institution using
							electronic means of communication are in all cases deemed equivalent
							to the signed agreements concluded between the Client and the
							Institution.
						</p>
					</li>
					<li>
						<p>
							The User uses the services of the Institution via the Internet, by
							accessing the server specified by the Institution. The Institution
							identifies the Client by the login name or code given to the User,
							the registration password and confirmation passwords generated by
							the Password Generator, or the Electronic Signature. The login name
							or code is given to the User upon signing the Agreement and is valid
							for the whole period of validity of the Agreement.
						</p>
					</li>
					<li>
						<p>
							The Client undertakes to ensure that the Means of Identification
							will only be known to the Clients specified in the Agreement, and
							neither the Client nor the User will transfer them to third parties.
							If, due to the fault of the User, the Means of Identification are
							used by a person who does not have such right, the Order received by
							the Institution, its change or cancellation is deemed to be
							submitted by the User.
						</p>
					</li>
					<li>
						<p>
							If the User has lost the Password Generator or mobile phone with the
							electronic signature certificate installed, and if there is a
							possibility that it has been or can be unlawfully used by third
							parties to access the Account, the Client or the User undertakes to
							immediately, but not later than within one business day, submit to
							the Institution a request to block the Account and the provision of
							services. The request can be presented orally, by phone no.
							______________________, upon arrival at the Institution, in writing,
							by e-mail or remotely submitting a request signed by the Electronic
							Signature. When submitting the request, the Client or the User must
							indicate his/her full name, personal identification number and the
							reason for which the provision of services is requested to be
							blocked. The Institution is entitled to require additional
							information to identify the person submitting the request. The
							Institution blocks the provision of services on the basis of the
							received request.
						</p>
					</li>
					<li>
						<p>
							The Institution also has the right to block the use of the Account
							and the provision of services:
						</p>
						<ol>
							<li>
								<p>
									If the Institution has been notified of the loss or
									disclosure of the Means of Identification to a third party,
									or there are reasonable grounds for believing that the Means
									of Identification or other sensitive information of the
									Client may become known or has become known (available) to
									third parties;
								</p>
							</li>
							<li>
								<p>
									If incorrect verification passwords from the Means of
									Identification were submitted three times in a row before
									the use of the Institution’s services;
								</p>
							</li>
							<li>
								<p>
									If the Client does not provide the Institution with the
									information and/or documents which he/she is required to
									submit to the Institution in accordance with this Agreement
									or other agreements between the Institution and the Client
									or legal regulations;
								</p>
							</li>
							<li>
								<p>
									If there are objectively justified reasons related to the
									security of the Client’s funds;
								</p>
							</li>
							<li>
								<p>
									If it is suspected that the Account, the payment instruments
									and/or funds are used or may be used for illegal, fraudulent
									or criminal conduct;
								</p>
							</li>
							<li>
								<p>
									If the Client violates the terms of this Agreement or other
									agreements between the Institution and the Client and/or
									legal acts;
								</p>
							</li>
							<li>
								<p>
									If it is suspected that the Account, payment instruments
									and/or funds may be unlawfully used by unauthorized third
									parties;
								</p>
							</li>
							<li>
								<p>
									If the Institution has suspicions about the identity of the
									Client and/or his representative and/or origin of funds;
								</p>
							</li>
							<li>
								<p>
									In other cases provided for in this Agreement, other
									agreements between the Institution and the Client and legal
									acts.
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							The blocking of the access to the Account and services is revoked
							upon the Client’s arrival at the Institution and upon submission of
							a written request or upon remote submission of the request verified
							by the Electronic Signature. The Institution has the right to refuse
							revoke the blocking if there are reasons to believe that the reasons
							for blocking have not been removed. If the access to the Account and
							services has been blocked at the Institution’s initiative, the
							blocking is only revoked when, according to the Institution’s
							evaluation, there are no more reasons for blocking.
						</p>
					</li>
					<li>
						<p>
							The Institution is not liable for Client’s losses arising from the
							use of the Account and its blocking and revoking thereof, if the
							Institution has acted in compliance with the terms and conditions
							stipulated in the Agreement or legal acts.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> Execution of Payment Transactions </strong>
				</p>
				<ol>
					<li>
						<p>
							In order to make a payment transaction, the User, having
							electronically logged in using the server address specified by the
							Institution and using the Means of Identification, shall instruct
							the Institution regarding the execution of a particular payment
							transaction, and shall provide the Unique Identifier and/or other
							information required by the Institution. The Order and the payment
							transaction data are submitted electronically prior to the execution
							of the payment transaction. Other submission methods are only
							possible on the basis of a separate agreement between the Client and
							the Institution. The submission of the Order is deemed to be the
							consent of the User to authorize the payment transaction. Until the
							execution of the Order, the User has the right to cancel the payment
							transaction following the same procedure.
						</p>
					</li>
					<li>
						<p>
							The Client agrees with the fact that the Institution, when executing
							the Client’s Order and the payment transaction, transfers the data
							related to the Client, his personal and other data, the Order and
							the payment transaction to third parties related to the execution of
							the Order and the payment transaction.
						</p>
					</li>
					<li>
						<p>
							The Institution has the right to refuse to execute the Order and
							payment transaction and to start the inspection if the Institution
							has any suspicions that the Order and payment transaction may
							violate or violate this Agreement, any other agreements between the
							Client and the Institution, and/or legal acts, or there are
							suspicions that the Order was not submitted by the Client or his
							legal representative, illegal funds may be used for execution of the
							Order, if there are insufficient data or other deficiencies in the
							Order, as well as in the failure of interbank and/or other financial
							systems, there are other unusual market conditions, important
							technical or other reasons, or the risk associated with the
							execution of the Order is too high and unacceptable to the
							Institution.
						</p>
					</li>
					<li>
						<p>
							The Institution shall credit the funds to the Account and debit the
							Account according to the Unique Identifier specified in the Order
							received by the Institution. If, in addition to the Unique
							Identifier, the Order contains additional information, the
							Institution is only responsible for the execution of a payment
							transaction in accordance with the Unique Identifier specified in
							the Order. The Institution has the right not to check whether the
							Unique Identifier is in compliance with the Account holder’s name
							and surname. If the Institution carries out such an inspection and
							identifies the apparent mismatch between the Unique Identifier and
							the Account holder’s name and surname submitted to the Institution,
							the Institution shall be entitled to refrain from executing such a
							payment transaction.
						</p>
					</li>
					<li>
						<p>
							If the User, when submitting the Order, indicates a Unique
							Identifier, such Order is considered to be executed properly if it
							has been executed according to the specified Unique Identifier. If
							the Unique Identifier provided by the User is incorrect, the
							Institution shall not be liable for failure or improper execution of
							the payment transaction, but shall make an attempt to recover the
							funds of the payment transaction. If the User specifies not only the
							Unique Identifier but also provides additional information, the
							Institution shall only be responsible for the execution of payment
							transactions in accordance with the Unique Identifier specified by
							the User.
						</p>
					</li>
					<li>
						<p>
							The Order is deemed received at the Institution (the count down for
							the execution of such an Order begins) on the day it is received,
							and if the receipt of the Order is not an Institution’s business
							day, it shall be presumed that the Order has been received on the
							next business day of the Institution. An Order received by the
							Institution on the Institution’s business day past the time set by
							the Institution is deemed to have been received on the next business
							day of the Institution.
						</p>
					</li>
					<li>
						<p>
							The Institution has the right to determine the mandatory information
							to be submitted to the Institution in order for the Order to be
							properly executed. The Client’s Order shall comply with the
							requirements established by the Institution, the agreements
							concluded between the Institution and the Client and the legal
							requirements for the submission of the Order and/or its content. The
							Client’s Order shall be worded clearly, unambiguously, executable,
							and it shall clearly express the will of the Client. The Institution
							is not liable for any errors, inconsistencies, repetitions and/or
							contradictions contained in the Client’s Order, including, but not
							limited to, the accuracy of the Client’s details.
						</p>
					</li>
					<li>
						<p>
							The Institution and the Client may agree on a limit on the payment
							transactions, which shall also be indicated to the Client on the
							Website and/or the Account. The Institution also has the right,
							unilaterally, without the Client’s consent to impose the limits on
							the Account, payment transactions and other services provided by the
							Institution.
						</p>
					</li>
					<li>
						<p>
							Any funds received by the Institution from or on behalf of the
							Client are not considered a deposit or other refundable funds, the
							Institution does not pay interest on it.
						</p>
					</li>
					<li>
						<p>
							Depending on the agreement between the Parties, execution of the
							Order may be started on a specific day or at the end of a certain
							period or on the day when the Client submits funds to the
							Institution.
						</p>
					</li>
					<li>
						<p>
							The Institution grants the possibility for the Client to use the
							funds received in the Account as soon as this amount is credited to
							the Institution’s account opened in a bank or other financial
							institution and the Institution receives all the information
							necessary for that, provided that the funds are received before the
							latest time for crediting funds specified in the Agreement (or
							another official source published by the Institution).
						</p>
					</li>
					<li>
						<p>
							When payment transactions are conducted in Euro in Lithuania or in
							other Member States of the European Union, the Institution
							undertakes to ensure that, upon receipt of the Order, the payment
							transaction is executed on the same business day (when the payer’s
							and payee’s accounts are both opened at the Institution) or at the
							latest by the end of the next business day of the Institution (when
							the payee’s account is opened at another financial institution).
						</p>
					</li>
					<li>
						<p>
							The duration of the provision of other services is defined in the
							respective service agreements, in the Standard Rates or on the
							Website (or in other official source published by the Institution).
						</p>
					</li>
					<li>
						<p>
							If the Client (the payer) has initiated a payment order, the
							Institution shall be responsible for the proper execution of the
							payment transaction. If the Institution can prove to the Client (the
							payer) and, when appropriate, the payee’s payment service provider
							that the payee’s payment service provider has received the payment
							transaction, the payment service provider of the payee is
							responsible to the payee for the proper execution of the payment
							transaction.
						</p>
					</li>
					<li>
						<p>
							The Client must check at least once a month the information on
							payment transactions executed in the Account and to inform the
							Institution in writing (by e-mail) about any unauthorized or
							inappropriately executed payment transactions, the funds that do not
							belong to the Client credited to the Client’s Account and any other
							mistakes, inconsistencies or inaccuracies in the Account and in
							related payment transactions. The Client’s notification must be
							submitted promptly, but not later than within 30 calendar days from
							the day the Institution has executed the payment transaction which
							is indicated by the Client as unauthorized or improperly executed.
							If the Client does not submit any such notifications by the
							specified time, he/she shall be deemed to have unconditionally
							agreed with the payment transactions executed in the Account.
						</p>
					</li>
					<li>
						<p>
							The institution, having received the Client’s notification about an
							unauthorized payment transaction and convinced that such transaction
							does not arise from intentional acts, gross negligence or dishonesty
							of the Client, shall immediately return the amount of the
							unauthorized payment transaction to the Client and restore the
							balance on the Account from which this amount was subtracted, should
							the unauthorized payment transaction would not have been performed,
							except in cases stipulated in this Agreement, where the Client has
							the responsibility for the unauthorized payment transaction.
						</p>
					</li>
					<li>
						<p>
							The Institution has the right to debit the funds incorrectly
							credited to the Client’s Account. If the Account does not have
							enough funds to debit the incorrectly credited funds, the Client
							undertakes, without any reservation, to return to the Institution
							the funds credited incorrectly within 3 (three) business days from
							the day the Institution’s request is received.
						</p>
					</li>
					<li>
						<p>
							The Client (the payer) has a right to receive back from the
							Institution the full amount of an authorized and already executed
							payment transaction initiated by the payee or via the payee,
							provided the following conditions are met: 1) the exact amount of
							the payment transaction was not indicated in when authorizing the
							payment transaction; 2) the amount of the payment transaction
							exceeds the amount which the Client (the payer) could have
							reasonably expected, taking into account his previous expenses, the
							terms of this Agreement and other circumstances, except for the
							circumstances related to the currency exchange, when the currency
							exchange rate was used in the course of the payment transaction, for
							which the Client (the payer) has agreed with the Institution in
							accordance with the procedure established by this Agreement and/or
							legal acts. At the request of the Institution, the Client (the
							payer) must provide information on the conditions specified in this
							clause.
						</p>
					</li>
					<li>
						<p>
							The Client (the payer) has no right to receive back the amount of
							payment transactions initiated by the payee or via the payee, if the
							Client (the payer) has given the Institution consent to execute the
							payment transaction and the Institution has provided the Client (the
							payer), in a manner agreed upon, the information about the future
							payment transaction or provided the conditions for access to it at
							least four weeks before the scheduled payment transaction is
							completed.
						</p>
					</li>
					<li>
						<p>
							The Client (the payer) has the right to ask the Institution to
							return the amount of the authorized payment transaction initiated by
							the payee or via the payee within eight weeks from the day the funds
							were debited from the Account.
						</p>
					</li>
					<li>
						<p>
							The Institution, upon receipt of an application for refund of the
							payment transaction, shall refund the full amount within ten working
							days or indicate the reasons for which it refuses to refund it, and
							if the Client (the payer) is a consumer, the Institution shall
							specify the procedure for appeal of such refusal.
						</p>
					</li>
					<li>
						<p>
							When the payment transaction is initiated by the payee or via the
							payee, the Client (the payer) cannot cancel the payment transaction
							after the payment transaction has been sent or the Client (the
							payer) has given the consent to execute the payment transaction. The
							Institution is not responsible for the fact that the payee submits
							the payment order without complying with the terms established in
							the agreement with the Client (the payer).
						</p>
					</li>
					<li>
						<p>
							If the amount specified in the Order is refunded due to reasons
							beyond the control of the Institution, the amount to be refunded
							shall be credited to the Client’s Account. Fees paid by the Client
							for the execution of the Order are not returned to the Client, and
							the fees and expenses of the Institution related to the refund of
							money may be debited from the Client’s Account.
						</p>
					</li>
					<li>
						<p>
							The Institution is entitled to unilaterally, without the Client’s
							consent, suspend the provision of services, the access to the
							Account, the issuance of Electronic Money, redemption and reception
							of payment transactions, authorization, payment of funds to the
							Client and/or third parties, if the Client in any way violates the
							legal acts, the Agreement or other obligations of his, or the
							Institution has reasonable suspicions that the Client may be in
							breach of his obligations. The suspension shall take place until the
							Client has eliminated the violations, provided the violation does
							not constitute grounds for termination of the Agreement.
						</p>
					</li>
					<li>
						<p>
							All information on Electronic Money and payment transactions, their
							data, terms of execution, fees, etc. is available to the Client at
							any time by logging into the Account. By logging into the Account,
							the Client may also receive the Account Statement with this
							information.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> Fees </strong>
				</p>
				<ol>
					<li>
						<p>
							The Client undertakes to pay for the issuance or change of the Means
							of Identification, to pay for the use of electronic services the
							fees specified in the Standard Rates and/or rates specified in the
							agreements concluded between the Institution and the Client; and the
							Institution shall be entitled, without a separate notice and
							Client's consent, during or after the execution of the payment
							transaction to debit the fees from any Client’s Account opened at
							the Institution.
						</p>
					</li>
					<li>
						<p>
							The fees for the specific services of the Institution, the currency
							exchange rate, their calculation, as well as other amounts payable
							to the Institution (including, but not limited to, the costs
							incurred by the Institution) are specified in the Standard Rates and
							on the Website.
						</p>
					</li>
					<li>
						<p>
							The Client declares that, at the time of conclusion of this
							Agreement, he is familiar with the rates for the Institution’s
							services and operations (including, but not limited to, the Standard
							Rates) and, when initiating services and operations, agrees to pay
							the established fee, and, in addition, undertakes to hold in the
							Account an amount of funds that would cover the fees to be paid to
							the Institution and other amounts. If the Account does not have
							enough funds to execute the payment transaction and pay the fee for
							its execution, the Institution shall have the right not to execute
							such a payment transaction.
						</p>
					</li>
					<li>
						<p>
							The Institution has the right to unilaterally change the fees and
							fees set forth in the Institution’s agreements and/or the Standard
							Rates and undertakes to publish them in accordance with the
							procedures established by the Institution’s agreements and/or legal
							acts. The Parties agree that these changes are are publicly
							available on the Website immediately after their entry into force.
						</p>
					</li>
					<li>
						<p>
							When the Institution’s refusal to execute a payment order is
							objectively justified, the Institution may charge a standard fee
							specified in the Standard Rates for such a refusal.
						</p>
					</li>
					<li>
						<p>
							The Institution is entitled to charge a fee from the Client for the
							refund of funds if the payment transaction has not been executed or
							failed due to an incorrect unique identifier, other incorrectly
							provided/inaccurate Client’s or User’s information for execution of
							the payment transaction or if the refund arises from a violation of
							the Agreement by the Client or the User.
						</p>
					</li>
					<li>
						<p>
							The Institution, in accordance with this Agreement, other agreements
							concluded between the Institution and the Client and legal acts, has
							the right to charge fees defined in the Standard Rates for the
							cancellation of the Order or the notice of refusal to execute the
							Order.
						</p>
					</li>
					<li>
						<p>
							Additional or more frequent information provided at the request of
							the Client’s or the transmission of information by means of
							communication other than those specified in this Agreement, may be
							subject to an extra fee specified in the Standard Rates.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> Liability of the Parties </strong>
				</p>
				<ol>
					<li>
						<p>
							The Institution is liable for incorrectly executed transactions in
							the Account in accordance with the procedure established by the
							legal acts of the Republic of Lithuania.
						</p>
					</li>
					<li>
						<p>
							The Client assumes full responsibility for the correctness of the
							information entered in the agreements and payment documents and
							Orders using remote electronic communication means.
						</p>
					</li>
					<li>
						<p>
							The Client assumes full responsibility for all operations executed
							in the Account and concluded agreements using electronic
							communication means, provided the appropriate Means of
							Identification were used when logging to the services of the
							Institution.
						</p>
					</li>
					<li>
						<p>
							The Client is liable for all losses incurred by the Institution due
							to incorrect information provided to the Institution, invalid
							documents, false payment orders and/or non-performance of other
							obligations stipulated in the Agreement.
						</p>
					</li>
					<li>
						<p>
							The responsibility of the Institution for the identification of the
							User shall be limited only to verifying the Means of Identification
							provided to the User.
						</p>
					</li>
					<li>
						<p>
							It is prohibited for the Client and the User to use the Means of
							Identification to perform or to allow third parties to perform any
							actions aimed at altering, disrupting or otherwise influencing the
							provision of the Institution’s services (operation). In the event of
							such modifications or attempts, the Institution is exempted from any
							liability or obligation arising from the execution of this
							Agreement.
						</p>
					</li>
					<li>
						<p>
							The Institution accepts no liability and is not responsible for the
							compliance of the Client’s payment documents received using
							electronic communication means with their originals and the accuracy
							or veracity of the data contained therein.
						</p>
					</li>
					<li>
						<p>
							The Institution is not responsible for the fact that the Means of
							Identification chosen by the User was not functioning or was
							functioning improperly, the User did not have phone, computer,
							software or other equipment or because of the failure of this
							equipment or if the Client did not protect his/her passwords or the
							Means of Identification and, therefore, passwords or the Means of
							Identification have become known to other persons.
						</p>
					</li>
					<li>
						<p>
							The Institution is not responsible for the fact that due to a
							failure in telecommunication networks the Client is unable to use
							the services of the Institution or because of the failure in
							telecommunication networks the information was corrupted, lost, etc.
						</p>
					</li>
					<li>
						<p>
							The Institution is not responsible for the fact that due to
							technical works and/or disruption related to the use of the
							information technology used by the Institution, the Client is not
							able to use the services of the Institution, except for cases when
							that lasts for more than 24 hours and occurs due to the intentional
							or gross negligence of the Institution.
						</p>
					</li>
					<li>
						<p>
							In the event of an executed payment transaction received from the
							Client by electronic communication means failing to correspond to
							the printed statement of this payment submitted by the Client, the
							Parties, in resolving their disputes, shall refer to the Client’s
							payment transaction received by electronic communication means and
							the data defining it as the true indicator.
						</p>
					</li>
					<li>
						<p>
							The Client or the User specified by him shall be jointly and
							severally liable for non-performance or improper performance of the
							Agreement. If the Client grants the User the right to manage the
							Account, the User shall be obliged to execute properly all
							obligations assumed by the Client in accordance with this Agreement.
						</p>
					</li>
					<li>
						<p>
							The Client must fully compensate for the losses incurred by the
							Institution arising from the disclosure of the Means of
							Identification or the loss of the Password Generator, mobile
							telephone (with the electronic signature certificate) or any other
							violation of this Agreement.
						</p>
					</li>
					<li>
						<p>
							The Client (the payer) is liable for unauthorized payment
							transactions up to €150 when these losses are incurred due to: 1)
							the use of a lost or stolen payment instrument; 2) the illegitimate
							acquisition of the payment instrument if the Client (the payer)
							failed to protect personalized security features.
						</p>
					</li>
					<li>
						<p>
							In the circumstances specified in Clause 9.14 of the Agreement, the
							Client (the payer) is liable for losses incurred by unauthorized
							payment transactions up to €50, provided the following conditions
							are met: 1) the payment transaction has been executed using the data
							authentication procedure which ensures the confidentiality of the
							Client, which uses two or more elements divided into the categories
							of knowledge, ownership and specificity, detailed in the legislation
							of the Institution’s supervisory authority, where if one of them is
							compromised, the reliability of other elements are unaffected; 2) an
							element used for the Client’s authentication procedure belongs to
							the category of ownership and it is protected against unauthorized
							copying and online theft, and its generated information can be used
							only once.
						</p>
					</li>
					<li>
						<p>
							The Client (the payer) is liable for all losses arising from
							unauthorized payment transactions if the Client (the payer) has
							suffered from them acting in bad faith or due to gross negligence or
							wilful misconduct of one or several of the obligations specified in
							Article 26 of the Law on Payments of the Republic of Lithuania.
						</p>
					</li>
					<li>
						<p>
							In no event shall the Institution be liable for indirect Client’s
							losses (including, but not limited to, loss of income) arising from
							the use of the services by the Client and/or on any other basis.
						</p>
					</li>
					<li>
						<p>
							If it is not precluded by the applicable law or otherwise stated in
							this Agreement, should the Institution breach this Agreement, the
							compensation payable to the Client by the Institution will not
							exceed the average of the fees paid by the Client the Institution in
							the last 3 months before the violation; but in any case not more
							than €5.
						</p>
					</li>
					<li>
						<p>
							The Institution is not liable for the fact that the user was not
							able to access the third party external portal due to failures of
							the telecommunication networks for which the Institution is not
							responsible, or such failures resulted in the loss or corruption of
							the Client’s authentication data transferred by the Institution to
							the third party.
						</p>
					</li>
					<li>
						<p>
							The Institution is not responsible for the actions and mistakes of
							financial institutions and other entities involved in the process of
							payment transactions, as well as for illegitimate actions of other
							third parties and losses incurred by the Client due to Account
							blocking and/or suspension of services.
						</p>
					</li>
					<li>
						<p>
							The Institution is not responsible for third party services and
							products and their quality, malfunctions of third party electronic
							systems while the Client is accessing third-party systems or is
							paying for the goods or services provided by third parties while
							using electronic services of the Institution; also, the Institution
							assumes no responsibility and does not guarantee that third parties
							will execute a transaction with the Client. Claims regarding
							electronic systems of third parties, their goods and services are
							not examined by the Institution; they must be provided directly to
							third parties.
						</p>
					</li>
					<li>
						<p>
							A Party is released from liability for non-performance of the
							Agreement if it proves that the Agreement has not been executed due
							to a force majeure. The parties must notify in writing (including
							e-mail) about the occurrence of force majeure circumstances that
							prevent the fulfilment of the Agreement within 14 (fourteen)
							calendar days from the date of the occurrence of these
							circumstances.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> Personal Data </strong>
				</p>
				<ol>
					<li>
						<p>
							The Client agrees that the Institution shall process the personal
							data of the Client which are necessary for the execution of this
							Agreement and the provision of services, as well as for the
							execution of other agreements between the Institution and the Client
							and the fulfilment of the aims provided for therein.
						</p>
					</li>
					<li>
						<p>
							The Client undertakes to familiarize himself/herself with and comply
							with the rules established by the Institution for the processing of
							personal data, which are published on the Website or otherwise
							submitted to the Client. The Client is also required to ensure that
							the designated related and/or authorized persons, whose personal
							data the Client has submitted to the Institution, will familiarize
							themselves with the rules and conditions for the processing of
							personal data of the Institution before the date of signing the
							Agreement, and the persons related to the Client will agree to these
							terms and conditions.
						</p>
					</li>
					<li>
						<p>
							The Institution undertakes to process the Client’s personal data in
							compliance with the legal acts regulating the processing of personal
							data.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>
						Conditions for Correspondence Between the Institution and the Client
					</strong>
				</p>
				<ol>
					<li>
						<p>
							The Agreement is concluded and all communications between the
							Parties are sent in Lithuanian and, if the Client is a foreigner, in
							English, unless the Parties agree on another language acceptable to
							them or the Website indicates that another language is acceptable to
							the Institution. All notices (including information on payment
							transactions) to the Client are sent by the Institution to the
							Client by e-mail, submits to the Account, uploads on the Website or
							provides by other electronic channels. Information about the Account
							and payment transactions shall be provided to the Client on a
							regular basis, at least once a month. The Client is also able to
							access the information relevant to him when logged in to the Website
							and the Account.
						</p>
					</li>
					<li>
						<p>
							The Client has the right to receive information on the terms and
							conditions of this Agreement and payment services in writing or by
							e-mail; he can also find the terms of this Agreement and the
							provision of payment services on the Website at any time.
						</p>
					</li>
					<li>
						<p>
							The Client submits his notices to the Institution by e-mail or via
							the Website, or he may also contact the Institution by telephone or
							other means specified on the Website. The Institution has the right
							to request the the Client to send a message, information or
							documents at a particular time in any other manner and form
							requested by the Institution (e.g., by registered mail, etc.), and
							the Client undertakes to do so at his own expense.
						</p>
					</li>
					<li>
						<p>
							Notices, information or documents submitted by the Client are deemed
							received by the Institution when the Institution confirms to the
							Client that the relevant notice, information or document has been
							received.
						</p>
					</li>
					<li>
						<p>
							Notices sent to the Client by the Institution cannot be considered
							as an offer by the Institution to the Client to conclude an
							agreement or to use the services, unless the Institution’s statement
							expressly states that such a tender is offered.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> Duration, Amendment and Termination of the Agreement </strong>
				</p>
				<ol>
					<li>
						<p>
							The Agreement enters into force on the day it is signed and is valid
							indefinitely until the termination of the Agreement. The Agreement
							automatically expires on the same day when all account agreements
							concluded with the Institution are terminated.
						</p>
					</li>
					<li>
						<p>
							The Client is entitled to unilaterally, out of court, terminate this
							Agreement by giving written notice to the Institution not later than
							30 (thirty) calendar days in advance, except in cases provided for
							in the Electronic Money and Payment Account Agreement. In this case,
							the Client must fully settle with the Institution. The Client is not
							entitled to a refund of the paid fees.
						</p>
					</li>
					<li>
						<p>
							Upon termination of the Agreement, the funds available in the
							Client’s Account (after deduction of fees payable to the Institution
							and other amounts) are returned to the Client in the account
							specified by him in another financial institution. If the Client
							does not indicate before the termination of the Agreement the
							account to which the Institution should transfer funds, the
							Institution is entitled to transfer the Institution’s funds to the
							last Client’s account known to the Institution in another financial
							institution.
						</p>
					</li>
					<li>
						<p>
							The Client, upon termination of the Agreement for more than 12
							(twelve) months or for an indefinite term, shall not pay any fee to
							the Institution after 12 (twelve) months from the date of conclusion
							of the Agreement. In all other cases, the Client shall pay to the
							Institution the fee specified in the Standard Rates for termination
							of the Agreement.
						</p>
					</li>
					<li>
						<p>
							The Institution shall have the right, unilaterally, out of court and
							without giving reasons, to terminate this Agreement by giving the
							Client written notice on paper or using another durable medium (e.g.
							e-mail) no later than 60 calendar days prior to the termination of
							the Agreement.
						</p>
					</li>
					<li>
						<p>
							The Institution has the right to unilaterally and out of court,
							given a prior 14 (fourteen) calendar days notice to the Client,
							terminate the Agreement if the Client does not fulfil or improperly
							performs the obligations provided for in the Agreement, refrains
							from providing required information to the Institution or it becomes
							evident that the Client, at the time of concluding the Agreement or
							later submitted to the Institution incorrect or misleading
							information, or it becomes clear that the Client engages in
							activities unacceptable to the Institution, illegal activities
							related to money laundering and/or terrorist financing, or actions
							performed by the Client have damaged or could have damaged the
							Institution’s reputation or in other cases defined in the Agreement.
						</p>
					</li>
					<li>
						<p>
							The termination of the Agreement does not relieve the Client from
							the proper fulfilment of obligations arising from this Agreement
							before the day of its termination.
						</p>
					</li>
					<li>
						<p>
							The Parties agree that after the signing of this Agreement by the
							Client and the Institution, it will be deemed that the previous
							agreements governing the relations between the Parties arising from
							the use of electronic services by the Client will be terminated and,
							in the event of a dispute, the Parties will follow the latest
							agreement concluded between the Parties, governing the analogous
							relations.
						</p>
					</li>
					<li>
						<p>
							The terms of the Agreement may be changed by written agreement
							between the Parties, except in cases stipulated by the Agreement,
							where the Institution has the right to modify the Agreement
							unilaterally.
						</p>
					</li>
					<li>
						<p>
							The Institution has the right to unilaterally change the terms of
							the Agreement (including the fees of services) by giving the Client
							a written notice (by e-mail) 30 calendar days in advance, except for
							the cases when the amendments are aimed at improving the terms and
							conditions for the provision of services to the Client. The
							amendments to the Agreement shall be deemed approved and agreed with
							the Client if the Client does not submit a written notice of
							disagreement before the date of entry into force of the amendment
							specified in the notice of amendment. The Client’s use of the
							services of the Institution after the effective date of the
							amendment of the Agreement terms constitutes the Client’s consent to
							the amendment of the Agreement terms. If the Client disagrees with
							the amendments and notifies about it the Institution in writing, all
							agreements concluded between the Institution and the Client shall
							cease to be effective from the day of entry into force of the
							amendment to this Agreement. The Client is not entitled to
							unilaterally change the terms of this Agreement.
						</p>
					</li>
					<li>
						<p>
							The Client has a right to get familiar with the current version of
							the Agreement, amendments to the Agreement and related information
							on the Website.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> Applicable Law and Dispute Resolution </strong>
				</p>
				<ol>
					<li>
						<p>
							The law of the Republic of Lithuania is applicable to this
							Agreement. Any dispute, not settled by negotiations or other
							pre-trial procedures, shall be settled in the competent court of the
							Republic of Lithuania according to the registration address of the
							Institution.
						</p>
					</li>
					<li>
						<p>
							Before contacting the court, the Client must, within 30 calendar
							days from the date of the violation, apply for a pre-emption
							procedure to the Institution for settlement of the dispute. The
							Client must submit his claim in writing and add to the claim
							detailed evidence supporting the claim and requests of the Client.
							The Institution shall respond to the Client's claim no later than
							within 30 calendar days, unless other agreements between the
							Institution and the Client or legal acts provide for other terms for
							the settlement of pre-trial disputes.
						</p>
					</li>
					<li>
						<p>
							If the Client is a natural person – a consumer, and the Institution,
							according to the Client, has violated his rights or interests, the
							Client has the right to address consumer disputes outside the court
							to the Bank of Lithuania ({link}) according to the established procedure of the Law on the Bank of
							Lithuania and Consumer Rights Protection Act.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong> Final Provisions </strong>
				</p>
				<ol>
					<li>
						<p>
							The Means of Identification issued by the Institution becomes the
							Client’s property only if the Client has paid the price for them set
							by the Institution. Otherwise, upon termination of the Agreement,
							the Client must immediately return the Means of Identification or
							pay the price established to the Institution if the Means of
							Identification has not been issued free of charge.
						</p>
					</li>
					<li>
						<p>
							The Parties undertake to protect each other’s technical and
							commercial and other confidential information, except for publicly
							available information obtained in the course of performance of the
							Agreement, and not to transfer it to third parties without the
							written consent of the other Party or its authorized
							representatives.
						</p>
					</li>
					<li>
						<p>
							The Client is not entitled to transfer the rights and obligations
							arising from this Agreement to third parties without the prior
							written consent of the Institution. The Institution has the right at
							any time to transfer the rights and obligations arising from this
							Agreement to third parties without the consent of the Client, unless
							such transfer of rights and obligations is in conflict with legal
							acts.
						</p>
					</li>
					<li>
						<p>
							The Agreement is made up of two copies having the same legal force,
							one for each Party.
						</p>
					</li>
					<li>
						<p>
							The Client is obliged to comply with Law on Electronic Money and
							Electronic Money Institutions of the Republic of Lithuania and the
							Law on Payments of the Republic of Lithuania (and subsequent
							amendments thereto), and the Client undertakes to comply with it
							throughout the period of validity of the Agreement. The Client also
							undertakes to comply with other legal acts of the Republic of
							Lithuania related to the provision of electronic money and payment
							services, including the minimum security requirements for Internet
							payments issued by the Bank of Lithuania and other legal acts
							regulating the activities of the Client. These legal acts form an
							integral and inseparable part of the Agreement.
						</p>
					</li>
					<li>
						<p>
							If any provision of this Agreement is or becomes invalid, the
							validity of the other provisions remains unchanged. An invalid
							provision should be replaced by a valid provision, the economic and
							legal purpose of which should be as close as possible to the invalid
							provision.
						</p>
					</li>
				</ol>
			</li>
		</ol>`
	},
	verifoAccountAgreement: {
		id: 'fe.verifo_account_agreement',
		defaultMessage: `<h1>
		Verified Payments, UAB Internet Banking System Agreement Number
	</h1>
	<p>
		<strong>Verified Payments, UAB</strong>, company code 304576936 registration address
		Gedimino av. 20, Vilnius, Lithuania, and
		<br />
		Customer
		<br />
		Name, surname/Company Name:
		<br />
		Person/Company Code:
		<br />
		Registration Address:
		<br />
		Correspondent Address:
		<br />
		Email Address:
		<br />
		Telephone Number:
	</p>
	<p>
		Hereinafter, collectively the Customer and Verified Payments, UAB are referred to as
		the Parties, and each individually referred as the Party, after entering into
		Verified Payments, UAB Internet Banking System Agreement.
	</p>
	<ol>
		<li>
			<p>
				<strong>Definitions</strong>
			</p>
			<ol>
				<li>
					<strong>The Company</strong> – Verified Payments, UAB
				</li>
				<li>
					<strong>The Company’s website</strong> - Verified Payments, UAB official
					website ({link})
				</li>
				<li>
					<strong>The Fees</strong> – The rates for services provided and
					transactions performed by the Company are approved and presented on the
					Verified Payments, UAB website
				</li>
				<li>
					<strong>The Customer</strong> – a person who has concluded this
					Agreement with the Company.
				</li>
				<li>
					<strong>Authentication tool</strong> – additional security measure that
					the Company will provide to the Customer in order to authenticate the
					Customer: to verify the identity of the Customer and/or the validity of
					the use of a specific payment instrument and/or the Customer
					personalized security credentials.
				</li>
				<li>
					<strong>The Account</strong> - an account of electronic money and
					payment opened on the behalf of the Customer, managed in euros.
				</li>
				<li>
					<strong>Business days</strong> - means the day when Verified Payments,
					UAB is open for business and carries on its activities necessary for
					executing a payment transaction.
				</li>
			</ol>
		</li>
		<li>
			<p>
				<strong>Object of the Contract</strong>
			</p>
			<ol>
				<li>
					By this Agreement, the Company undertakes the responsibility to provide
					the Customer a possibility to submit a request on the Verified Payments,
					UAB Banking System thereby managing the funds in the Account. Unless
					stated otherwise in the Agreement, by agreeing to this Agreement the
					Customer has the right to use electronic means of communication to
					manage all the Customer’s opened Accounts, including the Accounts that
					the Customer will
					<br />
					have in the future, in which the Company allows to perform operations,
					and use other services provided by the Company (including the electronic
					signature of contracts).
				</li>
			</ol>
		</li>
		<li>
			<p>
				<strong>The Company undertakes the responsibility to:</strong>
			</p>
			<ol>
				<li>
					Assume that the Customer’s identity is authenticated and allow the
					Customer to use operations and services
					<br />
					on Verified Payments, UAB Banking System if the correct Customer’s
					Authentication Tool has been used during connection to the Account. The
					Customer’s requests for execution of payments and other operations and/
					or services must be confirmed using the appropriate Authentication
					tools.
				</li>
				<li>
					Execute the Customer’s requests on the Verified Payments, UAB Banking
					System within the time frame specified in the instructions if:
					<br />
					1. The Customer’s requests on the Verified Payments, UAB Banking System
					are made in accordance with the Instructions for performing the
					transaction on the terms of the agreement, the Company’s general rules
					and requirements;
					<br />
					2. There is a sufficient amount of funds in the Account to perform the
					request and for the fees to the Company;
					<br />
					3. The funds in the Account are not seized or the right to use funds is
					not limited;
					<br />
					4. There are no restrictions set by the Law or indicated in the
					Agreement between the Customer and the Company for when the Company has
					right not to and/ or must not debit funds from the Customer’s Account;
					<br />
					5. The Customer does not exceed the limit set by the Company for a
					particular Authentication Tool or limits set by the Customer
					himself/herself;
				</li>
				<li>
					Provide advice to the Customer on using the Account on the Verified
					Payments, UAB Banking System;
				</li>
			</ol>
		</li>
		<li>
			<p>
				<strong>The Customer undertakes the responsibility to:</strong>
			</p>
			<ol>
				<li>Comply with the requirements stated in the Agreement;</li>
				<li>
					Ensure that only indicated user use the Authentication Tool to connect
					to the Account and use the Account;
				</li>
				<li>
					Undertake all the obligations that occurred from the requests made to
					the Company, messages and/ or other actions completed on the Verified
					Payments, UAB Banking System, if all actions were approved by the
					Customer using the right Authentication tools.
				</li>
				<li>
					Ensure the security of the Authentication Tools provided by the Company,
					not allow third parties to have an access and/ or to use the
					Authentication Tools. Also immediately inform the Company if the
					Authentication Tools are lost, taken over by another person, or for any
					other reasons the Customer is not able to use / manage them.
				</li>
				<li>
					Pay the fees to the Company for using the Verified Payments, UAB Banking
					System, executed operations, and other services, and to ensure
					sufficiency of funds on the Account to cover the requested operation as
					well as the fees related to the operation.
				</li>
				<li>
					Give a right to the Company to record telephone conversations between
					the Customer and the Company when the Customer requests to block an
					access to the Verified Payments, UAB Banking System or to cancel this
					blocking.
					<br />
					Recorded conversations are considered as an evidence during the
					disputes;
				</li>
				<li>
					Immediately inform the Company if there are any changes related to
					Customer’s personal data (address, account numbers, mobile phone number,
					or other information specified in the Special Section of the Agreement).
					In case of the failure to comply with this requirement, the Customer has
					no right to make any claims to the Company if all actions performed by
					the Company are on the basis of the latest known Customer’s details, do
					not comply with the Agreement, or that the Customer did not receive any
					communication sent to the latest known details.
				</li>
			</ol>
		</li>
		<li>
			<p>
				<strong>
					Provision, Use, Change and Blockage of the Authentication Tool:
				</strong>
			</p>
			<ol>
				<li>
					The Customer and the Company agree that the Authentication tools
					provided to the Customer are used to confirm the Customer identity. If
					valid Authentication Tools are used at the time of the connection, it is
					assumed that the Customer identity is authenticated. The Customer’s
					requests to perform the activities on the Verified Payments, UAB Banking
					System will only be executed when the client confirms the request with
					the Authentication Tool. All the actions on the Verified Payments, UAB
					Banking System confirmed with the Authentication tool assumed to be
					equal to written and signed documents.
				</li>
				<li>
					The Customer uses the Company’s services via the internet by connecting
					to specific servers indicated by the Company. The Company authenticates
					the Customer by username, registration password and verification
					passwords provided by the provided Authentication tools or using an
					electronic signature. The unique login name is created when the Customer
					agrees to the Agreement and this login name is valid for the whole
					period of validity
					<br />
					of the Agreement.
				</li>
				<li>
					The Customer undertakes the responsibility to ensure that the
					Authentication tools will be only known to the Users that are specified
					to the Company, and neither the Customer nor the User will share them to
					third parties. If due to the fault of the Users, the Authentication
					tools are used by a person without such rights, the Company assumes that
					the payment order, the change of payment order or cancellation are
					provided by the User.
				</li>
				<li>
					If the Customer loses the mobile phone to which, he/ she receives the
					Authentication tool or has an electronic signature certificate, or if
					there is a suspicion that third parties have an access to the
					Authentication tools, the
					<br />
					Customer undertakes the responsibility to contact the Company via phone
					call or email. Submitting a request the Customer has to provide his/ her
					name, surname, number of the personal code and the reason for blocking
					the Account. The Company has the right to request additional information
					in order to identify the Customer. The Company blocks the Account on the
					basis of a request;
				</li>
				<li>
					The Company has the right to block the electronic services:
					<br />
					1. If the Company has been notified about the loss or disclosure to the
					third parties of the Authentication tools, or there are reasonable
					grounds for believing the Authentication tools may become available to
					third parties;
					<br />
					2. If the passwords during the login process to the Verified Payments,
					UAB Banking System are entered incorrectly three times in a row;
				</li>
				<li>
					In order for the Customer to unblock the Account, he/ she must call the
					Company and submit a request for unblocking the Account, submitting a
					request the Customer has to provide his/ her name, surname, number of
					the personal code. The Company has the right to request additional
					information in order to identify the Customer. The Company has the right
					to reject the request to unblock the Account if there is a reason to
					believe that the reasons for blocking have not disappeared. If the
					blocking has been made on the Company’s initiative, the blocking of the
					Account is stopped if the Company decides that there are no reasons to
					keep the Account blocked.
				</li>
				<li>
					The Company is not liable for the Customer’s losses arising from the
					electronic services blocking if the Company has performed blocking
					following the conditions and procedures provided in the Agreement.
				</li>
			</ol>
		</li>
		<li>
			<p>
				<strong>Fees</strong>
			</p>
			<ol>
				<li>
					The Customer states that by agreeing to this Agreement he/ she is
					familiar with the fees for operations and services, also by submitting a
					request for an operation or service accepts to pay these fees;
				</li>
				<li>
					The Company has the right to change the fees and shall update the
					pricing on the Company’s website ({link2}) and inform the Customer about changes;
				</li>
			</ol>
		</li>
		<li>
			<p>
				<strong>Responsibilities of Parties</strong>
			</p>
			<ol>
				<li>
					The Customer fully takes responsibility for all the actions performed on
					the Verified Payments, UAB Banking System if the right Authentication
					Tools were used during the connection. Also, the Customer is responsible
					that all the data provided on the Verified Payments, UAB Banking System
					is correct.
				</li>
				<li>
					The Company’s responsibility regarding the authentication of the
					Customer is limited to the checking of his/her information of the
					Authentication tool.
				</li>
				<li>
					The Customer is prohibited from using the Authentication Tools or
					allowing third parties to perform any actions in order to disrupt the
					operation of the Company’s electronic services. In such an event or an
					attempt to disrupt the operations, the Company becomes not responsible
					for any liabilities or obligations that arise from the execution of the
					Agreement.
				</li>
				<li>
					The parties are not entitled to share the terms and/ or obligations
					specified in this Agreement to third parties without the consent of the
					other party in writing, except in the cases provided for by law.
				</li>
				<li>
					The Company is not responsible for the Customer’s documents that are
					sent via electronic means.
				</li>
				<li>
					The Company is not responsible for the fact that the Customer’s
					Authentication Tools did not work if the Customer did not have the right
					equipment to use the Authentication Tools.
				</li>
				<li>
					The Company is not responsible if due to the disruption of the
					telecommunication, the Customer did not receive the Authentication tools
					and was not able to connect to the Verified Payments, UAB Banking
					System.
				</li>
				<li>
					In case the Company executes the requested payment and the Customer
					submits the complaint stating that the executed transactions are not the
					same as presented in the Customer’s statement, the disputes revolving
					will be based on the Customer’s payment order and the data submitted on
					the Lithuania Banking System.
				</li>
				<li>
					The Customer and/ or his/her representative shall be equally responsible
					for not obeying the agreement. If the Customer gives a right to the
					representative to manage the Account, the representative is obligated to
					properly execute all the Customer’s obligations under this Agreement.
				</li>
				<li>
					The Customer is responsible to fully reimburse all the losses that the
					Company experienced because of Customer’s improper protection (allowing
					an access to the third parties; loss) of Authentication tools.
				</li>
				<li>
					The Company is not responsible for Customer’s indirect losses arising
					from the use of Verified Payments, UAB Banking System.
				</li>
				<li>
					The Company is not responsible if due to the disruption of the
					telecommunication, the Customer was unable to access third-party
					external portal or due to such failures the data was distorted or lost.
				</li>
				<li>
					The Company Agency is not responsible for third-party services and
					products and their quality, third-party electronic systems failures when
					the Customer joins third-party systems or when paying for goods sold or
					provided by third parties using the Company’s electronic services. The
					Company does not investigate any claims directed to the third-parties
					for their goods or services, and these claims shall be provided directly
					to the third parties.
				</li>
			</ol>
		</li>
		<li>
			<p>
				<strong>Final provisions</strong>
			</p>
			<ol>
				<li>
					It is assumed that the Customer signs this Agreement when the Customer
					agrees to it.
				</li>
				<li>
					The Agreement comes into force after the Customer has registered in the
					System, learned terms and conditions of the present Agreement, expressed
					his/ her consent to comply with them electronically and the Company
					approved the Customer’s application and expires on the same day when the
					Agreement is terminated. The Agreement is valid for the unlimited period
					of time.
				</li>
				<li>
					Each party has the right to terminate this Agreement unilaterally by
					providing a written notice 30 (thirty) calendar days prior the
					termination, except the cases that are indicated in the Company’s terms
					and conditions, the Agreement and the General Payment Rules. In the case
					of termination, both parties are obligated to fully settle accounts with
					each other. The fees paid by the Customer are refundable.
				</li>
				<li>
					The Parties agree that once this Agreement comes into force, all
					previous Verified Payments, UAB Banking
					<br />
					System Agreements between the Company and the Customer are terminated
					and in the event of a dispute, the parties will follow the latest
					Verified Payments, UAB Banking System Agreement.
				</li>
			</ol>
		</li>
	</ol>`
	},
	verifoPrivacyPolicy: {
		id: 'fe.verifo_privacy_policy',
		defaultMessage: `<h1>
		<strong>Privacy Policy</strong>
	</h1>
	<ol>
		<li>
			<p>
				<strong>Introduction</strong>
			</p>
			<ol>
				<li>
					<p>
						This Privacy policy is the main document that sets out the basis as
						to what happens to any personal data that You provide to Verified
						payments, UAB, or that We collect from You or other sources while
						using our Services about You. You may choose not to provide any
						information to Us, however Verifo may be unable to provide Services.
					</p>
				</li>
				<li>
					<p>
						Please pay attention to the fact that Verifo may update this Privacy
						policy from time to time, therefore please do review it regularly.
					</p>
				</li>
				<li>
					<p>
						Your personal data controller is Verifo as specified in General
						Terms &amp; Conditions ({link}, {link2}). We have appointed a data protection officer (“DPO”). You can
						contact our DPO at {link3}.
					</p>
				</li>
				<li>
					<p>
						Verifo acts according to the Law on the Legal Protection of Personal
						data of the Republic of Lithuania, Regulation (EU) 2016/679 of the
						European Parliament and of the Council of 27 April 2016 on the
						protection of natural persons with regard to the processing of
						personal data and on the free movement of such data (General Data
						Protection Regulation) and other applicable legal regulation.
					</p>
				</li>
				<li>
					<p>
						Security is highly important to us. We take all reasonable measures
						to protect personal data from loss, theft, misuse and unauthorized
						access, disclosure, alteration and destruction, including industry
						standard security and encryption features.
					</p>
				</li>
				<li>
					<p>
						If the Profile is opened by legal person, Head or other
						representative of the Client shall properly inform data subjects
						(Beneficial owners, Head, etc.) about transfer of their data to Us
						and to present this Privacy policy to them.
					</p>
				</li>
			</ol>
		</li>
		<li>
			<p>
				<strong>Definitions</strong>
			</p>
			<ol>
				<li>
					<p>
						AML shall mean anti-money laundering and counter-terrorism financing
						regulations.
					</p>
				</li>
				<li>
					<p>
						Personal data shall mean any information relating to an identified
						or identifiable natural person.
					</p>
				</li>
				<li>
					<p>
						Supervisory institutions shall mean Bank of Lithuania, State Data
						Protection Inspectorate, Financial Crimes Investigation Service,
						other institutions that supervise our activity.
					</p>
				</li>
				<li>
					<p>
						You shall mean the natural person who is contracting with us, making
						payment to our System or representative, Beneficial owner on whose
						behalf the Personal data is provided.
					</p>
				</li>
				<li>
					<p>
						Other terms in this Privacy policy is used as defined in General
						Terms &amp; Conditions ({link4}, {link5}).
					</p>
				</li>
			</ol>
		</li>
		<li>
			<p>
				<strong>The purposes of processing</strong>
			</p>
			<ol>
				<li>
					<p>
						<strong>
							We collect and process Your data for these purposes:
						</strong>
					</p>
					<p>
						A. Provision of Payment services; Verification of the identity;
						prevention of fraud, money laundering, counter-terrorist financing,
						other financial crimes; implementation of other obligations under
						AML requirements.
					</p>
					<p>
						B. Notification about changes in our Services and dispute
						prevention.
					</p>
					<p>C. Dispute settlement.</p>
					<p>D. Debt management.</p>
					<p>E. Marketing.</p>
					<p>F. Statistics.</p>
				</li>
			</ol>
			<p>
				<strong>
					A. Provision of Payment services; Verification of the identity;
					prevention of fraud, money laundering, counter-terrorist financing,
					other financial crimes; implementation of other obligations under AML
					requirements
				</strong>
			</p>
			<ol>
				<li>
					<p>
						Verifo is required by law to Verify Your identity, monitor
						transactions of the Client, prevent fraud, money laundering,
						counter-terrorist financing, other financial crimes, properly
						implement obligations of payment service provider and comply with
						AML regulations.
					</p>
				</li>
				<li>
					<p>
						For this purpose, We may collect below data about the natural person
						client or representative of the legal person client:
					</p>
					<p>
						a. Data about Your identity: name, surname, personal identification
						number or other unique sequence of symbols assigned to the person
						for identification purposes, date of birth, personal identification
						document number, copy of personal identification document,
						nationality or the state which has issued the personal
						identification document, country of residence, ID number in Verifo
						system, Account number in Verifo system, face photo, etc. (Identity
						data).
					</p>
					<p>
						b. Contact data: address, phone number, email address, etc. (Contact
						data).
					</p>
					<p>
						c. KYC data: account number on other payment service providers,
						checks on public and private registries, fraud, money laundering,
						counter-terrorist financing and other financial crimes prevention
						agencies, employer, position, address, occupation, used Services,
						payment and other transactions, turnover, source of funds, countries
						from / to which funds will be received / transferred, information of
						political involvement, other data of monitoring of Client’s
						activity, etc. (KYC data).
					</p>
					<p>
						d. Device information: OS of device, browser type and version used
						for access to Profile, IP and location, time zone setting, etc.
						(Device information).
					</p>
					<p>
						e. Verifo payment card information: number and CVV/CVC code of
						payment card, PIN code, relevant expiry dates, etc. (Payment card
						information).
					</p>
				</li>
				<li>
					<p>
						We may also collect and process Identity data about Beneficial
						owners of legal entity. Also Identity data might be collected and
						processed about Head of legal entity if Profile has been opened by
						other representative of the Client.
					</p>
				</li>
				<li>
					<p>
						If You are a payer (natural person) using our payment collection
						services or making payment to our Client and do not have a Profile
						in Verifo system, We may collect and process this data about You:
						name, surname, personal identification number and email address.
					</p>
				</li>
				<li>
					<p>
						We may collect data from You and from third parties, We may search
						publicly available information about You in order to Verify your
						identity, process transactions, detect and prevent fraud or other
						similar purposes.
					</p>
				</li>
				<li>
					<p>
						We collect data mentioned above as We are required by law and We
						need this information as to enter contractual relationship with the
						Client. If You or a representative of legal entity won’t provide
						required data, We may refuse to enter into contractual relationship
						and provide Services for the Client.
					</p>
				</li>
				<li>
					<p>
						We may provide Your data to: supervisory institutions, banking and
						financial services partners, other payment service providers,
						payment card manufacturing/personalization and delivery companies,
						companies that provide identification and sanctions/ watch lists
						screening, transaction monitoring services, government institutions,
						attorneys, bailiffs, pre-trial investigation institutions, courts,
						auditors, debt recovery agencies, companies that handle joint debtor
						data files, fraud, money laundering, terrorist financing and other
						financial crimes prevention agencies, other subjects that have
						legitimate interest or Your acceptance.
					</p>
				</li>
				<li>
					<p>
						We are going to process Your data for eight years from the date of
						termination of transactions or business relationships with Us. Time
						limits for processing may be additionally extended for up to two
						years upon a reasoned instruction of a competent authority.
					</p>
				</li>
				<li>
					<p>
						We may provide Your data to third countries as to perform Your
						payment transaction to third country recipient or using third
						country partners services for the payment transaction. Please be
						advised that there are European Commission Adequacy decisions for
						the transfer of the data to Andorra, Argentina, Canada (commercial
						organizations), Faroe Islands, Guernsey, Israel, Isle of Man,
						Jersey, New Zealand, Switzerland, Uruguay and the US (limited to the {link6}). The data to the other third countries is transferred for the
						purpose of the performance of a contract between You and Us.
					</p>
				</li>
			</ol>
			<p>
				<strong>
					B. Notification about changes in our Services and dispute prevention
				</strong>
			</p>
			<ol>
				<li>
					<p>
						We are required by law to notify You about changes in our Services
						and terms &amp; conditions for provision of services. These
						notifications are not marketing material and are to be provided as
						required by law. According to this You shall not have the right to
						object receiving such notifications. For this purpose, We may
						process Your Contact data.
					</p>
				</li>
				<li>
					<p>
						We process above mentioned data as We are required by law and for
						the performance of the contract with the Client.
					</p>
				</li>
				<li>
					<p>
						We are going to process Your data for the above mentioned purpose
						till the date of termination of business relationships with Us.
					</p>
				</li>
				<li>
					<p>
						You can also refer to Us requiring information from Us, to consult
						with Us about our Services or to inform Us about unauthorized
						payments, demand to block Your payment instrument or ask to provide
						other information. You may contact Us by phone or email. As You
						contact Us We may process Your Identity data, Contact data, Device
						data, also record our phone conversations and store content of our
						correspondence and history of it.
					</p>
				</li>
				<li>
					<p>Above mentioned data is processed:</p>
					<p>
						a. As You refer to Us by phone: for the purposes of the legitimate
						interests pursued by Us to prevent disputes between You and Us about
						proper provision or receiving of information.
					</p>
					<p>
						b. As You refer to Us by email: data is collected for the law
						requirement purposes and for the purposes of the legitimate
						interests pursued by Us to prevent disputes between You and Us about
						proper provision or receiving of information.
					</p>
				</li>
				<li>
					<p>
						Data collected by contacting us by email will be processed for eight
						years from the date of termination of transactions or business
						relationships with Us as it is required by AML regulations. Data
						collected by contacting Us by phone will be processed for 18 months
						from the day You called to our customer support. These terms may be
						additionally extended for up to 24 months from the final decision in
						case of dispute between the parties.
					</p>
				</li>
				<li>
					<p>
						Your data may be provided to supervisory institutions, attorneys,
						pre-trial investigation institutions, courts, auditors, debt
						recovery agencies, companies that handle joint debtor data files,
						other subjects having Your acceptance.
					</p>
				</li>
			</ol>
			<p>
				<strong>C. Dispute settlement</strong>
			</p>
			<ol>
				<li>
					<p>
						Before starting a dispute with Us firstly You should contact Verifo
						so that We can handle Your complaint and satisfy it benevolently if
						it is well grounded. If You are not satisfied with our reply, You
						can address competent authority according to Our {link7}.
					</p>
				</li>
				<li>
					<p>
						As the dispute may arise, for dispute settlement purposes We may
						collect and process such data: Identity data, Contact data, KYC
						data, also data provided in Your claim and its supplements, other
						data needed to investigate Your claim. The data is processed as We
						are required by law.
					</p>
				</li>
				<li>
					<p>
						Data will be processed for 3 years from the day We provided You a
						final response. These terms may be additionally extended up to the
						final dispute settlement between the parties.
					</p>
				</li>
				<li>
					<p>
						Your data may be provided to supervisory institutions, attorneys,
						pre-trial investigation institutions, courts, auditors, debt
						recovery agencies, companies that handle joint debtor data files,
						other subjects having Your acceptance.
					</p>
				</li>
			</ol>
			<p>
				<strong>D. Debt recovery</strong>
			</p>
			<ol>
				<li>
					<p>
						If somehow You will have a debt for Us, We may process such data
						about You: Identity data, Contact data, also data about Your
						payments, Services and information about debt.
					</p>
				</li>
				<li>
					<p>
						Data will be processed for 10 years from the date the debt
						originated. In case there is court proceeding, the term may be
						additionally extended up to the time the debt is recovered and 24
						months after recovery.
					</p>
				</li>
				<li>
					<p>
						Your data may be provided to attorneys, pre-trial investigation
						institutions, courts, auditors, bailiffs, debt recovery agencies,
						companies that handle joint debtor data files, banking and financial
						services providers, other payment service providers, government
						institutions.
					</p>
				</li>
				<li>
					<p>
						You therefore agree that if You failed to fulfill Your obligations
						to us, We have the right to provide Your data to companies that
						handle joint debtor data files by informing You in advance.
					</p>
				</li>
			</ol>
			<p>
				<strong>E. Marketing</strong>
			</p>
			<ol>
				<li>
					<p>
						We may provide You by email the information about our new Services,
						other goods and services We offer that are similar to those that You
						have already used or inquired about, to provide You or permit
						selected third parties to provide You information about goods or
						services We feel may interest You.
					</p>
				</li>
				<li>
					<p>
						Email for our direct marketing purposes (newsletters) will be
						processed only with Your separate acceptance.
					</p>
				</li>
				<li>
					<p>
						Your email address will be processed for 1 year from the date You
						terminate business relationship with Us. You have the right at any
						time to object to Your email usage for direct marketing purposes.
					</p>
				</li>
				<li>
					<p>
						We may provide Your email to email marketing service providers to
						send You newsletters on our behalf.
					</p>
				</li>
				<li>
					<p>
						We hereby inform You that We may also use Your personal data (such
						as used services, location, IP, behavior, etc.) to form a view on
						what We think You may want or need, or what may be of interest to
						You and show You adverts in our webpage.
					</p>
				</li>
				<li>
					<p>
						We may also provide anonymized information to advertisers to promote
						our products and services. Therefore, such anonymized information
						would be used to help our advertising partners provide a targeted
						campaign, relevant for a sub-section of our Clients.
					</p>
				</li>
				<li>
					<p>
						Your data will be processed for 1 year from the date You terminate
						business relationship with Us. You have the right at any time to
						object to Your data usage for marketing purposes.
					</p>
				</li>
				<li>
					<p>
						Your email and anonymized information about You may be provided for
						third parties that provide marketing services in online search
						engines, social networks, etc. Such third parties have their own
						privacy policies and You can directly object at any time to
						processing of Your data by such third parties according to their
						privacy policies.
					</p>
				</li>
				<li>
					<p>
						Data mentioned above is processed for the purposes of the legitimate
						interests pursued by Us: to show You our Services that We think You
						may want or need, or what may be of interest to You.
					</p>
				</li>
			</ol>
			<p>
				<strong>F. Statistics</strong>
			</p>
			<ol>
				<li>
					<p>
						All Your provided or our collected data about You, except Identity
						data, may be processed for the statistical purposes. We process Your
						data in such a way that after including data in statistical
						evaluation there would be no possibility to identify You.
					</p>
				</li>
				<li>
					<p>
						You agree that You are informed about the right to refuse that Your
						data would be processed for the statistical purposes, but Verifo
						would have the right to continue processing of Your data if can
						prove that data is processed for convincing legitimate reasons that
						are superior to the interests, rights and freedoms of You or in
						order to bring, enforce or defend legal requirements.
					</p>
				</li>
				<li>
					<p>The data will be processed till it becomes not relevant.</p>
				</li>
			</ol>
		</li>
		<li>
			<p>
				<strong>Data processing</strong>
			</p>
			<ol>
				<li>
					<p>
						Your data will be processed by automated means, as well as to manual
						processing, including automated individual decision-making and
						profiling, for various processing purposes.
					</p>
				</li>
				<li>
					<p>
						Automated decision making and profiling might be used for
						Verification of Your identity, monitoring Your operations and
						activity in the Profile, predicting other aspects of Your behavior.
						Such procedures are necessary according to AML requirements and
						necessary for entering and performing business relationship between
						Us and the Client. Verifo implements suitable measures to safeguard
						Your rights and freedoms and legitimate interests, including the
						right to obtain human intervention. You also have the right to
						express Your point of view and to contest the decision.
					</p>
				</li>
				<li>
					<p>
						The information We process about You is stored on our secure
						servers. We use all needed technical, organizational and other means
						to protect Your data.
					</p>
				</li>
			</ol>
		</li>
		<li>
			<p>
				<strong>Verifo partners services</strong>
			</p>
			<ol>
				<li>
					<p>
						As stated in General Terms &amp; Conditions ({link8}, {link9}), You may access Verifo partners services via Verifo system.
						According to this You may find links to third party websites on our
						website. These websites should have their own privacy policies which
						You should check. We shall not be liable for their policies and
						activity as We have no control over them.
					</p>
				</li>
				<li>
					<p>
						If You choose to use such services, You have to provide Your data to
						such partner and accept the terms &amp; conditions of services set
						by that partner or We may share Your data in order to provide
						certain services to You upon Your request. Verifo shall only be an
						intermediary between You and the service provider and is not liable
						for the proper provision of such services.
					</p>
				</li>
			</ol>
		</li>
		<li>
			<p>
				<strong>Your rights</strong>
			</p>
			<ol>
				<li>
					<p>
						Please be informed about Your rights under Data Protection
						regulations in relation to Your personal data:
					</p>
					<p>
						a. Right to Information: The right to ask Us for information about
						what personal data of Yours is being processed and the rationale for
						such processing.
					</p>
					<p>b. Right of Access: The right to access Your personal data;</p>
					<p>
						c. Right of Rectification: The right of rectification of inaccurate
						personal data concerning You, and the right to have incomplete
						personal data completed. Please be advised that We may need to
						verify the accuracy of the new data You provide to Us;
					</p>
					<p>
						d. Right of Erasure (the right to be forgotten): The right of
						erasure of personal data concerning You if there is no convincing
						reason for Us continuing to process it. Please be advised that We
						may not always be able to comply with Your request of erasure for
						specific legal reasons which will be notified to You, if applicable,
						at the time of Your request. Please note that Under GDPR Article
						17(3)(b), legal requirements take precedence over the right to be
						forgotten. From an AML perspective, the EU’s 4th Anti- Money
						Laundering Directive (4AMLD) introduced the requirement that both
						customer due diligence and transaction records be retained for a
						minimum of a set number of years after the end of the customer
						relationship and as a financial institution Verifo will retain Your
						data, in line with AML regulations, for a minimum of 8 years. In
						this context, the right to be forgotten would only be enforceable
						after this period had ended.;
					</p>
					<p>
						e. Right of Restriction of Processing (Right to Withdraw Consent):
						The right to obtain from Us restriction of processing if there is
						legitimate reason. Where processing has been restricted, such
						personal data shall, with the exception of storage, only be
						processed with Your consent or for the establishment, exercise or
						defense of legal claims or for the protection of the rights of
						another natural or legal person or for reasons of important public
						interest of the EU or of a Member State.
					</p>
					<p>
						f. Right to Data Portability: The right to receive the personal data
						concerning You, which You provided to Us and have the right to
						transmit data to another controller. Please be advised that this
						right only applies to information which You provided for Us.
					</p>
					<p>
						g. Right to object: The right to object at any time to processing of
						personal data concerning You which is processed for the purposes of
						our legitimate interests. We shall no longer process the personal
						data unless the We demonstrate compelling legitimate grounds for the
						processing which override the interests, rights and freedoms of You
						or for the establishment, exercise or defense of legal claims. Where
						personal data is processed for marketing purposes, You shall have
						the right to object at any time to processing of personal data
						concerning You for such marketing.
					</p>
					<p>
						h. Right to Object to Automated Processing: This right to object to
						a decision based on automated processing. Using this right, a
						customer may ask for his or her request (for instance, a loan
						request) to be reviewed manually, because he or she believes that
						automated processing of his or her loan may not consider the unique
						situation of the customer.
					</p>
					<p>
						i. Right to withdraw consent: The right to withdraw Your consent at
						any time where we are relying on consent to process Your personal
						data. However, this will not affect the lawfulness of any processing
						carried out before You withdraw your consent. In some cases, if You
						withdraw Your consent, We may not be able to provide the Services to
						You.
					</p>
					<p>
						j. Right to complain. You have right to make a complaint at any time
						to the State Data Protection Inspectorate, Lithuania supervisory
						authority for data protection issues. We would, however, appreciate
						the chance to deal with Your concerns before You approach the
						supervisory authority so please contact Us in the first instance.
					</p>
				</li>
				<li>
					<p>
						You can implement Your rights according to {link10}.
					</p>
				</li>
			</ol>
		</li>
	</ol>`
	},
	verifoTermsAndConditions: {
		id: 'fe.verifo_terms_and_conditions',
		defaultMessage: `<h1>General Terms &amp; Conditions</h1>
		<h2>For Private</h2>
		<ol>
			<li>
				<p>
					<strong>Introduction</strong>
				</p>
				<ol>
					<li>
						<p>
							Your service provider is Verified Payments, UAB (legal code
							304576936, reg. address Gedimino av. 20, LT-01103 Vilnius) (brand
							name Verifo), an electronic money institution acting under
							electronic money license No. 27 issued by the {link}
							on 13/02/2018. You can find useful information about Verifo {link2}. Activity of Verifo is supervised by the {link}.
						</p>
					</li>
					<li>
						<p>
							You can contact us at:
							<br />
							Phone: +370 620 44441
							<br />
							E-mail: {link3}
							<br />
							Address for correspondence: Gedimino av.20, LT-01103, Vilnius,
							Lithuania
						</p>
					</li>
					<li>
						<p>
							These General Terms &amp; Conditions, including its supplements,
							govern Your use of the Services provided by Verifo.
						</p>
					</li>
					<li>
						<p>
							Please read this document carefully before You decide to agree with
							it as it constitutes the legal binding relationship between You and
							Us. By using any of Our Services described in these General Terms
							&amp; Conditions, its supplements, You are agreeing to be bound by
							these terms of use. You are also advised to print or download and
							keep a copy of the General Terms &amp; Conditions for the future
							reference.
						</p>
					</li>
					<li>
						<p>
							Please note that various terms in these General Terms &amp;
							Conditions have a defined meaning, which is set out in the part
							“Definitions” and is incorporated into these General Terms &amp;
							Conditions.
						</p>
					</li>
					<li>
						<p>
							Conditions of separate services provided by Verifo are set in
							separate terms &amp; conditions for specific services which prevail
							over other provisions of these General Terms &amp; Conditions.
						</p>
					</li>
					<li>
						<p>
							Please pay attention that You may access Verifo partners services
							via Verifo system. If You choose to use such services, You have to
							provide Your data to such partner and accept the terms &amp;
							conditions of services set by that partner. Verifo shall only be an
							intermediary between You and the service provider and is not liable
							for the proper provision of such services.
						</p>
					</li>
					<li>
						<p>
							Services that can be provided for You can be found in the System or
							our website. Please be advised that some of our Services may be
							provided only for business clients. If You wish to use them, You
							should open business Profile / Account and comply with the
							requirements for business clients.
						</p>
					</li>
					<li>
						<p>
							These General Terms &amp; Conditions are concluded with You in
							English language that will be the main communication language
							between the parties (unless otherwise provided).
						</p>
					</li>
					<li>
						<p>
							You have right to get these General Terms &amp; Conditions on
							durable medium at any time. If You wish to receive it printed on
							paper, additional {link4} might be applied.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>Definitions</strong>
				</p>
				<ol>
					<li>
						<p>
							<strong>Account</strong> shall mean e-money account, opened in the
							Verifo System in the name of the Client and used to perform payment,
							currency exchange and other transactions.
						</p>
					</li>
					<li>
						<p>
							<strong>Business Day</strong> shall mean any day other than a
							Saturday or a Sunday or a public holiday in Lithuania. Verifo keeps
							the right to inform You in advance about other days that are not
							Business Days.
						</p>
					</li>
					<li>
						<p>
							<strong>Client</strong>, You shall mean the legal person or other
							person who is contracting with us for the provision of the Services
							not for personal, family or household means.
						</p>
					</li>
					<li>
						<p>
							<strong>Data Protection Regulations</strong> shall mean General Data
							Protection Regulation 2016/679 and other legal regulations.
						</p>
					</li>
					<li>
						<p>
							<strong>E-money</strong> shall mean electronically stored monetary
							value on the Account.
						</p>
					</li>
					<li>
						<p>
							<strong>EU</strong> shall mean European Union.
						</p>
					</li>
					<li>
						<p>
							<strong>Fees</strong> shall mean the charges payable by You to Us
							for the Services as set out in these General Terms &amp; Conditions
							and its supplements.
						</p>
					</li>
					<li>
						<p>
							<strong>General Terms &amp; Conditions</strong> shall mean these
							terms and conditions including the supplements amended from time to
							time.
						</p>
					</li>
					<li>
						<p>
							<strong>Head of legal entity</strong> shall mean natural person (-s)
							that are entitled to make decisions on behalf of the legal entity
							under articles of association or other documents of establishment.
						</p>
					</li>
					<li>
						<p>
							<strong>KYC</strong> shall mean procedures taken by Us to Verify the
							identity of the Client, understand the nature of Client’s activity
							and assess money laundering risks associated with the Client.
						</p>
					</li>
					<li>
						<p>
							<strong>Payment Services</strong> shall mean the e-money and payment
							services provided by Verifo to You including but not limited to the
							receipt and holding of funds in the Account and performance of
							payment transactions on Your behalf.
						</p>
					</li>
					<li>
						<p>
							<strong>Personalized safety features</strong> shall mean any code
							created in the System or a code provided to You for access to the
							Profile and/or Account or initiation and management of separate
							Services and/ or initiation, authorization, confirmation of
							transactions.
						</p>
					</li>
					<li>
						<p>
							<strong>Profile</strong> shall mean Your profile accessible via
							Verifo System where You can manage Your funds, Accounts and use
							Verifo Services.
						</p>
					</li>
					<li>
						<p>
							<strong>Services</strong> shall mean the Payment Services, currency
							exchange services and other services provided by Verifo to You as
							described in these General Terms &amp; Conditions and its
							supplements.
						</p>
					</li>
					<li>
						<p>
							Supervisory institution shall mean {link}.
						</p>
					</li>
					<li>
						<p>
							<strong>Supplements</strong> shall mean any separate terms &amp;
							conditions for specific services, links to Verifo website where
							specific terms are provided (including but not limited to Fees).
						</p>
					</li>
					<li>
						<p>
							<strong>System</strong>, Verifo System shall mean Verifo online
							payment platform that is used to provide Services for the Client.
						</p>
					</li>
					<li>
						<p>
							<strong>Verification of the identity</strong> shall mean any
							procedures established by Verifo designated to identify Client,
							one’s Beneficial owners and gather other information required by
							law.
						</p>
					</li>
					<li>
						<p>
							<strong>Verifo</strong>, We, Us shall mean Verified Payments, UAB as
							stated above.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>Registration and Verification of the identity</strong>
				</p>
				<ol>
					<li>
						<p>
							To register in Verifo system and create a Profile You shall provide
							all documents and information required by Verifo, accept these
							General Terms &amp; Conditions and {link5}. Please pay attention to the fact that You can have only one
							Profile therefore all following Profiles will be closed.
						</p>
					</li>
					<li>
						<p>The Account for the Client can be opened only personally by You.</p>
					</li>
					<li>
						<p>
							As a Verifo Client, You agree to cooperate with Us so as to
							ascertain Your identity, confirm Your address, contact details and
							provide all needed documents and explanations on Your activity
							including but not limited to personal identification document,
							bills, bank account statement and also any other required documents.
							Under EU law We are obliged to collect KYC data on our clients, and
							We may also ask for any additional data to validate Your
							transactions, planned spending activities, Your source of funds and
							etc. The asked data may include the original documents or their
							copies as well as copies approved by notary or Apostille depending
							on the requirements by applicable law. All documents shall be
							provided in English or Lithuania language.
						</p>
					</li>
					<li>
						<p>
							You must keep an accurate description of asked information and
							update it regularly to avoid suspension or termination.
						</p>
					</li>
					<li>
						<p>
							Your personal data is being processed according to the {link5}.
						</p>
					</li>
					<li>
						<p>
							You must be aware that We may reject request to create a Profile if
							any of the terms and conditions are not met by the Client. Verifo
							may also suspend or limit Your Profile, Your Account, set usage
							limits in the Account and apply other measures as set in the part
							“Restrictions on the use of Verifo services”.
						</p>
					</li>
					<li>
						<p>
							As the Profile is created, Client is assigned with multi-currency
							Account that is an e-money product. Your Account is not a bank
							account, and as such it is not covered by the deposit insurance
							schemes. Funds of the Client Verifo has issued e-money for are
							stored in EU credit institutions accounts that Verifo cannot use for
							anything other than its intended purpose or protected in other ways
							as stipulated in legal regulation.
						</p>
					</li>
					<li>
						<p>
							You can open more than one Account according to the procedures set
							in the System.
						</p>
					</li>
					<li>
						<p>
							Verifo keeps the right to set the limits of use for Your Account
							(-s).
						</p>
					</li>
					<li>
						<p>
							You may close your Profile, Account (-s) under conditions set into
							part “Termination of General Terms &amp; Conditions, closure of the
							Account”.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>E-money</strong>
				</p>
				<ol>
					<li>
						<p>
							All funds kept in Your Account are e-money that are issued by
							Verifo. Funds kept in Your Account are not a deposit and Verifo
							shall not pay any interest and shall not provide any other benefits
							associated with the period e-money are stored.
						</p>
					</li>
					<li>
						<p>
							Verifo issues e-money at the earliest convenience it receives the
							funds that are dedicated to You. E-money is issued at its nominal
							value (after deduction of a standard {link6} applicable to a particular payment method) and credited into Your
							Account in the currency it is received.
						</p>
					</li>
					<li>
						<p>You can top up Your Account by:</p>
						<p>
							a. receiving transfer from bank or other payment service provider
							account supported by the System;
						</p>
						<p>b. receiving transfer from other Verifo client.</p>
					</li>
					<li>
						<p>
							Verifo keeps the right to require that the first top up to Your
							Account would be from Your bank account.
						</p>
					</li>
					<li>
						<p>
							You should carefully follow the instructions for top up provided in
							the System. Verifo shall not be responsible for any fail to follow
							provided instructions and losses related with it.
						</p>
					</li>
					<li>
						<p>
							You can redeem Your e-money at its nominal value at any time except
							the cases set forth in these General Terms &amp; Conditions or any
							supplements when limitations could be applied to the Profile /
							Account.
						</p>
					</li>
					<li>
						<p>
							For the redemption of e-money You should submit a payment order in
							the Verifo system to any bank or other payment service provider
							account supported by the System. The required details for an
							effective transfer may differ depending on the country of the
							recipient’s account and recipient’s payment service provider. You
							can also redeem Your funds via payment card in ATM (if such service
							is provided for You).
						</p>
					</li>
					<li>
						<p>
							Verifo keeps the right to require that e-money would be redeemed to
							Your bank account.
						</p>
					</li>
					<li>
						<p>
							Verifo does not apply specific conditions for redemption of e-money
							that would differ from the standard conditions for transfers or ATM
							operations. You shall pay the usual {link6}.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>Payments and currency exchange</strong>
				</p>
				<p>
					<strong>Payments</strong>
				</p>
				<ol>
					<li>
						<p>
							You can use funds in Your Account to perform any transfers supported
							by Verifo:
						</p>
						<p>a. to other Verifo system client;</p>
						<p>b. to other bank or payment service provider account.</p>
					</li>
					<li>
						<p>
							You can make a transfer to other Verifo system client by entering
							details of the recipient requested in the transaction form: name,
							e-mail address or account number (the ‘unique identifier’), amount
							and currency You wish to transfer, payment purpose.
						</p>
					</li>
					<li>
						<p>
							In order to make transfer to other bank or payment service provider
							account You shall enter recipient’s and his/her account details
							requested in the transaction form (the ‘unique identifier’), amount
							and currency You wish to transfer, payment purpose or payment code,
							information if the receiver is natural or legal person.
						</p>
					</li>
					<li>
						<p>
							You will be informed about Fees applied to the transaction (if any)
							and usual time it takes to perform the transaction before confirming
							it. You can also find all applicable Fees {link7}.
						</p>
					</li>
					<li>
						<p>
							It is Your responsibility to make sure that the details in
							transaction form are entered correctly. Any error may result in the
							unsuccessful or delayed transfer. We shall not be liable for any
							losses you incur from entering an incorrect unique identifier.
						</p>
					</li>
					<li>
						<p>
							In order to submit the payment order, You need to confirm the
							details which have been entered into transaction form according to
							the procedures set in the System.
						</p>
					</li>
					<li>
						<p>
							The request to perform the transaction shall be deemed to be
							received at the time You provide your confirmation except the cases
							when confirmation is received on a day which is not a Business Day
							or is received after working hours of particular system used to make
							a transactions (i. e. SEPA and etc.). In this case We have the right
							to treat the request to perform the transaction as having been
							received on the next Business Day.
						</p>
					</li>
					<li>
						<p>
							We ensure that the transfer is credited to the recipient’s payment
							service provider’s account in the deadlines provided here.
						</p>
					</li>
					<li>
						<p>
							We reserve the right to refuse to perform any transaction directly
							or indirectly associated with any restricted country or recipient /
							payer.
						</p>
					</li>
					<li>
						<p>
							If the currency of the recipient’s account is different to the
							currency of the e-money You are transferring, the transaction may
							not be performed, or the currency exchange rates / additional Fees
							might be applied. It is your responsibility to make sure that the
							recipient’s account supports the currency You are transferring. We
							shall not be liable for any losses You incur from not making sure of
							the currencies supported by the recipient’s account.
						</p>
					</li>
					<li>
						<p>
							You may revoke the request to perform the transaction prior to the
							time the transaction is being performed. You may perform it directly
							in the System. Later You should contact out customer support for
							possibility to revoke the transaction.
						</p>
					</li>
					<li>
						<p>
							Once Your transaction has been completed, You will be able to view
							the completed transaction details on Your Account statement.
						</p>
					</li>
					<p>
						<strong>Currency exchange</strong>
					</p>
					<li>
						<p>
							E-money on Your Account may be held in different currency. We shall
							not be liable for any possible depreciation of money due to changes
							in exchange rates.
						</p>
					</li>
					<li>
						<p>
							Currency exchange is based on the exchange rate of Verifo which is
							valid at the moment of conversion. You can find currency rates here
							that is subject to change from time to time without Us being
							required to provide You with a notice. It is Your responsibility to
							stay informed of any changes to the rates applied to any exchanges.
							You shall check applicable currency rates before the transaction.
							Currencies to which You are able to convert Your funds are limited
							to those supported by Verifo that are also subject to change without
							prior notice.
						</p>
					</li>
					<li>
						<p>
							You will be informed on Verifo system prior to confirming Your
							request to exchange the currency about:
							<br />
							a. the amount of e-money You will use to purchase required currency;
						</p>
						<p>b. the amount and currency of the e-money you could purchase;</p>
						<p>c. the currency rate.</p>
					</li>
					<li>
						<p>
							In order to submit the request to exchange currency, You will need
							to confirm the details which have been entered into currency
							exchange form according to the procedures set in the System. By
							confirming the exchange details, You accept sole responsibility for
							entering into the currency exchange transaction. Verifo will not be
							liable for any losses You incur as a result of using this Service.
						</p>
					</li>
					<li>
						<p>
							Your request to exchange e-money will be accepted when We confirm to
							You that the transaction is performed on the Verifo system.
						</p>
					</li>
					<p>
						<strong>Statements</strong>
					</p>
					<li>
						<p>
							You can find all Your payment and currency exchange transactions,
							Fees applied for the transactions on the statement of Your Account
							used for these transactions.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>Fees</strong>
				</p>
				<ol>
					<li>
						<p>
							Prices for Verifo services are provided {link7}.
						</p>
					</li>
					<li>
						<p>
							Fees for the particular Services are also stated before payment or
							currency exchange transaction and shall be accepted by You by
							confirming the request to perform the transaction.
						</p>
					</li>
					<li>
						<p>
							Fees are deducted from any of Your Accounts at the time the
							transaction is being performed.
						</p>
					</li>
					<li>
						<p>
							Fees are deducted in EUR. If You do not have EUR in Your Account,
							currency exchange rates might be applied.
						</p>
					</li>
					<li>
						<p>
							By confirming the performance of the transaction, You also confirm
							that You carefully studied the Fees that are applied and relevant to
							You.
						</p>
					</li>
					<li>
						<p>
							If the amount of funds is insufficient to pay the Fee, the
							transaction shall not be performed.
						</p>
					</li>
					<li>
						<p>
							If You use Service plan and it is not renewed, usual Fees for the
							Services shall be applied.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>Restrictions on the use of Verifo services</strong>
				</p>
				<ol>
					<li>
						<p>While using our Services it is not permitted to:</p>
						<ol>
							<li>
								<p>
									a. breach these General Terms &amp; Conditions, other
									applicable supplements, agreements, legislation, including
									but not limited to, anti-money laundering and
									counter-terrorist financing regulations;
								</p>
							</li>
							<li>
								<p>
									b. use Verifo services for any illegal purposes, including,
									but not limited to fraud and money laundering; funding of
									terrorist organizations; unlawful sexually oriented
									materials or services; counterfeit products; unlawful
									gambling activities; unlawful purchase or sale of tobacco,
									firearms, weapons, war ammunition, prescription drugs, other
									controlled substances; unlawful trade of currency (Forex),
									binary options or other products prohibited by law; unlawful
									provision of financial or investment services;
								</p>
							</li>
							<li>
								<p>
									c. use Verifo services for such activities as consumer
									credits; issuance of unregulated and/ or unsupervised
									virtual currency, accepting payments in unregulated and/ or
									unsupervised virtual currency, buying, exchanging or
									managing it in any other way; activity related with ferrous,
									non-ferrous, precious metals, precious stones, jewelry,
									works of art; activity related with charity, support and
									similar non-profit activity; provision of payment and other
									financial, investment services; activity of trust or company
									establishment and administration services. Verifo has the
									right to decide that other activities not included herein
									are not acceptable to Verifo. You can find relevant
									information about all applicable restrictions here;
								</p>
							</li>
							<li>
								<p>
									d. infringe Verifo or any third party’s copyright, patent,
									trademark, trade secret or other intellectual property
									rights, or rights of publicity or privacy; violate any
									rights of third parties;
								</p>
							</li>
							<li>
								<p>
									e. spread computer viruses and undertake other actions that
									could cause Verifo system malfunctions, information damage
									or destruction and other damages to Verifo;
								</p>
							</li>
							<li>
								<p>
									f. conduct your business or use the Verifo services in any
									manner that is likely to result in or may result in
									complaints, disputes, reversals, chargebacks, fees, fines,
									penalties or other liability to Verifo, other clients, third
									parties or You;
								</p>
							</li>
							<li>
								<p>
									g. request to perform a transaction or to receive a payment
									from restricted countries or persons;
								</p>
							</li>
							<li>
								<p>
									h. provide Us with false, inaccurate or misleading
									information;
								</p>
							</li>
							<li>
								<p>
									i. refuse to provide Us information or undertake other
									actions that are reasonably requested by Verifo;
								</p>
							</li>
							<li>
								<p>
									j. refuse to cooperate in an investigation or provide
									confirmation of Your identity or any information You provide
									to Us;
								</p>
							</li>
							<li>
								<p>
									k. instruct Us to send or receive what We reasonably believe
									to be potentially fraudulent funds on Your behalf;
								</p>
							</li>
							<li>
								<p>
									l. reveal any passwords and other Personalized safety
									features to anyone or use anyone else’s passwords and other
									Personalized safety features;
								</p>
							</li>
							<li>
								<p>
									m. conduct Your business or use the Verifo services in any
									manner that may cause risk to Verifo.
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							If We believe that You might have breached these provisions, We may
							take actions to protect ourselves, other clients and third parties.
							The actions We may take include but are not limited to:
						</p>
						<p>
							a. closing, suspending, or limiting access to Your Profile, Account
							(-s) and/or payment instruments;
						</p>
						<p>
							b. contacting other Verifo clients, third parties who have
							transacted with You; contacting your bank or card issuer; and/or
							warning third parties, law enforcement, or impacted third parties of
							Your actions;
						</p>
						<p>c. taking legal action against You;</p>
						<p>
							d. terminating these General Terms &amp; Conditions within time
							defined in the notice of termination;
						</p>
						<p>e. fully or partially reversing a transaction;</p>
						<p>f. suspending performance of the transaction;</p>
						<p>g. detaining Your funds or part of it;</p>
						<p>h. refusing to provide Services, limiting them;</p>
						<p>i. changing any conditions of the provision of Verifo Services.</p>
					</li>
					<li>
						<p>
							Where it is possible, We will provide You with the relevant
							information regarding the actions taken, but We may be unable to do
							so in accordance with the appropriate law including interfering in
							the course of an investigation.
						</p>
					</li>
					<li>
						<p>
							You shall reimburse all direct and indirect damages, fines and other
							monetary sanctions applied to Verifo due to non-compliance with
							these General Terms &amp; Conditions.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>
						Communication and notifications about changes of General Terms &amp;
						Conditions
					</strong>
				</p>
				<ol>
					<li>
						<p>
							You shall provide Us Your valid e-mail address and telephone number
							and confirm it. You agree that e-mail address and telephone number
							You provided will be used for communication with Verifo and that You
							will check it regularly. You shall inform Verifo on any changes of
							Your contact details as it might be used to identify You.
						</p>
					</li>
					<li>
						<p>
							All communication between the parties is being carried out in the
							electronic means (unless otherwise provided). If You wish to receive
							documents printed on paper additional {link4} might be applied.
						</p>
					</li>
					<li>
						<p>
							You can contact our customer support by email, live chat and other
							means of communication specified in Our website.
						</p>
					</li>
					<li>
						<p>
							These General Terms &amp; Conditions are subject to change from time
							to time with sole discretion of Verifo. We will inform You about the
							changes of these General Terms &amp; Conditions 60 days in advance
							by providing notification to You via agreed communication channels
							(art. 1, part VIII).
						</p>
					</li>
					<li>
						<p>
							These changes will be considered accepted by You in case You do not,
							before the proposed date of the entry into force of the changes,
							notify Us to the contrary. If you do notify us to the contrary, Your
							notification will be considered to be a notice that You wish to
							terminate these General Terms &amp; Conditions on the date upon
							which the changes are to take effect.
						</p>
					</li>
					<li>
						<p>The 60 days notification period shall not be applied if:</p>
						<p>
							a. General Terms &amp; Conditions are changed due to the changes in
							mandatory requirements of the legislation;
						</p>
						<p>b. the Fees change;</p>
						<p>
							c. amendments to the General Terms &amp; Conditions are not
							essential (any changes that do not reduce or limit Your rights and
							do not increase Your liability or aggravate Your situation).
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>
						Termination of the General Terms &amp; Conditions, closure of the
						Account
					</strong>
				</p>
				<ol>
					<li>
						<p>
							We may terminate these General Terms &amp; Conditions at any time.
							Unless there are exceptional circumstances, We will give you 60 days
							prior written notice.
						</p>
					</li>
					<li>
						<p>
							You may terminate these General Terms &amp; Conditions at any time
							by providing us with one month’s notice. Such notice should be
							provided using email filling the form that is published in our
							website.
						</p>
					</li>
					<li>
						<p>
							You can also terminate these General Terms &amp; Conditions if You
							do not accept changes informing Verifo before these changes are
							started to apply.
						</p>
					</li>
					<li>
						<p>
							Termination of these General Terms &amp; Conditions also determines
							closure of Your Profile and all Accounts.
						</p>
					</li>
					<li>
						<p>
							You may also ask to close one or more of Your Accounts without
							terminating these General Terms &amp; Conditions. If You wish to
							close all Your Accounts, You have to terminate these General Terms
							&amp; Conditions.
						</p>
					</li>
					<li>
						<p>
							By terminating these General Terms &amp; Conditions, closing Your
							Account, You shall notify Us if You wish to receive Account (-s)
							statement (-s) for the last 36 months of use.
						</p>
					</li>
					<li>
						<p>
							We may freeze Your Account if it was not used for the past 12
							months. We may also close Your Account and terminate these General
							Terms &amp; Conditions if all Your Accounts were not used for the
							past 24 months.
						</p>
					</li>
					<li>
						<p>
							If Your Account holds a balance and You have other Accounts, the
							balance will be transferred to the other Account at the time of
							closure. If You do not have one, You have to withdraw Your funds
							until the Account will be closed. After termination of these General
							Terms &amp; Conditions You will not be able to access your Profile,
							but You may withdraw any remaining funds by contacting our customer
							support and requesting that the funds would be transferred to Your
							bank account. Additional {link4} might be applied for the storage of Your funds after termination of
							these General Terms &amp; Conditions.
						</p>
					</li>
					<li>
						<p>
							You may not close your Account, terminate these General Terms &amp;
							Conditions to avoid an investigation. If You attempt to close your
							Account / terminate General Terms &amp; Conditions while Verifo is
							conducting an investigation, We may freeze the Profile / Account (s)
							to protect all parties to the Verifo Services, its affiliates, or a
							third party against any liability. You will remain liable for any
							obligations related to Your Verifo Account and Your activity even
							after it is closed.
						</p>
					</li>
					<li>
						<p>
							The termination of these General Terms &amp; Conditions will not
							affect any of our rights or Your obligations arising under these
							terms of use. Any terms which by their nature should survive, will
							survive the termination of these General Terms &amp; Conditions.
						</p>
					</li>
					<li>
						<p>
							Without prejudice to any rights that are set under these General
							Terms &amp; Conditions, or any party’s other rights or remedies,
							either party may at any time terminate these General Terms &amp;
							Conditions with immediate effect by giving written notice to the
							other party if:
						</p>
						<p>
							a. the other party commits a material breach of any term of these
							General Terms &amp; Conditions and (if such breach is remediable)
							fails to remedy that breach within a period of 30 days after being
							notified in writing to do so;
						</p>
						<p>
							b. the other party repeatedly breaches any of the terms of these
							General Terms &amp; Conditions in such a manner as to reasonably
							justify the opinion that the party has no intention or ability to
							comply with these General Terms &amp; Conditions;
						</p>
						<p>
							c. the result of laws, payment scheme rules, regulatory authority
							rules or guidance or any change in means that it is unlawful or
							contrary to any such law, rules, order or regulations for either of
							the parties to perform or give effect to any of its obligations
							hereunder and such obligation cannot be readily severed from these
							General Terms &amp; Conditions; and / or
						</p>
						<p>
							d. the other party is subject to a bankruptcy, insolvency, winding
							up or other similar event.
						</p>
					</li>
					<li>
						<p>
							Without prejudice to any rights that are set under these General
							Terms &amp; Conditions or any of the party’s rights or remedies, We
							may at any time terminate these General Terms &amp; Conditions
							within date specified in written termination notification if:
						</p>
						<p>
							a. We are unable to verify Your identity and provided information;
						</p>
						<p>
							b. We have reason to believe that Your use of the Verifo Services
							might negatively affect the Verifo Services, System;
						</p>
						<p>
							c. You have acted or omitted to act in any way which we reasonably
							determine to diminish Verifo reputation and/or goodwill and/or which
							We reasonably determine or suspect to give rise to any offense or
							any increased risk or liability to us;
						</p>
						<p>
							d. You violated obligations under art. 1, part VII of these General
							Terms &amp; Conditions.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>Unauthorized payments</strong>
				</p>
				<ol>
					<li>
						<p>
							If you believe that any transaction has been incorrectly performed
							or was not authorized by You, You must inform our customer support
							as soon as possible via email, Live chat or other means of
							communication provided in the System.
						</p>
					</li>
					<li>
						<p>
							Where it is established that the transaction was not authorized by
							You or was incorrectly initiated or performed by Us and You have
							notified Us as soon as You noticed it but not later than within 13
							months of the date of the unauthorized transaction was performed, We
							shall refund to You the full amount debited without authorization.
						</p>
					</li>
					<li>
						<p>
							You agree to report any unauthorized payments to relevant legal
							authorities and share with Verifo the reporting confirmation
							received from the relevant legal authorities.
						</p>
					</li>
					<li>
						<p>You will be liable for:</p>
						<p>
							a. all losses incurred in respect of a payment or currency exchange
							transaction, ATM withdrawal, other transactions made by Us which was
							not authorized by You, if you have acted fraudulently, unfairly or
							have intentionally or with gross negligence failed to comply with
							the obligations set out in part “Security” or you have not notified
							us on time in accordance with art. 2; and
						</p>
						<p>
							b. where art. 3 (a) does not apply, up to 50 EUR of any losses
							incurred in respect of payment or currency exchange transaction, ATM
							withdrawal, other transactions which were not authorized by you
							related with usage of lost / stolen payment instrument or unlawful
							take over the instrument, where you have otherwise failed to comply
							with your obligations under part “Security”.
						</p>
						<p>
							c. Except where You have acted fraudulently or with intentional or
							gross negligence., You will not be liable for any losses incurred in
							respect of a transaction which occurs after you have notified Us,
							without undue delay, on becoming aware of the loss, theft,
							misappropriation or unauthorized use of Your Account or other
							payment instrument.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>Liability</strong>
				</p>
				<ol>
					<li>
						<p>
							We shall not be liable for non-performance or defective performance
							of the transaction we performed in accordance with the incorrect
							unique identifier given to Us by You. However, we shall take
							reasonable efforts to recover funds and may apply additional fees
							for doing so, including but not limited to passing on to You charges
							made by payment service providers for their assistance in the
							tracing process.
						</p>
					</li>
					<li>
						<p>
							We shall not be liable to You for the correct performance of the
							transaction, if We can prove that the receiver’s payment services
							provider received the payment within the appropriate time period. We
							will however, upon your request, make efforts to trace any
							non-performed or defectively performed payment transactions and
							notify You of any outcome involving our search.
						</p>
					</li>
					<li>
						<p>We shall not be liable to You for any:</p>
						<p>
							a. delay or failure to perform our obligations under these General
							Terms &amp; Conditions (including any delay in payment) by reason of
							any cause beyond our reasonable control including but not limited to
							any Force Majeure event, any action or inaction by You or any third
							party, bank, failure or delay of any electronic transmission, any
							accident, emergency, or any other abnormal or unforeseeable
							circumstances; or
						</p>
						<p>
							b. losses as a result of a requirement imposed on Us by the laws of
							any EEA state or other jurisdiction.
						</p>
					</li>
					<li>
						<p>
							In no event shall Verifo be liable for loss of profits or any
							special, incidental or consequential damages arising out of these
							General Terms &amp; Conditions or otherwise in connection with the
							Verifo Services.
						</p>
					</li>
					<li>
						<p>
							You are responsible for understanding and complying with any and all
							laws, rules and regulations of your specific jurisdiction that may
							be applicable to You in connection with Your use of our Services,
							including but not limited to, those related to taxes or foreign
							currency transactions. You are liable to the state and other
							subjects for fulfilment of all tax obligations independently.
						</p>
					</li>
					<li>
						<p>
							You are responsible for all liabilities, financial or otherwise,
							incurred by Verifo, Verifo client or other third party caused by or
							arising out of Your breach of these General Terms &amp; Conditions,
							Your use of our Services. You agree to reimburse Verifo, Verifo
							client or other third party for any and all such liability, to the
							extent not prohibited by applicable law.
						</p>
					</li>
					<li>
						<p>
							You remain liable under these General Terms &amp; Conditions in
							respect of all fees, charges and other amounts incurred through the
							use of our Services at any time, irrespective of termination,
							suspension or closure.
						</p>
					</li>
					<li>
						<p>
							You agree to indemnify Us and hold Verifo, our partners, our
							employees or agents who are authorized to act on our behalf harmless
							from any claim or demand (including legal fees) made or incurred by
							any third party due to or arising out of Your breach of these
							General Terms &amp; Conditions, breach of any law and/ or use of our
							Services.
						</p>
					</li>
					<li>
						<p>
							To the extent permitted by applicable law, Verifo is not liable, and
							You agree not to hold Us responsible, for any damages or losses
							(including, but not limited to, loss of money, goodwill, or
							reputation, profits or any special, indirect, or consequential
							damages) resulting directly or indirectly from:
						</p>
						<p>a. delays or disruptions in our Services;</p>
						<p>b. Your inability to use our Services for any reason;</p>
						<p>
							c. viruses or other malicious software obtained by accessing our
							website or any associated site or service;
						</p>
						<p>d. the content, actions, or inaction of third parties;</p>
						<p>
							e. illegal actions and operations of third persons performed using
							counterfeited and/or illegal documents or illegally received data;
						</p>
						<p>
							f. glitches, bugs, errors, or inaccuracies of any kind in our
							Services;
						</p>
						<p>g. any actions taken with respect to You, Your Account / Profile;</p>
						<p>
							h. Your need to modify practices, content, or behavior, or Your loss
							of or inability to do business, as a result of changes to these
							General Terms &amp; Conditions or our policies.
						</p>
					</li>
					<li>
						<p>
							In the event which entitles Us to be compensated by You (including,
							but not limited to, any technical errors on our behalf or on behalf
							of our partners), we shall be entitled to set-off the amount You owe
							Us in that currency or in a different currency by deducting amounts
							from Your Account. If the amount You owe to Us is in a currency
							which is different to the e-money You hold in the Account, We shall
							exchange the currency applying our currency exchange rates. We do
							not need to notify you of this conversion occurring.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>Security</strong>
				</p>
				<ol>
					<li>
						<p>
							You shall pay attention to the fact that Verifo services are
							financial services, accordingly You shall take all reasonable steps
							to protect Your Profile, Account, Personalized safety features and
							Your hardware/ software used for login to Profile. Any fail to do so
							may cause You financial losses.
						</p>
					</li>
					<p>
						<strong>Password, PIN</strong>
					</p>
					<li>
						<p>
							Any password You create shall be unique and consist of at least 8
							symbols, including capital and small letters, numbers and special
							symbols.
						</p>
					</li>
					<li>
						<p>
							The password shall not include information about You, family
							members, pets which can be known or easily guessed by third persons,
							such as: names, surnames, birth dates, addresses or their fragments.
							Also, it shall not consist of easily memorable and/ or guessable
							combinations of numbers and letters.
						</p>
					</li>
					<li>
						<p>Password, PIN shall be changed at least once in 3 or 6 months.</p>
					</li>
					<li>
						<p>
							The password, PIN shall not be used for logins to other systems,
							accounts, etc.
						</p>
					</li>
					<li>
						<p>
							You shall remember password, PIN and not write it down anywhere,
							shall not enter in mobile phone, email or other electronic means of
							communication, and shall not reveal it to third persons. You are
							solely responsible for the safety of password and PIN.
						</p>
					</li>
					<li>
						<p>
							Verifo does not initiate notifications (via SMS messages, emails,
							calls, etc.) with the offer / request to change the password or
							links to the password reset page. If the You receive such
							notification, You shall immediately inform our customer support.
						</p>
					</li>
					<li>
						<p>
							If You receive any SMS or email, questionnaires, surveys, or other
							links that require You to provide your PIN, password or other
							Personalized safety feature, You shall not provide Your information
							and contact our customer support.
						</p>
					</li>
					<li>
						<p>
							If You believe that the password, PIN may be known to any third
							person, You shall immediately change it and contact our customer
							support.
						</p>
					</li>
					<p>
						<strong>E-mail, phone</strong>
					</p>
					<li>
						<p>
							Your email, phone used for communication with Verifo, authentication
							shall be secured with password / PIN as it is described above.
						</p>
					</li>
					<li>
						<p>Email and phone shall be used only by You.</p>
					</li>
					<li>
						<p>
							If You notice any suspicious activity on email account, You shall
							immediately inform our customer support thereof and change email and
							Profile passwords.
						</p>
					</li>
					<li>
						<p>
							If You lose Your phone, You shall immediately inform our customer
							support and change Your Profile passwords.
						</p>
					</li>
					<p>
						<strong>Devices / software</strong>
					</p>
					<li>
						<p>
							You shall have a continuously updated antivirus program installed on
							Your devices.
						</p>
					</li>
					<li>
						<p>
							All Your devices used to login to Profile, to communicate with
							Verifo shall be secured with a PIN or password.
						</p>
					</li>
					<li>
						<p>
							You are responsible for safety of devices used to log in to the
							Profile, shall not leave them unattended, in public places or
							otherwise easily accessible to third persons.
						</p>
					</li>
					<li>
						<p>
							You shall update software, applications, anti-virus programs,
							browsers and other programs in time.
						</p>
					</li>
					<li>
						<p>
							You shall use only original software and its standard instruments
							provided with the device and shall not perform any amendments to the
							system files.
						</p>
					</li>
					<li>
						<p>
							You are forbidden to use features which allow to save login data on
							the device or browser.
						</p>
					</li>
					<li>
						<p>
							You shall close any application used for login, transactions, other
							Services every time You are not using it.
						</p>
					</li>
					<p>
						<strong>Profile</strong>
					</p>
					<li>
						<p>
							After finishing work within the Profile, You shall log out from the
							System and shall not leave the Profile accessible to third persons.
						</p>
					</li>
					<li>
						<p>
							You are highly not recommended to login to the Profile via public
							computers or devices of other persons.
						</p>
					</li>
					<li>
						<p>
							You shall update contact information on the Profile in time
							(including but not limited to phone number and email address), so
							that Verifo could contact You.
						</p>
					</li>
					<li>
						<p>
							You shall perform all reasonable instructions provided in the
							System, related to safety of payment instruments, personalized
							safety features.
						</p>
					</li>
					<li>
						<p>
							If You notice any suspicious activity on Profile and believe that
							third persons may have logged in Your Profile, You shall immediately
							inform our customer support thereof and request to freeze the
							Account.
						</p>
					</li>
					<p>
						<strong>Our rights</strong>
					</p>
					<li>
						<p>
							We can freeze (block) Your Profile, Account, payments instrument if
							Verifo has suspicions related with safety of Your Profile, Account,
							payment instrument, unauthorized or unfair usage of Account, payment
							instrument, if there is high risk that You may not fulfill Your
							payment obligations.
						</p>
					</li>
					<li>
						<p>
							Where it is possible, We will provide You with the relevant
							information regarding the actions imposed, but We may be unable to
							do so in accordance with the appropriate legislation or safety
							requirements.
						</p>
					</li>
					<p>
						<strong>Information about security breaches</strong>
					</p>
					<li>
						<p>
							If We have reasons to believe that any security breach or fraud
							might have happened, We will inform You about our concerns via our
							System. In case the provision of information via System would not be
							possible, We will provide You encrypted message via email. General
							security concerns might be provided via public means of
							communication (such as social networks or media).
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>Complaints</strong>
				</p>
				<ol>
					<li>
						<p>
							Any complaints about Us or the Services We provide should be
							addressed at our customer support.
						</p>
					</li>
					<li>
						<p>
							You should clearly indicate that You are wishing to make a complaint
							to Us. You should submit a complaint according to Our {link8}.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>Intellectual property</strong>
				</p>
				<ol>
					<li>
						<p>
							Verifo System, website, Services, logo and all intellectual property
							rights contained therein, including but not limited to any content,
							are owned or licensed by Us. Intellectual property rights mean
							rights such as: trademarks, copyright, domain names, database
							rights, design rights, patents and all other intellectual property
							rights of any kind whether or not they are registered (anywhere in
							the world). You may not copy, imitate or use them without our prior
							written consent.
						</p>
					</li>
					<li>
						<p>
							Nothing in these General Terms &amp; Conditions grants You any legal
							rights to the Verifo system and/or the website, other than is
							necessary to enable Your access to Profile / Accounts.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>Warranties</strong>
				</p>
				<ol>
					<li>
						<p>
							Verifo services, Verifo system are provided on an “as is” and
							without any express, implied or statutory representation or
							warranty.
						</p>
					</li>
					<li>
						<p>
							Verifo does not warrant that the Services will be uninterrupted or
							error free. Verifo shall not be responsible for any service
							interruptions, including, but not limited to, system failures or
							other interruptions that may affect the receipt, performing,
							completion or settlement of transactions or the Services.
						</p>
					</li>
					<li>
						<p>
							Verifo does not have any control over the products or services that
							are paid for using the Services. Verifo is not responsible for the
							quality, performance, or any consequential results of the products
							and/or services purchased using the Services.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>Third party providers</strong>
				</p>
				<ol>
					<li>
						<p>
							You can choose to allow a Third-Party Provider to access information
							on Your Account, to make payments from your Account, if Third Party
							Provider has license for such activity and Your explicit consent.
							Verifo is not liable for any actions of such Third-Party Providers.
						</p>
					</li>
					<li>
						<p>
							If you do, you must inform Us of any incorrect or unauthorized
							transactions that happened so We could take steps to stop further
							misuse of Your payment instruments and arrange any refund You’ve
							been entitled to.
						</p>
					</li>
					<li>
						<p>
							We can refuse or stop access to a Third-Party Provider if We believe
							it isn’t authorized or if we believe it’s fraudulent or acting
							fraudulently. If that happens, We’ll inform You why unless We
							believe that would compromise our security or it would be unlawful.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p>
					<strong>Concluding provisions</strong>
				</p>
				<ol>
					<li>
						<p>
							These General Terms &amp; Conditions shall be governed by the laws
							of Lithuania and any claim or dispute under these General Terms
							&amp; Conditions shall be subject to the jurisdiction of the Courts
							of Lithuania according to the headquarters of Verifo.
						</p>
					</li>
					<li>
						<p>
							You cannot assign or transfer legal ownership of the Account to
							anyone.
						</p>
					</li>
					<li>
						<p>
							You may not transfer or assign or sell any rights or obligations you
							have under these General Terms &amp; Conditions or otherwise grant
							any third party a legal or equitable interest over your Account
							without Verifo prior written consent.
						</p>
					</li>
					<li>
						<p>
							Verifo reserves the right to transfer or assign these General Terms
							&amp; Conditions or any right or obligation under these General
							Terms &amp; Conditions at any time.
						</p>
					</li>
					<li>
						<p>
							Unless stated otherwise in these General Terms &amp; Conditions, if
							any provision of these General Terms &amp; Conditions is held to be
							invalid or unenforceable, such provision shall be struck and the
							remaining provisions shall be enforced.
						</p>
					</li>
					<li>
						<p>
							These General Terms &amp; Conditions are concluded for an indefinite
							period.
						</p>
					</li>
				</ol>
			</li>
		</ol>`
	},
	personalBankAccountStatementExplanation: {
		id: 'fe.personal_bank_account_statement_explanation',
		defaultMessage:
			"Personal bank statement of the owner of the company. It should be clear to see that the owner is capable to support the company's activity."
	},
	bankAccountStatementExplanation: {
		id: 'fe.bank_account_statement_explanation',
		defaultMessage:
			'Bank account statement for the most recent 3 months in PDF format. The documents must contain the account holder’s full name.'
	},
	agreementWithBusinessPartnersExplanation: {
		id: 'fe.agreement_with_business_partners_explanation',
		defaultMessage:
			'Documents with information about the main business partners. Any confidential information can be hidden.'
	},
	licenseExplanation: {
		id: 'fe.license_explanation',
		defaultMessage:
			'A legal document that grants the right to operate a business in a certain country.'
	},
	financialStatementsExplanation: {
		id: 'fe.financial_statements_explanation',
		defaultMessage:
			'Audited financial statements of the company for the most recent year available.{br}If the financial statements are not available, please provide all other available documents that would help explain financial activities for the most recent 12 months: bank statements, agreements with partners or/and clients, invoices issued, etc.'
	},
	financialStatementsForLastThreeYearsExplanation: {
		id: 'fe.financial_statements_for_last_three_years_explanation',
		defaultMessage:
			'Audited financial statements of the company for the most recent 3 year.{br}If the financial statements are not available, please provide all other available documents that would help explain financial activities for the most recent 3 years: bank statements, agreements with partners or/and clients, invoices issued, etc.'
	},
	proofOfAddressExplanation: {
		id: 'fe.proof_of_address_explanation',
		defaultMessage:
			'Utility bill or a bank statement (which is no older than 3 months) with the full address visible.{br}Screenshots will not be accepted. The document must be written in Latin characters only and must contain the following information:'
	},
	proofOfAddressExplanationContains1: {
		id: 'fe.proof_of_address_explanation_containes_1',
		defaultMessage: 'Name of the issuing entity'
	},
	proofOfAddressExplanationContains2: {
		id: 'fe.proof_of_address_explanation_containes_2',
		defaultMessage: 'Address of the issuing entity'
	},
	proofOfAddressExplanationContains3: {
		id: 'fe.proof_of_address_explanation_containes_3',
		defaultMessage:
			"The customer's full name (documents with abbreviations will not be accepted)"
	},
	proofOfAddressExplanationContains4: {
		id: 'fe.proof_of_address_explanation_containes_4',
		defaultMessage: "The customer's current residential address"
	},
	proofOfAddressExplanationContains5: {
		id: 'fe.proof_of_address_explanation_containes_5',
		defaultMessage: 'Date of issuance.'
	},
	certificateOfIncorporationOrExtractExplanation: {
		id: 'fe.certificate_of_incorporation_or_extract_explanation',
		defaultMessage: `The document must be certified as a true copy of the original by the Notary Public;{br}OR a publicly available source to a business register, where the information regarding the company can be identified;{br}OR legalized with an apostille.{br}Only documents in Lithuanian or English languages will be accepted. Documents in other languages must contain an officially certified English translation (e.g., signed by a translation office, notary, or attorney).`
	},
	memorandumAndArticlesOfAssociationExplanation: {
		id: 'fe.memorandum_and_articles_of_association_explanation',
		defaultMessage: `The document must be certified as a true copy of the original by the Notary Public;{br}OR a publicly available source to a business register, where the information regarding the company can be identified;{br}OR legalized with an apostille.{br}{br}Only documents in Lithuanian or English languages will be accepted. Documents in other languages must contain an officially certified English translation (e.g., signed by a translation office, notary, or attorney).`
	},
	companysRegisterOfShareholdersAndDirectorsExplanation: {
		id: 'fe.companys_register_of_shareholders_and_directors_explanation',
		defaultMessage:
			'The document must not be older than 6 months and must be certified as a true copy of the original by the Notary Public;{br}OR a publicly available source to a business register, where the information regarding the company can be identified;{br}OR legalized with an apostille.{br}{br}Only documents in Lithuanian or English languages will be accepted. Documents in other languages must contain an officially certified English translation (e.g., signed by a translation office, notary, or attorney).'
	},
	utilityBillExplanation: {
		id: 'fe.utility_bill_explanation',
		defaultMessage:
			'Gas, electricity, internet broadband or water bills in PDF format and no older than 3 months.'
	},
	sourceOfWealthExplanation: {
		id: 'fe.source_of_wealth_explanation',
		defaultMessage:
			'Please provide <bold>at least one</bold> of documents listed below (documents must contain the account holders full name, amounts and currency of the funds):'
	},
	sourceOfWealthExplanationContent1: {
		id: 'fe.source_of_wealth_explanation_content_1',
		defaultMessage:
			'Employment income (e.g., pay slips or bank statement for the most recent 3 months. The salary must be clearly identifiable, tax return statement / income declaration for the most recent year)'
	},
	sourceOfWealthExplanationContent2: {
		id: 'fe.source_of_wealth_explanation_content_2',
		defaultMessage:
			'Maturity of life policy (e.g., life policy and bank statements clearly showing the payout)'
	},
	sourceOfWealthExplanationContent3: {
		id: 'fe.source_of_wealth_explanation_content_3',
		defaultMessage:
			'Sale of investments (e.g., investments certificates, bank statements, tax return statement / income declaration for the most recent year)'
	},
	sourceOfWealthExplanationContent4: {
		id: 'fe.source_of_wealth_explanation_content_4',
		defaultMessage:
			'Property sale (e.g., sale contract, bank statements, tax return statement / income declaration for the most recent year)'
	},
	sourceOfWealthExplanationContent5: {
		id: 'fe.source_of_wealth_explanation_content_5',
		defaultMessage:
			'Company sale (e.g., contract of sale, bank statements, tax return statement / income declaration for the most recent year)'
	},
	sourceOfWealthExplanationContent6: {
		id: 'fe.source_of_wealth_explanation_content_6',
		defaultMessage:
			'Divorce settlement (e.g.: court order AND a bank account statement where payment would be clearly visible)'
	},
	sourceOfWealthExplanationContent7: {
		id: 'fe.source_of_wealth_explanation_content_7',
		defaultMessage:
			'Deposit, savings (e.g., documents showing how savings were acquired, saving statements)'
	},
	sourceOfWealthExplanationContent8: {
		id: 'fe.source_of_wealth_explanation_content_8',
		defaultMessage:
			'Inheritance (e.g., a will signed by a licensed solicitor, bank statements or other documentary evidence (depends on the inherited assets)'
	},
	sourceOfWealthExplanationContent9: {
		id: 'fe.source_of_wealth_explanation_content_9',
		defaultMessage:
			"Gift or donation (e.g., documentary evidence of donor's source of wealth, bank statements, gift/donation agreement)"
	},
	sourceOfWealthExplanationContent10: {
		id: 'fe.source_of_wealth_explanation_content_10',
		defaultMessage:
			'Lottery or gambling win (e.g., statement from the gambling platform, evidence from the lottery company, cheque)'
	},
	sourceOfWealthExplanationContent11: {
		id: 'fe.source_of_wealth_explanation_content_11',
		defaultMessage: 'Retirement income (e.g.: pension statements, bank statements)'
	},
	sourceOfWealthExplanationContent12: {
		id: 'fe.source_of_wealth_explanation_content_12',
		defaultMessage: 'Company profits (e.g., copy of latest audited company accounts)'
	},
	sourceOfWealthExplanationContent13: {
		id: 'fe.source_of_wealth_explanation_content_13',
		defaultMessage:
			'Dividend payments (e.g., dividend certificate, copy of latest audited company accounts)'
	},
	sourceOfWealthExplanationContent14: {
		id: 'fe.source_of_wealth_explanation_content_14',
		defaultMessage:
			'Loan agreement (e.g., loan agreement AND a bank account statement where payment would be clearly visible, re-pay schedule,)'
	},
	anyOtherRelevantDocumentExplanation: {
		id: 'fe.any_other_relevant_document_explanation',
		defaultMessage:
			'Any other documents that are believed to help understand financial activities.'
	},
	proofOfBankAccountOpenedInEUExplanation: {
		id: 'fe.proof_of_bank_account_opened_in_EU_explanation',
		defaultMessage:
			'A bank statement that helps identify the owner of the account. The document must be in PDF format, no older than 3 months and cannot be a statement from an e-money institution.'
	},
	pageOfPassportWithIssueAndExpiryExplanation: {
		id: 'fe.page_of_passport_with_issue_and_expiry_explanation',
		defaultMessage:
			'A picture of the side of the passport that contains the issue and expiry dates of the document.'
	},
	statementOfCryptoWalletsWithThreeMonthsActivitiesExplanation: {
		id: 'fe.statement_of_crypto_wallets_with_three_months_activities_explanation',
		defaultMessage:
			"A statement from wallets or cryptocurrency exchanges where it would be clear to see the account's activity: dates and amounts of purchases and sales for at least 3 months."
	},
	identificationDocumentsOfRelatedPersonsExplanation: {
		id: 'fe.identification_documents_of_related_persons_explanation',
		defaultMessage:
			'A clear and valid copy of the identification document (passport or national ID card) for each Ultimate Beneficial Owner (UBO), Shareholder and the Head of the company that were indicated in questionnaire. The document must be in colour, show the full name, date of birth, and photo of the individual, and represent both sides of the document (for national ID cards)'
	},
	selectTheMostRelevantCountries: {
		id: 'fe.select_the_most_relevant_countries',
		defaultMessage: 'Select the most relevant countries'
	},
	doYouConductBusinessInOtherCountries: {
		id: 'fe.do_you_conduct_business_in_other_countries',
		defaultMessage:
			'Do you or your company conduct business in other country(s) besides where you are registered?'
	},
	whatPercentageOfBusinessActivityIsHandledInCash: {
		id: 'fe.what_percentage_of_business_activity_is handled_in_cash',
		defaultMessage:
			'What percentage of turnover in individual or business activity is handled in cash? Cash is money in the physical form of currency, such as banknotes and coins'
	},
	whatPercentageOfTurnoverIsHandledInCryptoCurrencies: {
		id: 'fe.percentage_turnover_in_crypto_currencies',
		defaultMessage:
			'What percentage of turnover in individual or business activity is handled in crypto currencies?'
	},
	isIndividualActivityRgisteredInPreferentialTaxZone: {
		id: 'fe.is_individual_activity_registered_in_preferential_tax_zone',
		defaultMessage:
			'Is individual activity or business registered or conducted in preferential tax zone (for instance, free economic zone, offshore jurisdiction)?'
	},
	indicateAverageAmountYouPlanToReceiveAndSend: {
		id: 'fe.indicate_average_amount_you_plan_to_receive_and_send',
		defaultMessage:
			'Please indicate the average EUR amount you plan to receive and send per month. It is not operational limits, you will be able to set your limits lower or higher.'
	},
	pleaseSelectAllFundCountries: {
		id: 'fe.please_select_all_fund_countries',
		defaultMessage:
			'Please select all countries to which and from which you are planing send and receive funds.'
	},
	cashExplanation: {
		id: 'fe.explanation_what_is_cash',
		defaultMessage:
			'Cash is money in the physical form of currency, such as banknotes and coins'
	},
	cashExplanationExtended: {
		id: 'fe.explanation_what_is_cash_extended',
		defaultMessage:
			'Cash is money in the physical form of currency, such as banknotes and coins. Rounded to closest percentage point.'
	},
	turnoversExceed100: {
		id: 'fe.warning_crypto_and_cash_turnovers_cannot_exceed_100_percent',
		defaultMessage:
			'Your cash turnover and crypto turnovers added exceed 100%, please review your answers.'
	},
	verificationQuestions: {
		id: 'fe.verification_questions',
		defaultMessage: 'Verification questions'
	},
	verificationQuestionsSubtitle: {
		id: 'fe.answer_additional_questions_to_proceed',
		defaultMessage:
			"Answer the additional verification questions below in order to proceed with your account's verification."
	},
	additionalQuestionsSubmitFailed: {
		id: 'fe.additional_questions_submit_failed_contact_support',
		defaultMessage: 'Failed to submit additional questions, try again or contact support.'
	},
	failed: {
		id: 'fe.failed',
		defaultMessage: 'Failed'
	},
	fillYourAnswerHere: {
		id: 'fe.fill_your_answer_here',
		defaultMessage: 'Fill in your answer here'
	},
	copy: {
		id: 'fe.copy',
		defaultMessage: 'Copy'
	},
	copyInvitationLinkBelow: {
		id: 'fe.copy_invitation_link_below',
		defaultMessage:
			'Now, copy the link provided below and send it to the company representative. They will have to finish the verification themselves.'
	},
	downloadFile: {
		id: 'fe.download_file',
		defaultMessage: 'Download file'
	},
	supportingDocumentDownloadLinkFailed: {
		id: 'fe.supporting_document_download_link_failed',
		defaultMessage: 'Failed to fetch document download link.'
	},
	successfullyCopied: {
		id: 'fe.successfully_copied',
		defaultMessage: 'Successfully coppied'
	},
	loading: {
		id: 'fe.loading',
		defaultMessage: 'Loading...'
	},
	searchForAddress: {
		id: 'fe.search_for_address',
		defaultMessage: 'Search for address'
	},
	pleaseEnterRegisteredAddress: {
		id: 'fe.please_enter_an_address_where_you_are_registered',
		defaultMessage: 'Please enter an address where you are registered'
	},
	searchPlaces: {
		id: 'fe.search_places',
		defaultMessage: 'Search Places ...'
	},
	specifyEmailForFurhterCommunication: {
		id: 'fe.specify_your_email_for_further_communication',
		defaultMessage:
			'Enter your email address(es) – it will be used for further communication regarding the verification process.'
	},
	handoverPageTitle: {
		id: 'fe.are_you_the_representative_of_the_client',
		defaultMessage: 'Are you the representative of the client?'
	},
	handoverPageTitlePPB: {
		id: 'fe.are_you_the_representative_of_the_client_ppb',
		defaultMessage:
			'Are you the representative (the head of the company or a person otherwise authorized to act on behalf of the legal entity) of the client?'
	},
	handoverPageText1: {
		id: 'fe.confirm_if_you_are_the_companys_representative',
		defaultMessage: `Representative shall mean the CEO or other authorized person to act on behalf of the client`
	},
	addressSelected: {
		id: 'fe.address_selected',
		defaultMessage: 'Address selected'
	},
	pleaseProvidePrefillerEmail: {
		id: 'fe.please_provide_prefiller_email',
		defaultMessage: 'Please enter the email address of yourself'
	},
	prefillerInputPlaceholder: {
		id: 'fe.please_enter_address_and_press_enter',
		defaultMessage: 'Enter email address'
	},
	emailAddressInvalid: {
		id: 'fe.must_be_a_valid_email_address',
		defaultMessage: 'Must be a valid email address'
	},
	emailAlreadySaved: {
		id: 'fe.email_already_saved',
		defaultMessage: 'Email already saved'
	},
	descriptionAND: {
		id: 'fe.tin_description_AND',
		defaultMessage: `Please enter your TIN code (Número de Registre Tributari). TIN can be found on tax identification card. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Andorra-TIN.pdf</a>`
	},
	descriptionAIA: {
		id: 'fe.tin_description_AIA',
		defaultMessage: `Please enter your TIN code. TINs can be found on the registration reports and on all official documents issued by the IRD for taxpayers such as notices of assessments and certificates. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Anguilla-TIN.pdf</a>`
	},
	descriptionATG: {
		id: 'fe.tin_description_ATG',
		defaultMessage: `Please enter your TIN (PIN) code. TIN is not issued automatically, if you do not have one, fill “NA” in the field.  More information : <a>https://ird.gov.ag/wp-content/uploads/2021/07/How-do-I-obtain-a-TIN-for-Personal-Income-Tax-Ver-2.pdf</a>`
	},
	descriptionARG: {
		id: 'fe.tin_description_ARG',
		defaultMessage: `Please enter your TIN (C.U.I.T - Clave Única de Identificación Tributaria) code. Once the CUIT assigned, any person may enter the AFIP’s website and see the Proofs of Registration or Registration of Monotributo of any of the registered taxpayers, if you do not have one, fill “NA” in the field.  More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/TIN_Argentina.pdf</a>`
	},
	descriptionABW: {
		id: 'fe.tin_description_ABW',
		defaultMessage: `Please enter your TIN code. A TIN is allocated to a natural person or entity if the person or entity requests this at the Tax Department. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Aruba-TIN.pdf</a>`
	},
	descriptionAUS: {
		id: 'fe.tin_description_AUS',
		defaultMessage: `Please enter your TFN (Tax File Number) if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Australia-TIN.pdf</a>`
	},
	descriptionAUT: {
		id: 'fe.tin_description_AUT',
		defaultMessage: `Please enter your TIN code (Abgabenkontonummer). TIN numbers can be found on tax assessments in the right upper corner on the first page, if you do not have one, fill “NA” in the field.  More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Austria-TIN.pdf</a>`
	},
	descriptionAZE: {
		id: 'fe.tin_description_AZE',
		defaultMessage: `Please enter your TIN or PIN code. TIN can be found on business license, PIN code can be found on passport and identity card. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Azerbaijan-TIN.pdf</a>`
	},
	descriptionBHS: {
		id: 'fe.tin_description_BHS',
		defaultMessage: `There is no TIN`
	},
	descriptionBHR: {
		id: 'fe.tin_description_BHR',
		defaultMessage: `There is no TIN`
	},
	descriptionBRB: {
		id: 'fe.tin_description_BRB',
		defaultMessage: `Please enter your TIN code. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Barbados-TIN.pdf</a>`
	},
	descriptionBEL: {
		id: 'fe.tin_description_BEL',
		defaultMessage: `Please enter your TIN code (Numéro National (NN)) . Residents of Belgium can find their TIN number on their identity card. For non-residents of Belgium TIN number can be found on residence card and car registration certificate. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Belgium-TIN.pdf</a>`
	},
	descriptionBLZ: {
		id: 'fe.tin_description_BLZ',
		defaultMessage: `Please enter your TIN code. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Belize-TIN.pdf</a>`
	},
	descriptionBMU: {
		id: 'fe.tin_description_BMU',
		defaultMessage: `There is no TIN`
	},
	descriptionBRA: {
		id: 'fe.tin_description_BRA',
		defaultMessage: `Please enter your TIN code (CPF (individuals) or CNPJ (legal persons)). TIN can be found on CPF card, ID card, driver license, Professional Identity Cards (i.e. Bar Association). More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Brazil-TIN.pdf</a>`
	},
	descriptionVGB: {
		id: 'fe.tin_description_VGB ',
		defaultMessage: `There is no TIN`
	},
	descriptionBRN: {
		id: 'fe.tin_description_BRN',
		defaultMessage: `Please enter your TIN code (NRIC Number).  More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Brunei-darussalam-TIN%20.pdf</a>`
	},
	descriptionBGR: {
		id: 'fe.tin_description_BGR',
		defaultMessage: `Please enter your TIN code (Единен граждански номер). TIN number can be found on passport, identification card, driving license and Certificate of Fiscal Residence. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Bulgaria%20-%20TIN.pdf</a>`
	},
	descriptionCAN: {
		id: 'fe.tin_description_CAN',
		defaultMessage: `Please enter your TIN code. For individuals, their TIN code is nine-digit Canadian Social Insurance Number (SIN), for corporations TIN is known as Business Number (BN), if you do not have one, fill “NA” in the field.  More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Canada-TIN.pdf</a>`
	},
	descriptionCYM: {
		id: 'fe.tin_description_CYM',
		defaultMessage: `There is no TIN`
	},
	descriptionCHL: {
		id: 'fe.tin_description_CHL',
		defaultMessage: `Please enter your TIN (RUT) code. The RUT given by the Civil Registry is the same as the RUT in the case of individuals resident in Chile. Tin code can be found on National Identity Card, Driver’s license, Deeds, Contracts and Invoices. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Chile-TIN.pdf</a>`
	},
	descriptionCHN: {
		id: 'fe.tin_description_CHN',
		defaultMessage: `Please enter your TIN code. Only for individuals using Chinese ID card as their identification as TIN is their ID numbers. As for individuals using passports or other ID certificates as their identification, the issuance of the Chinese TIN occurs following a first tax-return or following a first tax payment obligation. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/China-TIN.pdf</a>`
	},
	descriptionCOL: {
		id: 'fe.tin_description_COL',
		defaultMessage: `Please enter your TIN (RUT) code. TIN consist of 1 and up to 13 digits plus a verification digit on citizenship cards with identification numbers, identification types of identity card. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Colombia-TIN.pdf</a>`
	},
	descriptionCOK: {
		id: 'fe.tin_description_COK',
		defaultMessage: `Please enter your TIN code. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Cook-Islands_TIN.pdf</a>`
	},
	descriptionCRI: {
		id: 'fe.tin_description_CRI',
		defaultMessage: `Please enter your TIN (PIN) code. Physical Identification Number is used as TIN, it is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Costa-Rica-TIN.pdf</a>`
	},
	descriptionHRV: {
		id: 'fe.tin_description_HRV',
		defaultMessage: `Please enter your TIN code (Osobni identifikacijski broj). TIN number can be found on passport or identification card (main side of the card). More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Croatia-TIN.pdf</a>`
	},
	descriptionCUW: {
		id: 'fe.tin_description_CUW',
		defaultMessage: `Please enter your TIN code. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Curacao-TIN.pdf</a>`
	},
	descriptionCYP: {
		id: 'fe.tin_description_CYP',
		defaultMessage: `Please enter your TIN code (ΑΡΙΘΜΟΙ ΦΟΡΟΛΟΓΙΚΗΣ ΤΑΥΤΟΠΟΙΗΣΗΣ (ΑΦΤ)). TIN numbers are reported in the following official documents of identification: natural person - income tax self-assessment, entities - tax self-assessment. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Cyprus-TIN.pdf</a>`
	},
	descriptionCZE: {
		id: 'fe.tin_description_CZE',
		defaultMessage: `Please enter your TIN code (Rodné číslo). TIN number can be found on passport or identification card. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/CZ-TIN.pdf</a>`
	},
	descriptionDNK: {
		id: 'fe.tin_description_DNK',
		defaultMessage: `Please enter your TIN code (CPR-nummer or personnummer). TIN number can be found on passport, identification card, health insurance card/social security card or drivers licence. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Denmark-TIN.pdf</a>`
	},
	descriptionDMA: {
		id: 'fe.tin_description_DMA',
		defaultMessage: `Please enter your TIN code. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Dominica-TIN.pdf</a>`
	},
	descriptionECU: {
		id: 'fe.tin_description_ECU',
		defaultMessage: `Please enter your TIN code. TIN code is thirteen-digit Ecuadorian tax identification number (RUC).  TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Ecuador-TIN.pdf</a>`
	},
	descriptionEST: {
		id: 'fe.tin_description_EST',
		defaultMessage: `Please enter your TIN code (Isikukood). TIN number can be found on passport, identification card or driving license. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Estonia-TIN.pdf</a>`
	},
	descriptionFRO: {
		id: 'fe.tin_description_FRO',
		defaultMessage: `Please enter your TIN code. In the Faroe Islands the TIN equals the Faroese P Number. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Faroe-islands-TIN.pdf</a>`
	},
	descriptionFIN: {
		id: 'fe.tin_description_FIN',
		defaultMessage: `Please enter your TIN code (Veronumero). TIN number can be found on passport, identification card or driving license. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Finland-TIN.pdf</a>`
	},
	descriptionFRA: {
		id: 'fe.tin_description_FRA',
		defaultMessage: `Please enter your TIN code (Numéro fiscal de référence or numéro SPI). For individuals TIN number can be found on pre-filled tax return (field “N° Fiscal declarant”), notice of assessment (field “Numéro fiscal”) and for entities, numéro SIREN is reported on the accounting documents. TIN is not issued automatically, if you do not have one, fill “NA” in the field. TIN is automatically issued to an individual once this individual is identified by the French Tax administration (FTA) as a taxpayer (person having a fiscal obligation). If you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/France-TIN.pdf</a>`
	},
	descriptionDEU: {
		id: 'fe.tin_description_DEU',
		defaultMessage: `Please enter your TIN code (Die steuerliche Identifikationsnummer). TIN number can be found in the income tax assessment, on employment tax statement or in the information letter of the Federal Central Tax Office. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Germany-TIN.pdf</a>`
	},
	descriptionGHA: {
		id: 'fe.tin_description_GHA',
		defaultMessage: `Please enter your TIN code. Tin can be found on any return, claim, declaration, notice, statement ,or other documents for the purpose of a tax Law, Company Registration Certificate, Business Name Certificate, Taxpayer Identification Number Certificate. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Ghana-TIN.pdf</a>`
	},
	descriptionGIB: {
		id: 'fe.tin_description_GIB',
		defaultMessage: `Please enter your TIN code (Taxpayer reference number). Gibraltar’s taxpayer reference numbers can be found on documents issued by the Income Tax Office, such as tax return forms, assessments and tax code advice statements. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Gibraltar-TIN.pdf</a>`
	},
	descriptionGRC: {
		id: 'fe.tin_description_GRC',
		defaultMessage: `Please enter your TIN code (ΑΡΙΘΜΟΙ ΦΟΡΟΛΟΓΙΚΗΣ ΤΑΥΤΟΠΟΙΗΣΗΣ (ΑΦΤ) or CPR number). TIN number can be found on Tax Completeness Status, Tax Refund Status, Certification of issued TIN. TIN is issued upon request by the concerned individual that holds such obligation, If you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Greece-TIN.pdf</a>`
	},
	descriptionGRL: {
		id: 'fe.tin_description_GRL',
		defaultMessage: `Please enter your TIN code (TIN eor nd equals companies etc.). For natural persons the CPR number (TIN number) appears on official identification documents; passport, residence certificate and driving license. The non-natural person or company will receive a GER registration certificate mentioning the GER number. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Greenland-TIN.pdf</a>`
	},
	descriptionGRD: {
		id: 'fe.tin_description_GRD',
		defaultMessage: `Please enter your TIN code. TINs are found on tax remittances forms and statements issued to taxpayers. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Grenada-TIN.pdf</a>`
	},
	descriptionGGY: {
		id: 'fe.tin_description_GGY',
		defaultMessage: `Please enter your TIN code (Guernsey Social security number or UK National Insurance Number (NINO) or Jersey Social Security Number). For individuals, the TIN can be found on the Social Security Contribution and Social Security Insurance Cards (issued by Guernsey Social Security Department) and on individual’s payslip, issued by their employer. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Guernsey-TIN.pdf</a>`
	},
	descriptionHKG: {
		id: 'fe.tin_description_HKG',
		defaultMessage: `Please enter your TIN code (Hong Kong Identity Card (HKID) number). The HKID is an official identity document issued by the Immigration Department of Hong Kong. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Hong-Kong-TIN.pdf</a>`
	},
	descriptionHUN: {
		id: 'fe.tin_description_HUN',
		defaultMessage: `Please enter your TIN code (Adóazonosító jel). TIN number can be found on TIN card. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Hungary-TIN.pdf</a>`
	},
	descriptionISL: {
		id: 'fe.tin_description_ISL',
		defaultMessage: `Please enter your TIN code (Kennitala). TIN number can be found on driving license, debit cards, bank statements and tax returns. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Iceland-TIN.pdf</a>`
	},
	descriptionIND: {
		id: 'fe.tin_description_IND',
		defaultMessage: `Please enter your TIN code (Permanent Account Number (PAN)). PAN can be found on PAN card or PAN allotment letter. Indian Income Tax Return mandatorily has the taxpayer’s PAN on it. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/India-TIN.pdf</a>`
	},
	descriptionIDN: {
		id: 'fe.tin_description_IDN',
		defaultMessage: `Please enter your TIN code. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Indonesia-TIN.pdf</a>`
	},
	descriptionIRL: {
		id: 'fe.tin_description_IRL',
		defaultMessage: `Please enter your TIN code (Personal Public Service Number (PPS No)). TIN number can be found on tax return form. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Ireland-TIN.pdf</a>`
	},
	descriptionIMN: {
		id: 'fe.tin_description_IMN',
		defaultMessage: `Please enter your TIN code (Tax Reference Number or National Insurance Number (NINO)). A Tax Reference Number can be found on any official document or letter issued by the Income Tax Division, such as an Income Tax Return or Assessment Notice. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/IOM-TIN.pdf</a>`
	},
	descriptionISR: {
		id: 'fe.tin_description_ISR',
		defaultMessage: `Please enter your TIN code (ID number). The TIN for an Individual is his ID number. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Israel-TIN.pdf</a>`
	},
	descriptionITA: {
		id: 'fe.tin_description_ITA',
		defaultMessage: `Please enter your TIN code (Codice fiscale). TIN number can be found on health card, TIN card, residence permit and ID card. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Italy-TIN.pdf</a>`
	},
	descriptionJPN: {
		id: 'fe.tin_description_JPN',
		defaultMessage: `Please enter your TIN code. For individuals TIN can be found on “the notification card” or “Individual Number Cards”. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Japan-TIN.pdf</a>`
	},
	descriptionJEY: {
		id: 'fe.tin_description_JEY',
		defaultMessage: `Please enter your TIN code. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Jersey-TIN.pdf</a>`
	},
	descriptionKAZ: {
		id: 'fe.tin_description_KAZ',
		defaultMessage: `Please enter your TIN (INN) code. TIN is a unique combination of 12 digits generated for an individual during the initial registration in the information-production system for producing documents. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Kazakhstan-TIN.pdf</a>`
	},
	descriptionKWT: {
		id: 'fe.tin_description_KWT',
		defaultMessage: `Please enter your TIN code. TIN number in Civil ID cards within 12 digits which is issued by The Public Authority for Civil Information (PACI). More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Kuwait-TIN.pdf</a>`
	},
	descriptionLVA: {
		id: 'fe.tin_description_LVA',
		defaultMessage: `Please enter your TIN code (Personas kods). TIN number can be found on passport, identification card, driving license or residence permit. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Latvia-TIN.pdf</a>`
	},
	descriptionLBN: {
		id: 'fe.tin_description_LBN',
		defaultMessage: `Please enter your TIN code. Tax identification card, registration certificate (for entities), or any other official certificate issued by the departments of the Revenue Directorate. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Lebanon-TIN.pdf</a>`
	},
	descriptionLIE: {
		id: 'fe.tin_description_LIE',
		defaultMessage: `Please enter your TIN code (PEID Nummer ‘Personenidentifikationsnummer’). TIN number can be found on recent residence permits for foreigners, cross-border worker's ID. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/LIECHTENSTEIN%20TIN.pdf</a>`
	},
	descriptionLTU: {
		id: 'fe.tin_description_LTU',
		defaultMessage: `Please enter your TIN code (asmens kodas). TIN number can be found on passport, identification card, residence permit and driving license. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Lithuania-TIN.pdf</a>`
	},
	descriptionLUX: {
		id: 'fe.tin_description_LUX',
		defaultMessage: `Please enter your TIN code (National Identification Number). TIN number can be found on social security identification card. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Luxembourg-TIN.pdf</a>`
	},
	descriptionMAC: {
		id: 'fe.tin_description_MAC',
		defaultMessage: `Please enter your TIN code. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Macao-TIN.pdf</a>`
	},
	descriptionMYS: {
		id: 'fe.tin_description_MYS',
		defaultMessage: `Please enter your TIN code (Nombor Cukai Pendapatan). Both individuals and entities who are registered taxpayers with the Inland Revenue Board of Malaysia (IRBM) are assigned with a Tax Identification Number (TIN). More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Malaysia-TIN.pdf</a>`
	},
	descriptionMLT: {
		id: 'fe.tin_description_MLT',
		defaultMessage: `Please enter your TIN code (Identity Card Number). TIN number can be found on passport, identification card or Tax Return. More information :  <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Malta-TIN.pdf</a>`
	},
	descriptionMHL: {
		id: 'fe.tin_description_MHL',
		defaultMessage: `Please enter your TIN code (MISSA). TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Marshall-Islands-TIN.pdf</a>`
	},
	descriptionMUS: {
		id: 'fe.tin_description_MUS',
		defaultMessage: `Please enter your TIN (TAN) code. The TAN is printed on all tax returns, letters and notices sent to taxpayers. All official documents issued by the MRA contain the Tax Account Number. For individuals who are employees, it is often shown on the statement of emoluments issued by their employer. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Mauritius-TIN.pdf</a>`
	},
	descriptionMEX: {
		id: 'fe.tin_description_MEX',
		defaultMessage: `Please enter your TIN code (Clave en el Registro Federal de Contribuyentes – RFC). The TIN can be found on Tax Identification Card or Certification of Tax registration or Certification of Tax situation. In Mexico there is no automatic procedure for issuing a TIN (Clave en el Registro Federal de Contribuyentes - RFC) to individuals or entities, it is the responsibility of the obliged individual or entity to register in the Federal Taxpayer Registry to obtain a TIN. If you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Mexico-TIN.pdf</a>`
	},
	descriptionMCO: {
		id: 'fe.tin_description_MCO',
		defaultMessage: `There is no TIN`
	},
	descriptionMSR: {
		id: 'fe.tin_description_MSR',
		defaultMessage: `There is no TIN`
	},
	descriptionNRU: {
		id: 'fe.tin_description_NRU',
		defaultMessage: `Please enter your TIN code. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Nauru-TIN.pdf</a>`
	},
	descriptionNLD: {
		id: 'fe.tin_description_NLD',
		defaultMessage: `Please enter your TIN code (Fiscale identificatienummer (FIN) or Burgerservicenummer (BSN)). TIN number can be found on passport or identification card (main side of the card). More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Netherlands-TIN.pdf</a>`
	},
	descriptionNZL: {
		id: 'fe.tin_description_NZL',
		defaultMessage: `Please enter your TIN code. For individuals who are employees it is often shown on payslips issued by their employer. For businesses registered for GST (Goods and Services Tax) it is shown on Tax Invoices. It is also displayed in a customer's on-line services account with Inland Revenue (myIR). A TIN is not allocated unless a specific application has been made. If you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/New%20Zealand-TIN.pdf</a>`
	},
	descriptionNGA: {
		id: 'fe.tin_description_NGA',
		defaultMessage: `Please enter your TIN code, if you do not have one, fill “NA” in the field. More information : https://tinverification.jtb.gov.ng/Template/TINVerification`
	},
	descriptionNIU: {
		id: 'fe.tin_description_NIU',
		defaultMessage: `Please enter your TIN code, if you do not have one, fill “NA” in the field. More information : https://niue.tradeportal.org/procedure/8?l=en`
	},
	descriptionNOR: {
		id: 'fe.tin_description_NOR',
		defaultMessage: `Please enter your TIN code (Fødselsnummer or D-number). TIN number can be found on passport, driver's licence or letters from tax authority (main side of the card). More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Norway-TIN.pdf</a>`
	},
	descriptionPAK: {
		id: 'fe.tin_description_PAK',
		defaultMessage: `Please enter your TIN (NTN) code. The NTN or Registration Number may be found on the first page of the Income Tax return, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Pakistan-TIN.pdf</a>`
	},
	descriptionPAN: {
		id: 'fe.tin_description_PAN',
		defaultMessage: `Please enter your TIN code (Registro Único de Contribuyente, RUC). The Single Taxpayer Registry (Registro Único de Contribuyente, RUC) is the Tax Identification Number of every Panamanian natural or legal person. The issuance of the RUC is not automatic; the taxpayer must submit an application through a registration process. If you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Panama-TIN.pdf</a>`
	},
	descriptionPOL: {
		id: 'fe.tin_description_POL',
		defaultMessage: `Please enter your TIN code (Powszechny Elektroniczny System Ewidencji Ludności (PESEL)). TIN number can be found on passport or identification card. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Poland-TIN.pdf</a>`
	},
	descriptionPRT: {
		id: 'fe.tin_description_PRT',
		defaultMessage: `Please enter your TIN code (Numero de Indentificacao Fiscal). TIN number can be found on TIN card or on identity card, citizen card (emission by the Ministry of Justice) and taxpayer card (emission by the Ministry of Finance). More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Portugal-TIN.pdf</a>`
	},
	descriptionQAT: {
		id: 'fe.tin_description_QAT',
		defaultMessage: `Please enter your TIN code. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Qatar-TIN.pdf</a>`
	},
	descriptionROU: {
		id: 'fe.tin_description_ROU',
		defaultMessage: `Please enter your TIN code (Cod Numeric Personal). TIN number can be found on passport or identification card, Certificate for Tax Registration, Residence Permit, Driving license. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Romania-TIN.pdf</a>`
	},
	descriptionRUS: {
		id: 'fe.tin_description_RUS',
		defaultMessage: `Please enter your TIN (INN) code. INN can be found from the certificate of registration of an individual or business as a taxpayer, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Russia-TIN.pdf</a>`
	},
	descriptionKNA: {
		id: 'fe.tin_description_KNA',
		defaultMessage: `Please enter your TIN code. TINs are displayed on an individual’s St. Christopher (St. Kitts) & Nevis Driver’s Licence as the first set of numbers in the Licence No. before the hyphen. In most other instances, for individuals or entities registered for tax purposes, the TIN may only be obtained from documents generated for tax and customs purposes such as payment receipts, tax assessments and customs entries. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Saint-Kitts-and-Nevis-TIN.pdf</a>`
	},
	descriptionLCA: {
		id: 'fe.tin_description_LCA',
		defaultMessage: `Please enter your TIN code. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/SaintLucia-TIN.pdf</a>`
	},
	descriptionVCT: {
		id: 'fe.tin_description_VCT',
		defaultMessage: `Please enter your TIN code. TIN is issued to any taxable person who is required to pay taxes in accordance with the Income Tax Act and the Value Added Tax Act. If you do not have TIN code, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Saint-Vincent-and-the-Grenadines-TIN.pdf</a>`
	},
	descriptionWSM: {
		id: 'fe.tin_description_WSM',
		defaultMessage: `Please enter your TIN code. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Samoa-TIN.pdf</a>`
	},
	descriptionSMR: {
		id: 'fe.tin_description_SMR',
		defaultMessage: `Please enter your TIN code (Social Security Number (SSI Number)). The Social Security Number is indicated on the front of the identity card issued by the Vital Statistics Office, next to the photo of the holder, on the right, or on the Carta Azzurra (San Marino health card). It is also indicated in the certificates of tax residency issued by the Tax Office. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/San-Marino-TIN.pdf</a>`
	},
	descriptionSAU: {
		id: 'fe.tin_description_SAU',
		defaultMessage: `Please enter your TIN code. The TIN can be found on VAT Certificates and invoices. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Saudi-Arabia-TIN.pdf</a>`
	},
	descriptionSYC: {
		id: 'fe.tin_description_SYC',
		defaultMessage: `Please enter your TIN code. Any documents produced Seychelles Revenue Commission will have a space dedicated to the TIN. If you do not have TIN code, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Seychelles-TIN.pdf</a>`
	},
	descriptionSGP: {
		id: 'fe.tin_description_SGP',
		defaultMessage: `Please enter your TIN (NRIC or FIN) code. NRIC Number: This is for Singapore Citizens or Permanent Residents of Singapore. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Singapore-TIN.pdf</a>`
	},
	descriptionSXM: {
		id: 'fe.tin_description_SXM',
		defaultMessage: `Please enter your TIN code. The tax identification number can be issued to all individuals with a tax obligation. The tax identification is issued at the time of registration of the individual in the tax administrations database. If you do not have TIN code, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Sint-Maarten-TIN.pdf</a>`
	},
	descriptionSVK: {
		id: 'fe.tin_description_SVK',
		defaultMessage: `Please enter your TIN code (SI tax number (SI-TIN)). TIN number can be found on passport or identification card. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Slovak-Republic-TIN.pdf</a>`
	},
	descriptionSVN: {
		id: 'fe.tin_description_SVN',
		defaultMessage: `Please enter your TIN code (Davčna številka). TIN number can be found on certificate about the entry into the tax register, certificate of residence. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Slovenia-TIN.pdf</a>`
	},
	descriptionZAF: {
		id: 'fe.tin_description_ZAF',
		defaultMessage: `Please enter your TIN code (Taxpayer reference number). The TIN is used in almost all correspondence between SARS and the taxpayer as well as in prescribed documents such as: returns (Form IT 12 – individuals assessments (Form IT34 audit correspondence, notices of objection & appeal (Form NOO & NOA) and related dispute correspondence. If you do not have TIN code, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/South-Africa-TIN.pdf</a>`
	},
	descriptionKOR: {
		id: 'fe.tin_description_KOR',
		defaultMessage: `Please enter your TIN code (주민등록번호 or Resident Registration Number). The TIN can be found in the resident registration cards and in the photo page of passports. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Korea-TIN.pdf</a>`
	},
	descriptionESP: {
		id: 'fe.tin_description_ESP',
		defaultMessage: `Please enter your TIN code (Documento nacional de identidad número (DNI) or Número de identidad de extranjero (NIE)). TIN number can be found on identity card, residence permit, driving licence, taxpayer identitifaction card or social security card. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/SPAIN-TIN.pdf</a>`
	},
	descriptionSWE: {
		id: 'fe.tin_description_SWE',
		defaultMessage: `Please enter your TIN code (Personnummer). TIN number can be found on passport or identification card.  More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Sweden-TIN.pdf</a>`
	},
	descriptionCHE: {
		id: 'fe.tin_description_CHE',
		defaultMessage: `Please enter your TIN code (Unternehmens-Identifikationsnummer (UID)). TIN number for individuals can be found on official insurance certificate. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Switzerland-TIN.pdf</a>`
	},
	descriptionTTO: {
		id: 'fe.tin_description_TTO',
		defaultMessage: `Please enter your TIN code. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Trinidad-and-Tobago-TIN.pdf</a>`
	},
	descriptionTUR: {
		id: 'fe.tin_description_TUR',
		defaultMessage: `Please enter your TIN code. IN can be found on almost all the financial statements and declarations of taxpayer and notifications issued by the tax administration to the taxpayer in addition to TIN cards. Since individuals use the National Identity Number as TIN, this information can be found on National Identity Cards and passports. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Turkey-TIN.pdf</a>`
	},
	descriptionTCA: {
		id: 'fe.tin_description_TCA ',
		defaultMessage: `There is no TIN`
	},
	descriptionARE: {
		id: 'fe.tin_description_ARE',
		defaultMessage: `Please enter your TIN code. TIN is not issued automatically, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/UAE-TIN.pdf</a>`
	},
	descriptionGBR: {
		id: 'fe.tin_description_GBR',
		defaultMessage: `Please enter your TIN code (The unique taxpayer reference (UTR) or National Insurance Number (NINO)). Unique Taxpayer Reference (UTR) can be found on tax return form, National Insurance Number (NINO) can be found on coding notice to taxpayer, national insurance card and on letters issued by the Department for Work and Pensions. The number also appears on employee's pay slip and on a Statement of Account issued by HMRC. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/UK-TIN.pdf</a>`
	},
	descriptionURY: {
		id: 'fe.tin_description_URY',
		defaultMessage: `Please enter your TIN (RUT) code. TIN number can be found on passport or identification card. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Uruguay-TIN.pdf</a>`
	},
	descriptionVUT: {
		id: 'fe.tin_description_VUT',
		defaultMessage: `Please enter your TIN code. Persons needs to apply for TIN, if you do not have one, fill “NA” in the field. More information : <a>https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Vanuatu-TIN.pdf</a>`
	},
	pleaseEnterTin: {
		id: 'fe.please_enter_tin',
		defaultMessage: `Please enter your tax identification number`
	},
	nameAND: {
		id: 'fe.tin_name_AND',
		defaultMessage: `Número de Registre Tributari`
	},
	nameATG: {
		id: 'fe.tin_name_ATG',
		defaultMessage: `PIN
		`
	},
	nameARG: {
		id: 'fe.tin_name_ARG',
		defaultMessage: `C.U.I.T - Clave Única de Identificación Tributaria`
	},
	nameAUT: {
		id: 'fe.tin_name_AUT',
		defaultMessage: `Abgabenkontonummer`
	},
	nameAZE: {
		id: 'fe.tin_name_AZE',
		defaultMessage: `PIN`
	},
	nameBEL: {
		id: 'fe.tin_name_BEL',
		defaultMessage: `Numéro National (NN)`
	},
	nameBRA: {
		id: 'fe.tin_name_BRA',
		defaultMessage: `CPF (individuals) or CNPJ (legal persons)`
	},
	nameBRN: {
		id: 'fe.tin_name_BRN',
		defaultMessage: `NRIC Number`
	},
	nameBGR: {
		id: 'fe.tin_name_BGR',
		defaultMessage: `Единен граждански номер`
	},
	nameCHL: {
		id: 'fe.tin_name_CHL',
		defaultMessage: `RUT`
	},
	nameCOL: {
		id: 'fe.tin_name_COL',
		defaultMessage: `RUT`
	},
	nameCRI: {
		id: 'fe.tin_name_CRI',
		defaultMessage: `PIN`
	},
	nameHRV: {
		id: 'fe.tin_name_HRV',
		defaultMessage: `Osobni identifikacijski broj `
	},
	nameCYP: {
		id: 'fe.tin_name_CYP',
		defaultMessage: `ΑΡΙΘΜΟΙ ΦΟΡΟΛΟΓΙΚΗΣ ΤΑΥΤΟΠΟΙΗΣΗΣ (ΑΦΤ)`
	},
	nameCZE: {
		id: 'fe.tin_name_CZE',
		defaultMessage: `Rodné číslo`
	},
	nameDNK: {
		id: 'fe.tin_name_DNK',
		defaultMessage: `CPR-nummer or personnummer`
	},
	nameEST: {
		id: 'fe.tin_name_EST',
		defaultMessage: `Isikukood`
	},
	nameFRO: {
		id: 'fe.tin_name_FRO',
		defaultMessage: `Faroese P Number`
	},
	nameFIN: {
		id: 'fe.tin_name_FIN',
		defaultMessage: `Veronumero`
	},
	nameFRA: {
		id: 'fe.tin_name_FRA',
		defaultMessage: `Numéro fiscal de référence or numéro SPI`
	},
	nameDEU: {
		id: 'fe.tin_name_DEU',
		defaultMessage: `Die steuerliche Identifikationsnummer`
	},
	nameGIB: {
		id: 'fe.tin_name_GIB',
		defaultMessage: `Taxpayer reference number`
	},
	nameGRC: {
		id: 'fe.tin_name_GRC',
		defaultMessage: `ΑΡΙΘΜΟΙ ΦΟΡΟΛΟΓΙΚΗΣ ΤΑΥΤΟΠΟΙΗΣΗΣ (ΑΦΤ) // CPR number`
	},
	nameGRL: {
		id: 'fe.tin_name_GRL',
		defaultMessage: `In Greenland the TIN equals the CPR number for all natural persons and equals the GER number for all non-natural persons/companies etc.`
	},
	nameGGY: {
		id: 'fe.tin_name_GGY',
		defaultMessage: `Guernsey Social security number or UK National Insurance Number (NINO) or Jersey SocialSecurity Number`
	},
	nameHKG: {
		id: 'fe.tin_name_HKG',
		defaultMessage: `HKID`
	},
	nameHUN: {
		id: 'fe.tin_name_HUN',
		defaultMessage: `Adóazonosító jel`
	},
	nameISL: {
		id: 'fe.tin_name_ISL',
		defaultMessage: `Kennitala`
	},
	nameIND: {
		id: 'fe.tin_name_IND',
		defaultMessage: `Permanent Account Number (PAN)`
	},
	nameIRL: {
		id: 'fe.tin_name_IRL',
		defaultMessage: `Personal Public Service Number (PPS No)`
	},
	nameIMN: {
		id: 'fe.tin_name_IMN',
		defaultMessage: `Tax Reference Number or National Insurance Number (NINO)`
	},
	nameISR: {
		id: 'fe.tin_name_ISR',
		defaultMessage: `Tax Identification Number on ID Card + Passport (document number)`
	},
	nameITA: {
		id: 'fe.tin_name_ITA',
		defaultMessage: `Codice fiscale`
	},
	nameJEY: {
		id: 'fe.tin_name_JEY',
		defaultMessage: `Tax Reference Numbers Or Tax Identification Number`
	},
	nameKAZ: {
		id: 'fe.tin_name_KAZ',
		defaultMessage: `IIN`
	},
	nameLVA: {
		id: 'fe.tin_name_LVA',
		defaultMessage: `Personas kods`
	},
	nameLIE: {
		id: 'fe.tin_name_LIE',
		defaultMessage: `PEID Nummer ‘Personenidentifikationsnummer’`
	},
	nameLTU: {
		id: 'fe.tin_name_LTU',
		defaultMessage: `Asmens kodas`
	},
	nameLUX: {
		id: 'fe.tin_name_LUX',
		defaultMessage: `National Identification Number`
	},
	nameMYS: {
		id: 'fe.tin_name_MYS',
		defaultMessage: `Nombor Cukai Pendapatan`
	},
	nameMLT: {
		id: 'fe.tin_name_MLT',
		defaultMessage: `Identity Card Number`
	},
	nameMHL: {
		id: 'fe.tin_name_MHL',
		defaultMessage: `MISSA`
	},
	nameMUS: {
		id: 'fe.tin_name_MUS',
		defaultMessage: `TAN`
	},
	nameMEX: {
		id: 'fe.tin_name_MEX',
		defaultMessage: `Clave en el Registro Federal de Contribuyentes - RFC`
	},
	nameMCO: {
		id: 'fe.tin_name_MCO',
		defaultMessage: `Numéro d’identification fiscal`
	},
	nameNLD: {
		id: 'fe.tin_name_NLD',
		defaultMessage: `Fiscale identificatienummer (FIN) or Burgerservicenummer (BSN)`
	},
	nameNOR: {
		id: 'fe.tin_name_NOR',
		defaultMessage: `Fødselsnummer////TIN IS NOT ON THE MAIN PAGE OF PASSPORT`
	},
	namePAK: {
		id: 'fe.tin_name_PAK',
		defaultMessage: ` NTN`
	},
	namePAN: {
		id: 'fe.tin_name_PAN',
		defaultMessage: `Registro Único de Contribuyente, RUC`
	},
	namePOL: {
		id: 'fe.tin_name_POL',
		defaultMessage: `Powszechny Elektroniczny System Ewidencji Ludności (PESEL)`
	},
	namePRT: {
		id: 'fe.tin_name_PRT',
		defaultMessage: `Numero de Indentificacao Fiscal`
	},
	nameROU: {
		id: 'fe.tin_name_ROU',
		defaultMessage: `Cod Numeric Personal`
	},
	nameRUS: {
		id: 'fe.tin_name_RUS',
		defaultMessage: `INN`
	},
	nameSMR: {
		id: 'fe.tin_name_SMR',
		defaultMessage: `Social Security Number (SSI Number)`
	},
	nameSYC: {
		id: 'fe.tin_name_SYC',
		defaultMessage: `Tax Identification Number`
	},
	nameSGP: {
		id: 'fe.tin_name_SGP',
		defaultMessage: `NRIC/FIN (who work or resides)`
	},
	nameSVK: {
		id: 'fe.tin_name_SVK',
		defaultMessage: `SI tax number (SI-TIN)`
	},
	nameSVN: {
		id: 'fe.tin_name_SVN',
		defaultMessage: `Davčna številka`
	},
	nameZAF: {
		id: 'fe.tin_name_ZAF',
		defaultMessage: `Taxpayer reference number`
	},
	nameKOR: {
		id: 'fe.tin_name_KOR',
		defaultMessage: `주민등록번호 or Resident Registration Number`
	},
	nameESP: {
		id: 'fe.tin_name_ESP',
		defaultMessage: `Documento nacional de identidad número (DNI) or Número de identidad de extranjero (NIE)`
	},
	nameSWE: {
		id: 'fe.tin_name_SWE',
		defaultMessage: `Personnummer`
	},
	nameCHE: {
		id: 'fe.tin_name_CHE',
		defaultMessage: `Unternehmens-Identifikationsnummer (UID)`
	},
	nameGBR: {
		id: 'fe.tin_name_GBR',
		defaultMessage: `The unique taxpayer reference (UTR) or National Insurance Number (NINO)`
	},
	nameURY: {
		id: 'fe.tin_name_URY',
		defaultMessage: `Acronym in Spanish RUT.`
	},
	traceIdWithId: {
		id: 'fe.trace_id_with_id',
		defaultMessage: `Id: {traceId}`
	},
	tryAnotherDevice: {
		id: 'fe.you_may_also_try_with_another_device_scan_qr',
		defaultMessage:
			'You may also try the proceedure with another device by scaning this QR code.'
	},
	fileWasRemoved: {
		id: 'fe.file_was_removed',
		defaultMessage: 'File was removed due to possible malware'
	},
	weCouldntFindAnEntity: {
		id: 'fe.we_could_not_find_an_entity_registered',
		defaultMessage: "We couldn't find an entity registered."
	},
	pendingForScan: {
		id: 'fe.pending_for_malware_scan',
		defaultMessage: 'Pending for malware scan'
	},
	verificationLink: {
		id: 'fe.verification_link',
		defaultMessage: 'Verification link'
	},
	statusOfRelatedVerifications: {
		id: 'fe.status_of_related_verifications',
		defaultMessage: 'Status of related verifications:'
	},
	new: {
		id: 'fe.new',
		defaultMessage: 'New'
	},
	underReview: {
		id: 'fe.under_review',
		defaultMessage: 'Under review'
	},
	onboarded: {
		id: 'fe.onboarded',
		defaultMessage: 'Onboarded'
	},
	inProgress: {
		id: 'fe.in_progress',
		defaultMessage: 'In progress'
	},
	rejected: {
		id: 'fe.rejected',
		defaultMessage: 'Rejected'
	},
	expired: {
		id: 'fe.expired',
		defaultMessage: 'Expired'
	},
	unknown: {
		id: 'fe.unknown',
		defaultMessage: 'Unknown'
	},
	applicationPayment: {
		id: 'fe.application_payment',
		defaultMessage: 'Application payment'
	},
	applicationNotPaid: {
		id: 'fe.application_not_paid',
		defaultMessage: 'Application not paid'
	},
	applicationPaymentIsPending: {
		id: 'fe.application_payment_is_pending',
		defaultMessage: 'Application payment is pending'
	},
	applicationPaid: {
		id: 'fe.application_paid',
		defaultMessage: 'Application paid'
	},
	ifYouHaveAlreadyPaid: {
		id: 'fe.if_you_have_already_paid',
		defaultMessage: 'If you have already paid, it might take time for our system to reflect it.'
	},
	weHaveReceivedYourPayment: {
		id: 'fe.we_have_received_your_payment',
		defaultMessage:
			'We have received your payment, our team will get in touch with you shortly.'
	},
	currency: {
		id: 'fe.currency',
		defaultMessage: 'Currency'
	},
	applyDiscountVoucher: {
		id: 'fe.apply_discount_voucher',
		defaultMessage: 'Apply discount voucher'
	},
	apply: {
		id: 'fe.apply',
		defaultMessage: 'Apply'
	},
	discountApplied: {
		id: 'fe.discount_applied',
		defaultMessage: 'Discount applied'
	},
	voucherHasAlreadyBeenApplied: {
		id: 'fe.voucher_has_already_been_applied',
		defaultMessage: 'Voucher has already been applied'
	},
	appliedVouchers: {
		id: 'fe.applied_vouchers',
		defaultMessage: 'Applied vouchers'
	},
	failedToRemoveTheVoucher: {
		id: 'fe.failed_to_remove_the_voucher',
		defaultMessage: 'Failed to remove the voucher'
	},
	failedToApplyVoucher: {
		id: 'fe.failed_to_apply_voucher',
		defaultMessage: 'Failed to apply voucher'
	},
	voucherIsNotUsable: {
		id: 'fe.voucher_is_not_usable',
		defaultMessage: 'Voucher is not usable'
	},
	wrongFeeStatusForVoucherUse: {
		id: 'fe.wrong_fee_status_for_voucher_use',
		defaultMessage: 'Wrong fee status for voucher use'
	},
	voucherCodeIsNotValid: {
		id: 'fe.voucher_code_is_not_valid',
		defaultMessage: 'Voucher code is not valid'
	},
	voucherCurrencyMismatch: {
		id: 'fe.voucher_currency_mismatch',
		defaultMessage: 'Voucher currency mismatch'
	},
	priorityFee: {
		id: 'fe.priority_fee',
		defaultMessage: 'Priority fee'
	},
	applicationFee: {
		id: 'fe.application_fee',
		defaultMessage: 'Application fee'
	},
	discount: {
		id: 'fe.discount',
		defaultMessage: 'Discount'
	},
	totalPaidAmount: {
		id: 'fe.total_paid_amount',
		defaultMessage: 'Total paid amount'
	},
	totalAmount: {
		id: 'fe.total_amount',
		defaultMessage: 'Total amount'
	},
	payByBankWire: {
		id: 'fe.pay_by_bank_wire',
		defaultMessage: 'Pay by bank wire'
	},
	payByCrypto: {
		id: 'fe.pay_by_crypto',
		defaultMessage: 'Pay by crypto'
	},
	payWithBankera: {
		id: 'fe.pay_with_bankera',
		defaultMessage: 'Pay with Bankera'
	},
	selectPaymentMethod: {
		id: 'fe.select_payment_method',
		defaultMessage: 'Select payment method'
	},
	paymentAmount: {
		id: 'fe.payment_amount',
		defaultMessage: 'Payment amount'
	},
	sepa: {
		id: 'fe.sepa',
		defaultMessage: 'SEPA'
	},
	swift: {
		id: 'fe.swift',
		defaultMessage: 'SWIFT'
	},
	singleEuroPaymentsArea: {
		id: 'fe.single_euro_payments_area',
		defaultMessage: 'Single Euro Payments Area'
	},
	internationalPayments: {
		id: 'fe.international_payments',
		defaultMessage: 'International payments'
	},
	sepaPaymentDetails: {
		id: 'fe.sepa_payment_details',
		defaultMessage: 'SEPA payment details'
	},
	swiftPaymentDetails: {
		id: 'fe.swift_payment_details',
		defaultMessage: 'SWIFT payment details'
	},
	copyAll: {
		id: 'fe.copy_all',
		defaultMessage: 'Copy all'
	},
	receiver: {
		id: 'fe.receiver',
		defaultMessage: 'Receiver'
	},
	bankAccountNumber: {
		id: 'fe.bank_account_number',
		defaultMessage: 'Bank account number (IBAN)'
	},
	bankName: {
		id: 'fe.bank_name',
		defaultMessage: 'Bank name'
	},
	bankIdentificationCode: {
		id: 'fe.bank_identification_code',
		defaultMessage: 'Bank identification code (BIC/SWIFT)'
	},
	referenceCodePrefixText: {
		id: 'fe.reference_code_prefix_text_optional',
		defaultMessage: 'Text in front of reference code'
	},
	bankAddress: {
		id: 'fe.bank_address',
		defaultMessage: 'Bank address'
	},
	correspondentBankName: {
		id: 'fe.correspondent_bank_name',
		defaultMessage: 'Correspondent bank name'
	},
	correspondentBankIdentificationCode: {
		id: 'fe.correspondent_bank_identification_code',
		defaultMessage: 'Correspondent bank identification code (BIC/SWIFT)'
	},
	correspondentBankAddress: {
		id: 'fe.correspondent_bank_address',
		defaultMessage: 'Correspondent bank address'
	},
	referenceCode: {
		id: 'fe.reference_code',
		defaultMessage: 'Reference code'
	},
	pleaseContinueOn: {
		id: 'fe.please_continue_on',
		defaultMessage: 'Please continue on:'
	}
});

export default messages;
